import { NativeDateAdapter, MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { formatCurrency, CommonModule, CurrencyPipe } from '@angular/common';
import { createAction, props, Store } from '@ngrx/store';
import { __decorate, __param, __rest } from 'tslib';
import { ElementRef, Input, HostListener, Directive, NgModule, Inject, ViewChild, Component, Injectable, EventEmitter, Output, forwardRef, Pipe, HostBinding, ChangeDetectorRef, Optional, ViewContainerRef, Renderer2, ViewChildren, ComponentFactoryResolver, QueryList, ContentChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { tap, takeUntil, filter, map } from 'rxjs/operators';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule, FormGroup, FormControl, Validators, FormsModule, NG_VALIDATORS, FormBuilder, NgControl, FormArray } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import moment from 'moment';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DrawerRailModule } from 'angular-material-rail-drawer';
import { MatToolbarModule } from '@angular/material/toolbar';
import { QRCodeModule } from 'angularx-qrcode';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { Subject } from 'rxjs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTab, MatTabGroup, MatTabsModule } from '@angular/material/tabs';

class CustomDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek() {
        return 1;
    }
}

const creditCardTypes = [
    'ATTIVA',
    'NON ATTIVA'
];

const channelTypes = [
    'NEXI',
    'STRIPE'
];

const gatewayStates = [
    'ATTIVO',
    'IN ATTIVAZIONE'
];

const paymentInvoiceState = [
    'NON MIGRATA',
    'DA GENERARE',
    'DISPONIBILE',
    'NON GENERARE'
];

const serviceTypes = [
    'Base',
    'API',
    'E-Commerce',
    'Link2Pay',
    'Link2PayB2B',
    'Link2PayPro',
    'Open',
    'OpenPro',
    'U-Comm',
    'Advanced',
    'MKPL',
    'Smart'
];

const ticketAreas = [
    'SUPPORT - AREA TECNICA',
    'SUPPORT - AREA CONTABILE',
    'SUPPORT - AREA VENDITA',
    'SUPPORT - SEGRETERIA'
];

const openDialog = createAction('[Loader] Open Dialog', props());
const closeDialog = createAction('[Loader] Close Dialog');

function dateToYMD(date) {
    let month = String(date.getMonth() + 1);
    let day = String(date.getDate());
    const year = String(date.getFullYear());
    const twoLengthString = 2;
    if (month.length < twoLengthString) {
        month = `0${month}`;
    }
    if (day.length < twoLengthString) {
        day = `0${day}`;
    }
    return [year, month, day].join('-');
}
function dateToDMY(date) {
    let month = String(date.getMonth() + 1);
    let day = String(date.getDate());
    const year = String(date.getFullYear());
    const twoLengthString = 2;
    if (month.length < twoLengthString) {
        month = `0${month}`;
    }
    if (day.length < twoLengthString) {
        day = `0${day}`;
    }
    return [day, month, year].join('/');
}
function dateToMDY(date) {
    let month = String(date.getMonth() + 1);
    let day = String(date.getDate());
    const year = String(date.getFullYear());
    const twoLengthString = 2;
    if (month.length < twoLengthString) {
        month = `0${month}`;
    }
    if (day.length < twoLengthString) {
        day = `0${day}`;
    }
    return [month, day, year].join('/');
}
function extendedDateMonth(date, translator) {
    const monthMap = {
        0: 'JAN',
        1: 'FEB',
        2: 'MAR',
        3: 'APR',
        4: 'MAY',
        5: 'JUN',
        6: 'JUL',
        7: 'AUG',
        8: 'SEP',
        9: 'OCT',
        10: 'NOV',
        11: 'DEC'
    };
    return translator.instant(`UI_LIB.DATE.${monthMap[date.getMonth()]}`);
}
function formatAmount(value, translateService) {
    if (value !== 0 && !value || !translateService) {
        return '';
    }
    const currentLocale = translateService.getBrowserCultureLang();
    if (value && value !== 0 && value !== Infinity) {
        return formatCurrency(value, currentLocale, '€', 'EUR', '1.2-2').trim();
    }
    return formatCurrency(0, currentLocale, '€', 'EUR', '1.2-2').trim();
}
function returnTicketTypeById(ticketTypeId) {
    switch (ticketTypeId) {
        case 3:
            return 'REQUEST_SUPPORT.SUPP_TECNIC_AREA';
        case 4:
            return 'REQUEST_SUPPORT.SUPP_ACCOUNTING_AREA';
        case 5:
            return 'REQUEST_SUPPORT.SUPP_SELLING_AREA';
        case 6:
            return 'REQUEST_SUPPORT.SUPP_REGISTRY';
        default:
            return `${ticketTypeId}`;
    }
}
function returnTicketTypeByString(ticketTypeId) {
    const ticketMap = {
        'REQUEST_SUPPORT.SUPP_ACCOUNTING_AREA': 4,
        'REQUEST_SUPPORT.SUPP_REGISTRY': 6,
        'REQUEST_SUPPORT.SUPP_SELLING_AREA': 5,
        'REQUEST_SUPPORT.SUPP_TECNIC_AREA': 3,
    };
    return ticketMap[ticketTypeId];
}
function returnServiceTypeString(serviceType) {
    var _a;
    const serviceMap = {
        'Base': 1,
        'Advanced': 2,
        'Open': 3,
        'OpenPro': 4,
        'E-Commerce': 5,
        'Link2Pay': 6,
        'U-Comm': 7,
        'Link2PayPro': 8,
        'Link2PayB2B': 9,
        'API': 10,
        'MKPL': 13,
        'Smart': 14
    };
    return _a = serviceMap[serviceType], (_a !== null && _a !== void 0 ? _a : -1);
}
function returnServiceTypeNumber(serviceType) {
    var _a;
    const serviceMap = {
        1: 'Base',
        2: 'Advanced',
        3: 'Open',
        4: 'OpenPro',
        5: 'E-Commerce',
        6: 'Link2Pay',
        7: 'U-Comm',
        8: 'Link2PayPro',
        9: 'Link2PayB2B',
        10: 'API',
        13: 'MKPL',
        14: 'Smart'
    };
    return _a = serviceMap[serviceType], (_a !== null && _a !== void 0 ? _a : `${serviceType}`);
}
function convertNumberForFilter(value) {
    if (!!value) {
        if (value.includes(',')) {
            return value.replace(/,/g, '.');
        }
        else {
            return value + '.00';
        }
    }
    else {
        return undefined;
    }
}
function addMonthsToDate(date, months) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() !== d) {
        date.setDate(0);
    }
    return date;
}
function firstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
function lastDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
function dateMonthDifference(d1, d2) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}
function returnNextMonthDate(date) {
    return date.getMonth() === 11
        ? new Date(date.getFullYear() + 1, 0, date.getDate())
        : new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
}
function returnFirstDayNextMonth(date) {
    return date.getMonth() === 11
        ? new Date(date.getFullYear() + 1, 0)
        : new Date(date.getFullYear(), date.getMonth() + 1);
}
function calculateRateValue(totalInstallments, totalAmount) {
    return Math.floor(totalAmount / totalInstallments * 100) / 100;
}
function calculateLastRateValue(totalInstallments, totalAmount) {
    const singleRateValue = Math.floor(totalAmount / totalInstallments * 100) / 100;
    return totalAmount !== singleRateValue * totalInstallments
        ? singleRateValue + (totalAmount - (singleRateValue * totalInstallments))
        : singleRateValue;
}
function roundNumber(val) {
    return Math.floor(val * 100) / 100;
}
function retrieveNotificationTranslation(template) {
    const templateMap = {
        'app.creditCard.expiry': 'CREDITCARD_EXPIRY',
        'app.file.delete': 'FILE_DELETE',
        'app.localUnity.changeName': 'LOCALUNITY_CHANGENAME',
        'app.market.externalpayment.reinstall': 'EXTERNAL_PAYMENT_REINSTALL',
        'app.market.externalpayment': 'EXTERNAL_PAYMENT',
        'app.market.gateway.infochanged': 'GATEWAY_INFO_CHANGED',
        'app.market.rateListRelaunch': 'RATE_LIST_RELAUCH',
        'app.market.useradd': 'USER_ADD',
        'app.market.userchangestatus': 'USER_CHANGES_STATUS',
        'app.merchant.activationSuccess': 'MERCHANT_ACTIVATION_SUCCESS',
        'app.merchant.closeClient': 'MERCHANT_CLOSE_CLIENT',
        'app.merchant.creditCard': 'MERCHANT_CREDITCARD',
        'app.merchant.firstactivationpayment.incash': 'FIRST_ACTIVATION_PAYMENT_INCASH',
        'app.merchant.firstactivationpayment': 'FIRST_ACTIVATION_PAYMENT_WITHCARD',
        'app.merchant.infochanged': 'MERCHANT_INFO_CHANGED',
        'app.merchant.newClient': 'MERCHANT_NEW_CLIENT',
        'app.merchant.nexiCode': 'MERCHANT_NEXICODE',
        'app.merchant.posadd': 'POS_ADD',
        'app.merchant.sell': 'MERCHANT_SELL',
        'app.merhcant.changePass': 'MERCHANT_CHANGE_PASS',
        'app.payment.deleted': 'PAYMENT_DELETED',
        'app.payment.error': 'PAYMENT_ERROR',
        'app.payment.incash': 'PAYMENT_IN_CASH',
        'app.payment.insolvent': 'PAYMENT_INSOLVENT',
        'app.rata.error': 'RATA_ERROR',
        'app.rata.success': 'RATA_SUCCESS',
        'app.rate.raise': 'RATA_RAISE',
        'app.recurrentpayment.report': 'RECURRING_PAYMENT_REPORT',
        'app.service.activated': 'SERVICE_ACTIVATED',
        'app.service.failed': 'SERVICE_FAILED',
        'app.support.externalpayment': 'EXTERNAL_PAYMENT',
        'app.support.firstactivationpayment.incash': 'FIRST_ACTIVATION_PAYMENT_INCASH',
        'app.support.firstactivationpayment': 'FIRST_ACTIVATION_PAYMENT_WITHCARD',
        'app.support.sddactivationpayment': 'SDD_ACTIVATION_PAYMENT',
        'app.support.gateway.infochanged': 'GATEWAY_INFO_CHANGED',
        'app.support.merchant.changedcreditCard': 'MERCHANT_CREDITCARD_CHANGED',
        'app.support.merchant.infochanged': 'MERCHANT_INFO_CHANGED',
        'app.support.posadd': 'POS_ADD',
        'app.support.service.activated.incash': 'SERVICES_ACTIVATED_INCASH',
        'app.support.service.activated': 'SERVICES_ACTIVATED_WITHCARD',
        'app.ticket.closed': 'TICKET_CLOSED',
        'app.ticket.new': 'TICKET_NEW',
        'app.ticket.newmessage': 'TICKET_NEW_MESSAGE',
        'app.ticket.status': 'TICKET_STATUS',
    };
    if (!templateMap[template]) {
        console.warn(`[NOTIFICATIONS] Missing translation template for: ${template}`);
    }
    return `SHARED.NOTIFICATION.${templateMap[template]}`;
}
function retrieveRouteId(currentRoute) {
    return +currentRoute.snapshot.paramMap.get('id');
}
function retrieveRouteParam(currenRoute, param) {
    return +currenRoute.snapshot.paramMap.get(param);
}
function retrieveRouteQueryParam(currenRoute, param) {
    return currenRoute.snapshot.queryParamMap.get(param);
}
function rateLabelById(rateId, translator) {
    const labelsMap = {
        1: 'UI_LIB.RATES.RATA_1',
        2: 'UI_LIB.RATES.RATA_SUCCESSIVA',
        3: 'UI_LIB.RATES.RATA_UNICA',
        4: 'UI_LIB.RATES.RATA_0',
        5: 'UI_LIB.RATES.TOKEN',
        6: 'UI_LIB.RATES.RATA_CONGUAGLIO'
    };
    return labelsMap[rateId] ? translator.instant(labelsMap[rateId]) : '';
}
function objectToQueryParams(values) {
    return values ? Object.entries(values).map(([key, val]) => `${key}=${val}`).join('&') : '';
}
function generateLocalUnits(localUnits) {
    return localUnits.map(localUnit => ({
        address: localUnit.address,
        city: localUnit.city,
        flagSelected: false,
        id: localUnit.id,
        label: localUnit.label,
        name: localUnit.name,
        province: localUnit.province,
        signboard: localUnit.signboard,
        startDate: !!localUnit.dateStart ? new Date(localUnit.dateStart) : undefined,
        state: localUnit.state,
        stopDate: !!localUnit.dateStop ? new Date(localUnit.dateStop) : undefined,
    }));
}
function openDialogForSendEmail(callback) {
    return openDialog({
        dialogData: {
            title: 'UI_LIB.DIALOG.DIALOG_ALERT_TITLE',
            message: ['UI_LIB.DIALOG.SEND_REPORT_VIA_EMAIL'],
            buttons: [{
                    label: 'UI_LIB.DIALOG.CLOSE',
                    icon: '',
                    callback
                }],
            flagWarningDialog: true,
        },
    });
}
function downloadDocument(pdfFile, fileName, document) {
    const pdf = atob(pdfFile);
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}
function creditCardExpiresInMonths(data) {
    return data
        ? dateMonthDifference(new Date(), new Date(`${data.month + 1}/20/${data.year}`))
        : 0;
}

const date = new Date();
const dates = {
    endOfCurrentMonth: dateToYMD(new Date(date.getFullYear(), date.getMonth() + 1, 0)),
    endOfCurrentMonthPreviousYear: dateToYMD(new Date(date.getFullYear() - 1, date.getMonth() + 1, 0)),
    endOfPreviousMonth: dateToYMD(new Date(date.getFullYear(), date.getMonth(), 0)),
    endOfPreviousMonthPreviousYear: dateToYMD(new Date(date.getFullYear() - 1, date.getMonth(), 0)),
    startOfCurrentMonth: dateToYMD(new Date(date.getFullYear(), date.getMonth(), 1)),
    startOfCurrentMonthPreviousYear: dateToYMD(new Date(date.getFullYear() - 1, date.getMonth(), 1)),
    startOfPreviousMonth: dateToYMD(new Date(date.getFullYear(), date.getMonth() - 1, 1)),
    startOfPreviousMonthPreviousYear: dateToYMD(new Date(date.getFullYear() - 1, date.getMonth() - 1, 1))
};
const LABELS = {
    ACTIVATING: 'In attivazione',
    ACTIVE: 'Attivi',
    CONCLUDED: 'Conclusi',
    CURRENT_MONTH_INSOLVENT: 'Insolventi mese corrente',
    CURRENT_MONTH_RECEIPTS: 'Incassi mese corrente',
    CURRENT_MONTH: 'Mese corrente',
    EXPIRING_CANONS: 'Canoni in scadenza',
    EXPIRING_MERCHANTS_WITH_RENEW: 'Merchant in scadenza con rinnovo',
    EXPIRING_MERCHANTS: 'Merchant in scadenza',
    EXPIRING_SERVICES_WITH_RENEW: 'Servizi in scadenza con rinnovo',
    EXPIRING_SERVICES: 'Servizi in scadenza',
    EXPIRING_SUBSCRIPTIONS: 'Sottoscrizioni in scadenza',
    HISTORICAL_PAYMENTS: 'Storico incassi',
    INSOLVENT: 'Insolventi',
    LAST_12_MONTH: 'Ultimi 12 mesi',
    MERCHANT_DETAILS: 'Dettaglio Merchant',
    MERCHANT_STATUS: 'Stati Merchant',
    NEW_ACTIVATIONS_CURRENT_MONTH: 'Nuove attivazioni mese corrente',
    NEXT_MONTH: 'Prossimo mese',
    NEXT_YEAR: 'Prossimo anno',
    OPERATIVE: 'Operativi',
    PREVIOUS_MONTH_PREVIOUS_YEAR: 'Mese precedente anno precedente',
    PREVIOUS_MONTH: 'Mese precedente',
    RECEIPTS_PREVISION: 'Previsionale incassi',
    SAME_MONTH_PREVIOUS_YEAR: 'Stesso mese anno precedente',
    STANDBY: 'Standby',
    DEACTIVE: 'Disattivato'
};
/**
 * Return the card data for dashboard.
 * @param env The environment, market or support.
 * @param data The dashboard data.
 */
function retrieveCardData(env, data, options, translateService) {
    return [
        ...retrieveCommonCardData(data, env, options, translateService),
        ...env === 'market'
            ? retrieveMarketCardData(data)
            : retrieveSupportCardData(data)
    ];
}
/**
 * Return the common card data.
 * @param data The dashboard data.
 */
const retrieveCommonCardData = (data, env, options, translateService) => [
    {
        title: LABELS.HISTORICAL_PAYMENTS,
        dataRows: [
            {
                prefix: LABELS.PREVIOUS_MONTH,
                data: formatAmount(data.collectionAmounts.lastMonthAmount, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: {
                        state: 'PAGATO',
                        dateTransactionStart: dates.startOfPreviousMonth,
                        dateTransactionEnd: dates.endOfPreviousMonth
                    }
                }
            },
            {
                prefix: LABELS.PREVIOUS_MONTH_PREVIOUS_YEAR,
                data: formatAmount(data.collectionAmounts.lastMonthLastYearAmount, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: {
                        state: 'PAGATO',
                        dateTransactionStart: dates.startOfPreviousMonthPreviousYear,
                        dateTransactionEnd: dates.endOfPreviousMonthPreviousYear
                    }
                }
            },
            {
                prefix: LABELS.LAST_12_MONTH,
                data: formatAmount(data.collectionAmounts.lastTwelveMonthsAmount, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: {
                        state: 'PAGATO',
                        dateTransactionStart: dates.startOfCurrentMonthPreviousYear,
                        dateTransactionEnd: dates.endOfPreviousMonth
                    }
                }
            },
        ]
    },
    {
        title: LABELS.CURRENT_MONTH_RECEIPTS,
        dataRows: [
            {
                prefix: LABELS.CURRENT_MONTH,
                data: formatAmount(data.incomingAmounts.incomingAmountsCurrentMonth, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: {
                        state: 'PAGATO',
                        dateTransactionStart: dates.startOfCurrentMonth,
                        dateTransactionEnd: dates.endOfCurrentMonth
                    }
                }
            },
            {
                prefix: LABELS.SAME_MONTH_PREVIOUS_YEAR,
                data: formatAmount(data.incomingAmounts.incomingAmountsCurrentMonthLastYear, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: {
                        state: 'PAGATO',
                        dateTransactionStart: dates.startOfCurrentMonthPreviousYear,
                        dateTransactionEnd: dates.endOfCurrentMonthPreviousYear,
                    }
                }
            },
            {
                prefix: LABELS.CURRENT_MONTH_INSOLVENT,
                data: env === 'market'
                    ? `${data.incomingAmounts.incomingClientsInsolvent}`
                    : formatAmount(data.incomingAmounts.incomingAmountsInsolvent, translateService),
                suffix: null,
                actions: {
                    route: options.route,
                    initialFilters: env === 'market'
                        ? {
                            state: 'INSOLUTO',
                            datePayablebyStart: dates.startOfCurrentMonth,
                            datePayablebyEnd: dates.endOfCurrentMonth
                        }
                        : {
                            state: 'INSOLUTO',
                            dateCreationStart: dates.startOfCurrentMonth,
                            dateCreationEnd: dates.endOfCurrentMonth
                        }
                }
            }
        ]
    },
    {
        title: LABELS.RECEIPTS_PREVISION,
        dataRows: [
            {
                prefix: LABELS.NEXT_MONTH,
                data: formatAmount(data.estimatedAmounts.estimatedAmountsNextMonth, translateService),
                suffix: null
            },
            {
                prefix: LABELS.NEXT_YEAR,
                data: formatAmount(data.estimatedAmounts.estimatedAmountsNextYear, translateService),
                suffix: null
            }
        ]
    }
];
const ɵ0 = retrieveCommonCardData;
/**
 * Return the market card data.
 * @param data The dashboard data.
 */
const retrieveMarketCardData = (data) => [
    {
        title: LABELS.EXPIRING_SUBSCRIPTIONS,
        dataRows: [
            {
                prefix: null,
                data: `${data.expiringSubscribedServices.expiringSubscribedServicesInt}`,
                suffix: null
            }
        ]
    },
    {
        title: 'Dettaglio clienti',
        dataRows: [
            {
                prefix: 'In questo mese',
                data: `${data.clientDetail.currentMonthActiveClients}`,
                suffix: null,
                actions: {
                    route: 'customers',
                    initialFilters: {
                        state: 'ATTIVO',
                        dateCreationStart: dates.startOfCurrentMonth,
                        dateCreationEnd: dates.endOfCurrentMonth
                    }
                }
            },
            {
                prefix: 'Attivi totali',
                data: `${data.clientDetail.totalActiveClients}`,
                suffix: null,
                actions: {
                    route: 'customers',
                    initialFilters: {
                        state: 'ATTIVO'
                    }
                }
            }
        ]
    }
];
const ɵ1 = retrieveMarketCardData;
/**
 * Return the support card data.
 * @param data The dashboard data.
 */
const retrieveSupportCardData = (data) => [
    {
        title: LABELS.MERCHANT_DETAILS,
        dataRows: [
            {
                prefix: LABELS.NEW_ACTIVATIONS_CURRENT_MONTH,
                data: `${data.merchantDetail.currentMonthActiveMerchants}`,
                suffix: null,
                actions: null,
            },
            {
                prefix: 'Nuove attivazioni da inizio anno',
                data: `${data.merchantDetail.currentYearActiveMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants',
                    initialFilters: {
                        dateCreationStart: dateToYMD(new Date(date.getFullYear(), 0, 1)),
                        dateCreationEnd: dateToYMD(new Date(date.getFullYear(), 12, 0))
                    }
                }
            },
            {
                prefix: LABELS.CURRENT_MONTH_INSOLVENT,
                data: `${data.merchantDetail.currentMonthInsolventMerchants}`,
                suffix: null,
                actions: {
                    route: 'payments',
                    initialFilters: {
                        state: 'INSOLUTO',
                        dateCreationStart: dates.startOfCurrentMonth,
                        dateCreationEnd: dates.endOfCurrentMonth
                    }
                }
            }
        ]
    },
    {
        title: LABELS.EXPIRING_CANONS,
        dataRows: [
            {
                prefix: LABELS.EXPIRING_SERVICES,
                data: `${data.canons.expiringCanonsNoRenew}`,
                suffix: null
            },
            {
                prefix: LABELS.EXPIRING_SERVICES_WITH_RENEW,
                data: `${data.canons.expiringCanons}`,
                suffix: null
            },
            {
                prefix: LABELS.EXPIRING_MERCHANTS,
                data: `${data.canons.expiringMerchantsNoRenew}`,
                suffix: null
            },
            {
                prefix: LABELS.EXPIRING_MERCHANTS_WITH_RENEW,
                data: `${data.canons.expiringMerchants}`,
                suffix: null
            },
        ]
    },
    {
        title: LABELS.MERCHANT_STATUS,
        dataRows: [
            {
                prefix: LABELS.ACTIVATING,
                data: `${data.merchantStatus.activationPendingMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_pre_actives'
                }
            },
            {
                prefix: LABELS.ACTIVE,
                data: `${data.merchantStatus.activeMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_actives'
                }
            },
            {
                prefix: LABELS.STANDBY,
                data: `${data.merchantStatus.standbyMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_standby',
                }
            },
            {
                prefix: LABELS.OPERATIVE,
                data: `${data.merchantStatus.operatingMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_operating'
                }
            },
            {
                prefix: LABELS.INSOLVENT,
                data: `${data.merchantStatus.insolventMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_insolvent'
                }
            },
            {
                prefix: LABELS.CONCLUDED,
                data: `${data.merchantStatus.endedUpMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_concluded'
                }
            },
            {
                prefix: LABELS.DEACTIVE,
                data: `${data.merchantStatus.deactiveMerchants}`,
                suffix: null,
                actions: {
                    route: 'merchants/merchants_deactivated'
                }
            }
        ]
    }
];
const ɵ2 = retrieveSupportCardData;

let NumericDirective = class NumericDirective {
    constructor(el) {
        this.el = el;
        this.decimals = 0;
        this.specialKeys = [
            'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'
        ];
    }
    check(value, decimals) {
        if (decimals <= 0) {
            return String(value).match(new RegExp(/^\d+$/));
        }
        else {
            const regExpString = '^\\s*((\\d+(\\.\\d{0,' + decimals + '})?)|((\\d*(\\.\\d{1,' + decimals + '}))))\\s*$';
            return String(value).match(new RegExp(regExpString));
        }
    }
    onKeyDown(event) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current = this.el.nativeElement.value;
        const next = current.concat(event.key);
        if (next && !this.check(next, this.decimals)) {
            event.preventDefault();
        }
    }
};
NumericDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('decimals')
], NumericDirective.prototype, "decimals", void 0);
__decorate([
    HostListener('keydown', ['$event'])
], NumericDirective.prototype, "onKeyDown", null);
NumericDirective = __decorate([
    Directive({
        selector: '[numeric]'
    })
], NumericDirective);

let AttributeDirectivesModule = class AttributeDirectivesModule {
};
AttributeDirectivesModule = __decorate([
    NgModule({
        declarations: [NumericDirective],
        imports: [
            CommonModule
        ],
        exports: [NumericDirective]
    })
], AttributeDirectivesModule);

const ticketStates = [
    'NUOVO',
    'APERTO',
    'CHIUSO'
];

function minDateValidator({ date }) {
    return (control) => {
        if (date) {
            const newDate = new Date(date);
            newDate.setHours(0, 0, 0, 0);
            const controlDate = control.value.date && control.value.date instanceof Date ? control.value.date : null;
            if (controlDate && controlDate < newDate) {
                return {
                    invalid: true
                };
            }
        }
        return null;
    };
}
function maxDateValidator({ date }) {
    return (control) => {
        if (date) {
            let newDate;
            if (typeof date === 'string') {
                newDate = new Date(date);
            }
            else {
                newDate = date;
            }
            newDate.setHours(0, 0, 0, 0);
            const controlDate = control.value.date && control.value.date instanceof Date ? control.value.date : null;
            if (controlDate && controlDate > newDate) {
                return {
                    invalid: true
                };
            }
        }
        return null;
    };
}

let SpDialogComponent = class SpDialogComponent {
    constructor(dialogData) {
        this.dialogData = dialogData;
    }
    launchCallback(button) {
        if (button.callback && typeof (button.callback) === 'function') {
            button.callback();
        }
        if (button.downloadCallback && typeof (button.downloadCallback) === 'function') {
            button.downloadCallback(this.saveAsImage());
        }
    }
    saveAsImage() {
        // fetches base 64 data from canvas
        return this.qrCodeParent.qrcElement.nativeElement
            .querySelector("canvas")
            .toDataURL("image/png");
    }
    retrieveButtonColor(index) {
        if (this.dialogData.flagWarningDialog || this.dialogData.flagPrimaryDialog) {
            return 'accent';
        }
        return index === this.dialogData.buttons.length - 1 ? 'primary' : 'accent';
    }
};
SpDialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
__decorate([
    ViewChild('qrCodeParent')
], SpDialogComponent.prototype, "qrCodeParent", void 0);
SpDialogComponent = __decorate([
    Component({
        selector: 'sp-dialog',
        template: "<div class=\"dialog-wrapper\">\n  <button *ngIf=\"dialogData.flagPrimaryDialog\" mat-icon-button disableRipple class=\"close-button\" mat-dialog-close aria-label=\"Chiudi\">\n    <sp-icon [fontIcon]=\"'close'\"></sp-icon>\n  </button>\n  <h2 mat-dialog-title class='aligned-to-start' [ngClass]=\"{'warning' : dialogData.flagWarningDialog}\">{{\n    (dialogData.title) | translate }}</h2>\n  <mat-dialog-content class='mat-typography'>\n    <ng-container *ngFor='let messageRow of dialogData.message'>\n      <p class=\"message-row\">{{ messageRow | translate }}</p>\n    </ng-container>\n    <div *ngIf='dialogData.qrCodeUrl' class='aligned-to-center'>\n      <qrcode #qrCodeParent [qrdata]='dialogData.qrCodeUrl' [allowEmptyString]='true' [cssClass]=\"'center'\"\n        [colorDark]=\"'#000000ff'\" [colorLight]=\"'#ffffffff'\" [elementType]=\"'canvas'\" [errorCorrectionLevel]=\"'M'\"\n        [margin]='4' [scale]='1' [width]='300'></qrcode>\n\n      <img [src]='dialogData.qrCodeLogo' class='innerLogo' alt='' *ngIf='dialogData.qrCodeLogo'>\n    </div>\n  </mat-dialog-content>\n  <div class='flex-space-around'>\n    <ng-container *ngFor='let button of dialogData.buttons; let i=index'>\n      <!-- <sp-button class=\"mx button-inline\" (buttonClick)=\"launchCallback(button)\" [buttonColor]=\"retrieveButtonColor(i)\"\n               [label]=\"button.label | translate\" [fontIcon]=\"button.icon\"></sp-button> -->\n\n      <button (click)='launchCallback(button)' [color]='retrieveButtonColor(i)' mat-raised-button [type]=\"'button'\">\n        <ng-container *ngIf='!!button.fontIcon' class='icon'>\n          <sp-icon [fontIcon]='button.fontIcon'></sp-icon>\n        </ng-container>\n        <span>{{ button.label | translate }}</span>\n      </button>\n    </ng-container>\n  </div>\n</div>",
        styles: [".sp-top-spacing-zero{margin-top:0}.sp-top-spacing-s{margin-top:8px}.sp-top-spacing-m{margin-top:16px}.sp-top-spacing-l{margin-top:24px}.sp-top-spacing-xl{margin-top:32px}.sp-top-spacing-xxl{margin-top:48px}.sp-top-spacing-xxxl{margin-top:64px}.sp-bottom-spacing-zero{margin-bottom:0}.sp-bottom-spacing-s{margin-bottom:8px}.sp-bottom-spacing-m{margin-bottom:16px}.sp-bottom-spacing-l{margin-bottom:24px}.sp-bottom-spacing-xl{margin-bottom:32px}.sp-bottom-spacing-xxl{margin-bottom:48px}.sp-bottom-spacing-xxxl{margin-bottom:64px}.sp-left-spacing-zero{margin-left:0}.sp-left-spacing-s{margin-left:8px}.sp-left-spacing-m{margin-left:16px}.sp-left-spacing-l{margin-left:24px}.sp-left-spacing-xl{margin-left:32px}.sp-left-spacing-xxl{margin-left:48px}.sp-left-spacing-xxxl{margin-left:64px}.sp-spacing-zero{margin:0}.sp-spacing-s{margin:8px}.sp-spacing-m{margin:16px}.sp-spacing-l{margin:24px}.sp-spacing-xl{margin:32px}.sp-spacing-xxl{margin:48px}.sp-spacing-xxxl{margin:64px}.sp-right-spacing-zero{margin-right:0}.sp-right-spacing-s{margin-right:8px}.sp-right-spacing-m{margin-right:16px}.sp-right-spacing-l{margin-right:24px}.sp-right-spacing-xl{margin-right:32px}.sp-right-spacing-xxl{margin-right:48px}.sp-right-spacing-xxxl{margin-right:64px}.sp-top-padding-zero{padding-top:0}.sp-top-padding-s{padding-top:8px}.sp-top-padding-m{padding-top:16px}.sp-top-padding-l{padding-top:24px}.sp-bottom-padding-zero{padding-bottom:0}.sp-bottom-padding-s{padding-bottom:8px}.sp-bottom-padding-m{padding-bottom:16px}.sp-bottom-padding-l{padding-bottom:24px}.sp-left-padding-zero{padding-left:0}.sp-left-padding-s{padding-left:8px}.sp-left-padding-m{padding-left:16px}.sp-left-padding-l{padding-left:24px}.sp-right-padding-zero{padding-right:0}.sp-right-padding-s{padding-right:8px}.sp-right-padding-m{padding-right:16px}.sp-right-padding-l{padding-right:24px}.aligned-to-start{display:flex;align-items:center;justify-content:flex-start}.no-padding{padding:0!important}.aligned-to-center{display:flex;align-items:center;justify-content:center}.aligned-to-end{display:flex;align-items:center;justify-content:flex-end}.flex-space-around{display:flex;justify-content:space-around}.flex-space-between{display:flex;justify-content:space-between;align-items:center}.flex-list{display:flex;flex-flow:column nowrap}.flex{display:flex}.hidden{display:none}.inputMaxwidth{max-width:100px}.menu-item-description{position:relative;color:#737373;font-weight:700;font-size:small}.error-message{font-size:12px;position:relative;color:red;padding:8px}.formcard{display:block;border-radius:15px;box-shadow:0 2px 5px 1px rgba(0,0,0,.15);padding:16px;background-color:#fff}.color-white{color:#fff}.clickable{cursor:pointer}p.light,span.light{font-weight:300}p.regular,span.regular{font-weight:400}p.semibold,span.semibold{font-weight:600}p.bold,span.bold{font-weight:700}:host{display:block}:host .warning{color:red}:host .message-row{font-size:20px}:host .dialog-wrapper{position:relative;min-width:300px}:host .dialog-wrapper .close-button{position:absolute;right:8px;z-index:10}:host .dialog-wrapper .close-button mat-icon{font-size:20px}:host .dialog-wrapper h2[mat-dialog-title]{margin:0 40px 0 0;padding:0}:host .dialog-wrapper .dialog-content{padding-top:8px}.innerLogo{position:absolute;width:40px;height:40px}"]
    }),
    __param(0, Inject(MAT_DIALOG_DATA))
], SpDialogComponent);

let DialogEffects = class DialogEffects {
    constructor(actions$, dialog) {
        this.actions$ = actions$;
        this.dialog = dialog;
        this.openDialog$ = createEffect(() => this.actions$.pipe(ofType(openDialog), tap(props => {
            var _a;
            if (this.dialogRef) {
                this.dialogRef.close();
            }
            this.dialogRef = this.dialog.open(SpDialogComponent, {
                width: (_a = props.dialogData.width, (_a !== null && _a !== void 0 ? _a : '450px')),
                height: 'auto',
                disableClose: true,
                data: props.dialogData
            });
        })), { dispatch: false });
        this.closeDialog$ = createEffect(() => this.actions$.pipe(ofType(closeDialog), tap(() => {
            if (this.dialogRef) {
                this.dialogRef.close();
                this.dialogRef = undefined;
            }
        })), { dispatch: false });
    }
};
DialogEffects.ctorParameters = () => [
    { type: Actions },
    { type: MatDialog }
];
DialogEffects = __decorate([
    Injectable()
], DialogEffects);

const openSnackbar = createAction('[Snackbar] Open Snackbar', props());

let SpSnackBarTemplateComponent = class SpSnackBarTemplateComponent {
    constructor(data) {
        this.data = data;
        /**
         * @property {string} icon
         * Proprietà di @Input().
         * Definisce l'icona da visualizzare nella snackbar
         */
        this.icon = 'warning_outline';
    }
};
SpSnackBarTemplateComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_SNACK_BAR_DATA,] }] }
];
__decorate([
    Input()
], SpSnackBarTemplateComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpSnackBarTemplateComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpSnackBarTemplateComponent.prototype, "icon", void 0);
SpSnackBarTemplateComponent = __decorate([
    Component({
        selector: 'sp-snack-bar',
        template: "<div class=\"status-bar\"\n     [id]=\"id\">\n  <div class=\"icon-container\">\n    <sp-icon [fontIcon]=\"icon\"></sp-icon>\n  </div>\n  <div class=\"description-container\">\n    <p>{{ data | translate }}</p>\n  </div>\n</div>\n",
        styles: [":host .status-bar{display:flex;height:56px}:host .status-bar p{color:#fff}:host .status-bar .icon-container{flex:0 0 56px}:host .status-bar .description-container{flex:1 1 auto}:host .status-bar .description-container p{margin:0;padding:0}"]
    }),
    __param(0, Inject(MAT_SNACK_BAR_DATA))
], SpSnackBarTemplateComponent);

let SnackbarEffects = class SnackbarEffects {
    constructor(actions$, snackBar) {
        this.actions$ = actions$;
        this.snackBar = snackBar;
        this.openSnackbar$ = createEffect(() => this.actions$.pipe(ofType(openSnackbar), tap(props => {
            this.snackBar.openFromComponent(SpSnackBarTemplateComponent, { data: props.message, duration: 2000 });
        })), { dispatch: false });
    }
};
SnackbarEffects.ctorParameters = () => [
    { type: Actions },
    { type: MatSnackBar }
];
SnackbarEffects = __decorate([
    Injectable()
], SnackbarEffects);

let SpBreadcrumbComponent = class SpBreadcrumbComponent {
    constructor() {
        /**
         * @property {EventEmitter<StepItem>} stepClicked
         * Proprietà di @Output().
         * Emette lo step di navigazione selezionato.
         */
        this.stepClicked = new EventEmitter();
    }
    goToPath(stepItem) {
        this.stepClicked.emit(stepItem);
    }
    isLastStep(index) {
        return index < this.steps.length - 1;
    }
};
__decorate([
    Input()
], SpBreadcrumbComponent.prototype, "steps", void 0);
__decorate([
    Output()
], SpBreadcrumbComponent.prototype, "stepClicked", void 0);
SpBreadcrumbComponent = __decorate([
    Component({
        selector: 'sp-breadcrumb',
        template: "<ng-container *ngFor=\"let step of steps; let i=index\">\n  <a (click)=\"goToPath(step)\"><small>{{ step.label }}</small></a> <small *ngIf=\"isLastStep(i)\">&nbsp;&gt;&nbsp;</small>\n</ng-container>\n"
    })
], SpBreadcrumbComponent);

let SpBreadcrumbModule = class SpBreadcrumbModule {
};
SpBreadcrumbModule = __decorate([
    NgModule({
        declarations: [SpBreadcrumbComponent],
        imports: [CommonModule],
        exports: [SpBreadcrumbComponent]
    })
], SpBreadcrumbModule);

let SpButtonComponent = class SpButtonComponent {
    constructor() {
        /**
         * @property {boolean} flagNoPadding
         * Proprietà di @Input().
         * Stabilisce se il bottone non deve avere padding
         */
        this.flagNoPadding = false;
        /**
         * @property {string} label
         * Proprietà di @Input().
         * Definisce il testo della label del button
         */
        this.label = '';
        /**
         * @property {string} tooltip
         * Proprietà di @Input().
         * Definisce il testo del tooltip del button
         */
        this.tooltip = '';
        /**
         * @property {string} buttonType
         * Proprietà di @Input().
         * Definisce il tipo di bottone. Può essere anche di tipo submit.
         */
        this.buttonType = 'button';
        /**
         * @property {string} buttonColor
         * Proprietà di @Input().
         * Definisce il colore del bottone. opzioni disponibili: primary, accent, warn. Per lasciare il pulsante bianco, valorizzare a undefined
         */
        this.buttonColor = 'primary';
        /**
         * @property {string} buttonClick
         * Proprietà di @Output().
         * Definisce l'evento che viene scatenato al click sul pulsante (o al submit se buttonType=submit).
         */
        this.buttonClick = new EventEmitter();
    }
    clickEvent() {
        if (!this.flagDisabled) {
            this.buttonClick.emit();
        }
    }
};
__decorate([
    Input()
], SpButtonComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "flagNoPadding", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "tooltip", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "flagHiddenTooltip", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "fontIcon", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "buttonType", void 0);
__decorate([
    Input()
], SpButtonComponent.prototype, "buttonColor", void 0);
__decorate([
    Output()
], SpButtonComponent.prototype, "buttonClick", void 0);
SpButtonComponent = __decorate([
    Component({
        selector: 'sp-button',
        template: "<div [matTooltip]=\"flagHiddenTooltip ? '' : tooltip\">\n  <button (click)=\"clickEvent()\"\n          [color]=\"buttonColor\"\n          [disabled]=\"flagDisabled\"\n          [id]=\"id\"\n          mat-raised-button\n          [type]=\"buttonType\"\n          class=\"rounded-corners\"\n          [ngClass]=\"{'sp-x-padding-xl': !flagNoPadding}\">\n    <ng-container *ngIf=\"!!fontIcon\"\n                  class=\"icon\">\n      <sp-icon [fontIcon]=\"fontIcon\"></sp-icon>\n    </ng-container>\n    <span class=\"button-label\">{{ label }}</span>\n  </button>\n</div>\n",
        styles: [":host.button-inline:not(:last-of-type){margin-right:16px}:host .sp-x-padding-xl{padding-left:32px;padding-right:32px}"]
    })
], SpButtonComponent);

let SpIconComponent = class SpIconComponent {
    constructor() {
        /**
         * @property {string} tooltip
         * Proprietà di @Input().
         * Definisce il tooltip dell'icona
         */
        this.tooltip = '';
        /**
         * @property {string} iconSize
         * Proprietà di @Input().
         * Definisce la dimensione dell'icona (normal: 24px; big: 32px; bigger: 40px)
         */
        this.iconSize = 'normal';
    }
    defineSize(iconSize) {
        if (iconSize === 'big') {
            return 'md-32';
        }
        if (iconSize === 'bigger') {
            return 'md-40';
        }
        return undefined;
    }
};
__decorate([
    Input()
], SpIconComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpIconComponent.prototype, "fontIcon", void 0);
__decorate([
    Input()
], SpIconComponent.prototype, "tooltip", void 0);
__decorate([
    Input()
], SpIconComponent.prototype, "iconSize", void 0);
SpIconComponent = __decorate([
    Component({
        selector: 'sp-icon',
        template: "<div [matTooltip]=\"tooltip\"\n     class=\"flex-tooltip\">\n    <mat-icon [id]=\"id\"\n              [ngClass]=\"defineSize(iconSize)\">{{ fontIcon }}</mat-icon>\n</div>\n",
        styles: [":host{display:inline-flex}:host.sp-rounded-icon{border:2px solid currentColor;border-radius:50%;width:40px;height:40px;align-items:center;justify-content:center}:host .flex-tooltip{display:flex;align-items:center;justify-content:center}"]
    })
], SpIconComponent);

let SpIconModule = class SpIconModule {
};
SpIconModule = __decorate([
    NgModule({
        declarations: [SpIconComponent],
        imports: [MatIconModule, CommonModule, MatTooltipModule],
        exports: [SpIconComponent]
    })
], SpIconModule);

let SpButtonModule = class SpButtonModule {
};
SpButtonModule = __decorate([
    NgModule({
        declarations: [SpButtonComponent],
        imports: [
            SpIconModule,
            MatButtonModule,
            CommonModule,
            MatTooltipModule
        ],
        exports: [SpButtonComponent]
    })
], SpButtonModule);

let SpCardComponent = class SpCardComponent {
};
__decorate([
    Input()
], SpCardComponent.prototype, "title", void 0);
SpCardComponent = __decorate([
    Component({
        selector: 'sp-card',
        template: "<mat-card class=\"fill-height\">\n  <mat-card-header *ngIf=\"title\"\n                   class=\"centered-text\">\n    <mat-card-title>{{ title }}</mat-card-title>\n  </mat-card-header>\n  <mat-card-content class=\"sp-card-content\">\n    <ng-content></ng-content>\n  </mat-card-content>\n</mat-card>\n",
        styles: [":host{display:block;height:100%}:host .fill-height{height:inherit}:host .centered-text{justify-content:center;text-align:center}"]
    })
], SpCardComponent);

let SpCardModule = class SpCardModule {
};
SpCardModule = __decorate([
    NgModule({
        declarations: [SpCardComponent],
        imports: [MatCardModule, CommonModule],
        exports: [SpCardComponent]
    })
], SpCardModule);

var SpCheckBoxComponent_1;
let SpCheckBoxComponent = SpCheckBoxComponent_1 = class SpCheckBoxComponent {
    constructor() {
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
          * @property {boolean} disabled
          * Proprietà di @Input().
          * Disabilita la checkbox
          */
        this.flagDisabled = false;
        /**
        * @property {boolean} flagChecked
        * Proprietà di @Input().
        * Mette il check sulla checkbox
        */
        this.flagChecked = false;
        /**
         * @property {string} label
         * Proprietà di @Input().
         * Definisce la label della input
         */
        this.changed = new EventEmitter();
    }
    writeValue(val) {
        if (!!val) {
            this.flagChecked = val;
            this.emitChange(this.flagChecked);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onChange(value) {
        // do nothing
    }
    emitChange(value) {
        this.onChange(value);
        this.changed.emit(value);
    }
};
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpCheckBoxComponent.prototype, "flagChecked", void 0);
__decorate([
    Output()
], SpCheckBoxComponent.prototype, "changed", void 0);
SpCheckBoxComponent = SpCheckBoxComponent_1 = __decorate([
    Component({
        selector: 'sp-checkbox',
        template: "<div>\n  <mat-checkbox color=\"accent\"\n                [checked]=\"flagChecked\"\n                [disabled]=\"flagDisabled\"\n                (change)=\"emitChange($event.checked)\">\n    <ng-container *ngIf=\"!!label; else content\">\n      {{ label }}\n    </ng-container>\n    <ng-template #content>\n      <ng-content></ng-content>\n    </ng-template>\n  </mat-checkbox>\n  <ng-container *ngIf=\"flagShowErrorMessage\">\n    <div class=\"error-message\">\n      <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n            class=\"message\">\n        {{ errorMessage | translate }}\n      </span>\n    </div>\n  </ng-container>\n</div>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpCheckBoxComponent_1) }
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpCheckBoxComponent);

let SpCheckBoxModule = class SpCheckBoxModule {
};
SpCheckBoxModule = __decorate([
    NgModule({
        declarations: [SpCheckBoxComponent],
        imports: [
            MatFormFieldModule,
            TranslateModule,
            MatCheckboxModule,
            ReactiveFormsModule,
            CommonModule
        ],
        exports: [SpCheckBoxComponent],
    })
], SpCheckBoxModule);

let InstallmentsNumberFormComponent = class InstallmentsNumberFormComponent {
    constructor() {
        this.installmentChanged = new EventEmitter();
        this.internalAvailableInstallments = [];
        this.form = new FormGroup({
            installmentsNumber: new FormControl('')
        });
    }
    ngOnChanges(changes) {
        if (changes && changes['availableInstallments'] && changes['availableInstallments'].currentValue) {
            this.internalAvailableInstallments = this.availableInstallments.map(value => `${Number(value) + 1}`);
            this.form.get('installmentsNumber').setValue(this.internalAvailableInstallments[0]);
        }
    }
    onInstallmentSelected(installment) {
        this.installmentChanged.emit(`${Number(installment) - 1}`);
    }
};
__decorate([
    Input()
], InstallmentsNumberFormComponent.prototype, "availableInstallments", void 0);
__decorate([
    Output()
], InstallmentsNumberFormComponent.prototype, "installmentChanged", void 0);
InstallmentsNumberFormComponent = __decorate([
    Component({
        selector: 'sp-installments-number-form',
        template: "<form [formGroup]=\"form\" class=\"like-label-value\">\n  <p>{{ 'UI_LIB.SELL_PREVIEW.NUMBER_INSTALLMENTS' | translate }}</p>\n\n  <sp-select\n    class=\"like-label-value__value\"\n    formControlName=\"installmentsNumber\"\n    [flagIsAllAvailable]=\"false\"\n    [label]=\"'UI_LIB.SELL_PREVIEW.AVAILABLE_INSTALLMENTS' | translate\"\n    [values]=\"internalAvailableInstallments\"\n    (changeSelection)=\"onInstallmentSelected($event)\"\n  >\n  </sp-select>\n</form>\n",
        styles: [":host .like-label-value{display:flex;flex-flow:row nowrap}:host .like-label-value p{flex:1 1 40%;display:flex;align-items:center;justify-content:flex-start;margin-bottom:0}:host .like-label-value .like-label-value__value{flex:1 1 60%;display:flex;align-items:center;justify-content:flex-end}"]
    })
], InstallmentsNumberFormComponent);

let PayerInfoFormComponent = class PayerInfoFormComponent {
    constructor() {
        this.fiscalCodePattern = '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$';
        this.fiscalCodeLenght = 16;
        this.form = new FormGroup({
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', [Validators.required]),
            eMailAddress: new FormControl('', [Validators.required, Validators.email]),
            phoneNumber: new FormControl(''),
            fiscalCode: new FormControl('')
        });
    }
    ngOnInit() {
        this.form.get('firstName').setValue(this.operation.payer.firstName);
        this.form.get('lastName').setValue(this.operation.payer.lastName);
        this.form.get('phoneNumber').setValue(this.operation.payer.phoneNumber);
        this.form.get('eMailAddress').setValue(this.operation.payer.eMailAddress);
        this.form.get('fiscalCode').setValue(this.operation.payer.fiscalCode);
    }
    ngOnChanges(changes) {
        if (changes && changes['operation'] && changes['operation'].currentValue && this.flagFiscalCode) {
            this.form
                .get('fiscalCode')
                .setValidators([
                Validators.required,
                Validators.minLength(this.fiscalCodeLenght),
                Validators.maxLength(this.fiscalCodeLenght),
                Validators.pattern(this.fiscalCodePattern)
            ]);
        }
        else {
            this.form.get('fiscalCode').clearValidators();
        }
    }
    isErrorVisible(name) {
        return this.form.get(`${name}`).invalid && !this.form.get(`${name}`).pristine;
    }
    retrieveFiscalCodeErrorMessage() {
        var _a, _b, _c;
        if (((_a = this.form) === null || _a === void 0 ? void 0 : _a.get('fiscalCode').hasError('minlength')) || ((_b = this.form) === null || _b === void 0 ? void 0 : _b.get('fiscalCode').hasError('maxlength')) || ((_c = this.form) === null || _c === void 0 ? void 0 : _c.get('fiscalCode').hasError('pattern'))) {
            return 'SHARED.ERRORS.INVALID';
        }
        return 'SHARED.ERRORS.MANDATORY';
    }
};
__decorate([
    Input()
], PayerInfoFormComponent.prototype, "operation", void 0);
__decorate([
    Input()
], PayerInfoFormComponent.prototype, "flagFiscalCode", void 0);
PayerInfoFormComponent = __decorate([
    Component({
        selector: 'sp-payer-info-form',
        template: "<form [formGroup]=\"form\">\n  <div class=\"flex-col\">\n    <div class=\"flex\">\n      <sp-input\n        class=\"sp-left-spacing-s sp-right-spacing-s flex-grow\"\n        formControlName=\"firstName\"\n        [id]=\"'input-payer-name'\"\n        [label]=\"('UI_LIB.SELL_PREVIEW.NAME' | translate) + ' *'\"\n        [flagShowErrorMessage]=\"isErrorVisible('firstName')\"\n        [errorMessage]=\"'SHARED.ERRORS.MANDATORY' | translate\"\n      >\n      </sp-input>\n      <sp-input\n        class=\"sp-left-spacing-s sp-right-spacing-s flex-grow\"\n        formControlName=\"lastName\"\n        [id]=\"'input-payer-surname'\"\n        [label]=\"('UI_LIB.SELL_PREVIEW.SURNAME' | translate) + ' *'\"\n        [flagShowErrorMessage]=\"isErrorVisible('lastName')\"\n        [errorMessage]=\"'SHARED.ERRORS.MANDATORY' | translate\"\n      >\n      </sp-input>\n    </div>\n    <div class=\"flex sp-top-spacing-s\">\n      <sp-numeric-input\n        class=\"sp-left-spacing-s sp-right-spacing-s flex-grow\"\n        formControlName=\"phoneNumber\"\n        [label]=\"'UI_LIB.SELL_PREVIEW.TELEPHONE' | translate\"\n      ></sp-numeric-input>\n      <sp-input\n        class=\"sp-left-spacing-s sp-right-spacing-s flex-grow\"\n        formControlName=\"eMailAddress\"\n        [flagShowErrorMessage]=\"isErrorVisible('eMailAddress')\"\n        [id]=\"'input-payer-email'\"\n        [label]=\"('UI_LIB.SELL_PREVIEW.MAIL' | translate) + ' *'\"\n        [errorMessage]=\"'SHARED.ERRORS.MANDATORY' | translate\"\n      >\n      </sp-input>\n    </div>\n    <div *ngIf=\"flagFiscalCode\" class=\"flex sp-top-spacing-s\">\n      <sp-input\n        class=\"sp-left-spacing-s sp-right-spacing-s flex-grow fiscal-code\"\n        formControlName=\"fiscalCode\"\n        [maxLength]=\"fiscalCodeLenght\"\n        [flagShowErrorMessage]=\"isErrorVisible('fiscalCode')\"\n        [id]=\"'input-payer-fiscal-code'\"\n        [label]=\"('UI_LIB.SELL_PREVIEW.FISCAL_CODE' | translate) + ' *'\"\n        [errorMessage]=\"retrieveFiscalCodeErrorMessage() | translate\"\n      >\n      </sp-input>\n    </div>\n  </div>\n  <div class=\"sp-left-spacing-s sp-top-spacing-s font-small\">\n    {{ 'UI_LIB.MANDATORY_FIELD' | translate }}\n  </div>\n</form>\n",
        styles: [":host .flex-col{display:flex;flex-direction:column}:host .flex-grow{flex-grow:1}:host .font-small{font-size:smaller}:host .fiscal-code [type=text]{text-transform:uppercase}"]
    })
], PayerInfoFormComponent);

let SpConcludeSellingPreviewComponent = class SpConcludeSellingPreviewComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.flagShowLoader = true;
        this.flagShowModuleLoader = true;
        this.flagFiscalCode = false;
        this.flagPerpetual = false;
        this.returnToHome = new EventEmitter();
        this.installmentChange = new EventEmitter();
        this.multipleRatesSelected = new EventEmitter();
        this.displayedColumns = ['id', 'amount', 'payableBy'];
        this.flagMultipleRatesAvailable = true;
        this.isStripe = false;
    }
    onResize(event) {
        this.checkMobile();
    }
    ngAfterViewInit() {
        this.checkMobile();
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _e;
        if (changes && changes['operation'] && changes['operation'].currentValue) {
            this.flagMultipleRatesAvailable = this.flagMultipleRatesAvailable && !!((_a = this.operation) === null || _a === void 0 ? void 0 : _a.multipleInstallments);
            if (!!((_b = this.operation) === null || _b === void 0 ? void 0 : _b.multipleInstallments) && !this.installmentKey) {
                this.installmentKey = this.retrieveFirstKeyOnMultipleInstallments(this.operation.multipleInstallments);
            }
            if (((_c = this.operation) === null || _c === void 0 ? void 0 : _c.channel) === 'APPPAGO') {
                this.displayedColumns = ['id', 'amount'];
            }
            if (!!((_d = this.operation) === null || _d === void 0 ? void 0 : _d.channel) && this.checkStripeChannel(this.operation.channel)) {
                this.isStripe = true;
            }
            this.hidetitle = ((_e = this.operation) === null || _e === void 0 ? void 0 : _e.channel) === 'NEXI_PAYPAL';
        }
    }
    emitReturnToHome() {
        this.returnToHome.emit();
    }
    format(n) {
        return formatAmount(n, this.translateService);
    }
    elementRateNumberLabel(id) {
        return id === 0 ? 'UI_LIB.SELL_PREVIEW.FIRST_PAYMENT' : 'UI_LIB.SELL_PREVIEW.INSTALLMENT_NO';
    }
    get firstInstallmentAmount() {
        if (!!this.operation &&
            !!this.operation.multipleInstallments &&
            !!this.installmentKey &&
            this.operation.multipleInstallments[this.installmentKey].length > 0) {
            return formatAmount(Number(this.operation.multipleInstallments[this.installmentKey][0].amount), this.translateService);
        }
        return undefined;
    }
    get totalAmount() {
        if (!!this.operation) {
            if (!!this.firstInstallmentAmount) {
                return this.firstInstallmentAmount;
            }
            return formatAmount(this.operation.amount, this.translateService);
        }
        return undefined;
    }
    get rateAmount() {
        if (!!this.operation) {
            if (!!this.operation.multipleInstallments &&
                !!this.installmentKey &&
                this.operation.multipleInstallments[this.installmentKey].length > 0) {
                return Number(this.operation.multipleInstallments[this.installmentKey][0].amount);
            }
            return this.operation.amount;
        }
        return undefined;
    }
    get expiryMonth() {
        return !!this.operation ? dateToYMD(addMonthsToDate(new Date(), this.operation.totalInstallments)) : undefined;
    }
    get flagIsFormValid() {
        return !!this.payerInfoForm ? this.payerInfoForm.form.valid : undefined;
    }
    get tableHeight() {
        var _a;
        const installmentsSize = (_a = this.operation.installments) === null || _a === void 0 ? void 0 : _a.length;
        const multipleInstallmentsSize = this.operation.multipleInstallments;
        if (this.isMobile) {
            return '';
        }
        else if (!!multipleInstallmentsSize && !!this.installmentKey && multipleInstallmentsSize[this.installmentKey].length > 0) {
            return 'table-height-' + multipleInstallmentsSize[this.installmentKey].length;
        }
        else if (!!installmentsSize && installmentsSize <= 11 && installmentsSize !== 0) {
            return 'table-height-' + installmentsSize;
        }
        else {
            return 'table-height-max';
        }
    }
    get isMobile() {
        return window.innerWidth <= 620;
    }
    get flagConfirmRateDisabled() {
        return this.operation && this.operation.channel === 'APPPAGO' && this.rateAmount < 30;
    }
    retrieveAvailableInstallments(recordInstallments) {
        if (!!recordInstallments) {
            return Object.keys(recordInstallments);
        }
        return [];
    }
    onInstallmentChanged(installmentKey) {
        this.installmentKey = installmentKey;
        this.installmentChange.emit(this.installmentKey);
    }
    checkMobile() {
        var _a, _b, _c;
        if (this.isMobile) {
            const element = (_c = (_b = (_a = this.perfectScrollbar) === null || _a === void 0 ? void 0 : _a.directiveRef) === null || _b === void 0 ? void 0 : _b.elementRef) === null || _c === void 0 ? void 0 : _c.nativeElement;
            if (!!element) {
                const parent = element.parentElement;
                parent.style.overflow = 'hidden auto';
                element.classList.remove('ps');
            }
        }
    }
    checkStripeChannel(channel) {
        return channel === 'STRIPE' || channel === 'STRIPE_SDD' || channel === 'STRIPE_KLARNA' || channel === 'STRIPE_ALMA' || channel === 'STRIPE_SCALAPAY';
    }
    retrieveFirstKeyOnMultipleInstallments(multipleInstallments) {
        if (!!multipleInstallments) {
            return Object.keys(multipleInstallments)[0];
        }
        return undefined;
    }
    multipleRatesConfirm() {
        var _a, _b;
        (_b = (_a = this.installmentsNumberForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.get('installmentsNumber').disable();
        this.flagMultipleRatesAvailable = false;
        this.multipleRatesSelected.emit();
    }
    showRedirectSection() {
        return this.operation && this.redirectChannels ? this.redirectChannels.includes(this.operation.channel) : false;
    }
};
SpConcludeSellingPreviewComponent.ctorParameters = () => [
    { type: TranslateService }
];
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "operation", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "flagUnavailableSelling", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "flagShowLoader", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "flagShowModuleLoader", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "flagFiscalCode", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "flagPerpetual", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "customer", void 0);
__decorate([
    Input()
], SpConcludeSellingPreviewComponent.prototype, "redirectChannels", void 0);
__decorate([
    Output()
], SpConcludeSellingPreviewComponent.prototype, "returnToHome", void 0);
__decorate([
    Output()
], SpConcludeSellingPreviewComponent.prototype, "installmentChange", void 0);
__decorate([
    Output()
], SpConcludeSellingPreviewComponent.prototype, "multipleRatesSelected", void 0);
__decorate([
    ViewChild(PayerInfoFormComponent)
], SpConcludeSellingPreviewComponent.prototype, "payerInfoForm", void 0);
__decorate([
    ViewChild('mainScrollbar')
], SpConcludeSellingPreviewComponent.prototype, "perfectScrollbar", void 0);
__decorate([
    ViewChild(InstallmentsNumberFormComponent)
], SpConcludeSellingPreviewComponent.prototype, "installmentsNumberForm", void 0);
__decorate([
    HostListener('window:resize', ['$event'])
], SpConcludeSellingPreviewComponent.prototype, "onResize", null);
SpConcludeSellingPreviewComponent = __decorate([
    Component({
        selector: 'sp-conclude-selling',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\" src=\"./assets/img/login_person.png\" alt=\"\"/>\n\n  <perfect-scrollbar #mainScrollbar [disabled]=\"isMobile\">\n    <ng-container *ngIf=\"!!operation\">\n\n      <div *ngIf=\"showRedirectSection()\" class=\"conclude-selling__container\">\n\n        <div class=\"conclude-selling__content\">\n          <h3>{{ 'UI_LIB.COMPLETE_SELLING.REDIRECT_KLARNA' | translate }}</h3>\n        </div>\n        <div *ngIf=\"!isStripe\" class=\"conclude-selling__bank-logo\">\n          powered by\n          <div\n            class=\"conclude-selling__bank-logo__img\"\n            [ngClass]=\"{\n              'conclude-selling__bank-logo__img--pagodil': operation.channel === 'NEXI_PAGODIL',\n              'conclude-selling__bank-logo__img--nexi_3_paypal': operation.channel === 'NEXI_3_PAYPAL',\n              'conclude-selling__bank-logo__img--scalapay': operation.channel === 'SCALAPAY',\n              'conclude-selling__bank-logo__img--nexi': operation.channel === 'KLARNA_BY_NEXI'\n            }\"\n          ></div>\n        </div>\n\n      </div>\n\n      <div *ngIf=\"!showRedirectSection()\" class=\"conclude-selling__container\">\n        <img src=\"./assets/img/small_pay_logo_big.png\" class=\"conclude-selling__logo\" alt=\"\"/>\n\n        <ng-container *ngIf=\"!flagUnavailableSelling; else unavailableOperation\">\n          <!-- Informazioni generiche -->\n          <div class=\"conclude-selling__content\">\n            <h3>{{ 'UI_LIB.COMPLETE_SELLING.GENERIC_INFO' | translate }}</h3>\n            <sp-payer-info-form *ngIf=\"!!operation\" [operation]=\"operation\"\n                                [flagFiscalCode]=\"flagFiscalCode\"></sp-payer-info-form>\n            <div class=\"product sp-top-spacing-m\">\n                <span class=\"product-label\">{{ 'UI_LIB.COMPLETE_SELLING.PRODUCT' | translate }}: </span>\n                <span class=\"product-value\">{{ operation.serviceName }}</span>\n            </div>\n          </div>\n\n          <!-- Pianificazione pagamenti -->\n          <div class=\"conclude-selling__content\">\n            <h3>{{ 'UI_LIB.COMPLETE_SELLING.RATE_LIST' | translate }}</h3>\n\n            <div class=\"custom-grid\">\n              <sp-label-value\n                class=\"custom-grid__item\"\n                [label]=\"'UI_LIB.SELL_PREVIEW.FIRST_PAYMENT'\"\n                [value]=\"totalAmount\"\n                [valueAlignment]=\"'right'\"\n              ></sp-label-value>\n              <sp-label-value\n                *ngIf=\"operation.channel !== 'APPPAGO'\"\n                [label]=\"'UI_LIB.SELL_PREVIEW.EXPIRY_MONTH_SHORT'\"\n                [value]=\"expiryMonth\"\n                [valueAlignment]=\"'right'\"\n                class=\"custom-grid__item\"\n              ></sp-label-value>\n\n              <div\n                [class]=\"operation.channel !== 'APPPAGO' ? 'custom-grid__item custom-grid__item--full' : 'custom-grid__item'\">\n                <sp-installments-number-form\n                  *ngIf=\"!!operation.multipleInstallments\"\n                  [availableInstallments]=\"retrieveAvailableInstallments(operation.multipleInstallments)\"\n                  (installmentChanged)=\"onInstallmentChanged($event)\"\n                ></sp-installments-number-form>\n              </div>\n            </div>\n            <!-- Rate lists -->\n\n            <!-- MULTPLE installments -->\n            <ng-container *ngIf=\"!!operation.multipleInstallments; else defaultInstallments\">\n              <div [className]=\"'conclude-selling__table ' + tableHeight\">\n                <perfect-scrollbar [disabled]=\"isMobile\">\n                  <table mat-table [dataSource]=\"operation.multipleInstallments[installmentKey]\"\n                         aria-describedby=\"installments\">\n                    <ng-container matColumnDef=\"id\">\n                      <th mat-header-cell *matHeaderCellDef class=\"width-30\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_NO' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-30\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ elementRateNumberLabel(element.id) | translate }}\n                          {{ element.id === 0 ? null : element.id }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <ng-container matColumnDef=\"amount\">\n                      <th mat-header-cell *matHeaderCellDef class=\"width-40\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_AMOUNT' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-40\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ format(element.amount) }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <ng-container matColumnDef=\"payableBy\">\n                      <th mat-header-cell *matHeaderCellDef class=\"below-all width-30\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_OF' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-30\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ element.payableBy | date: 'MM/yyyy' }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"\n                        class=\"zero-height table-header\"></tr>\n\n                    <tr mat-row *matRowDef=\"let row; columns: displayedColumns\" class=\"zero-height\"></tr>\n                  </table>\n                </perfect-scrollbar>\n              </div>\n\n              <sp-button\n                *ngIf=\"flagMultipleRatesAvailable\"\n                class=\"button-inline aligned-to-center sp-top-spacing-l\"\n                [id]=\"'select-multiple-rates'\"\n                [flagDisabled]=\"flagConfirmRateDisabled\"\n                [label]=\"'UI_LIB.SELL_PREVIEW.RATE_CONFIRM' | translate\"\n                (buttonClick)=\"multipleRatesConfirm()\">\n              </sp-button>\n\n              <div class=\"rate-error\" *ngIf=\"flagConfirmRateDisabled\">\n                <em>L'importo minimo delle rate deve essere di 30\u20AC</em>\n              </div>\n\n            </ng-container>\n\n            <!-- DEFAULT installments -->\n            <ng-template #defaultInstallments>\n              <div [className]=\"'conclude-selling__table ' + tableHeight\">\n                <perfect-scrollbar [disabled]=\"isMobile\">\n                  <table mat-table [dataSource]=\"operation.installments\" aria-describedby=\"installments\">\n                    <ng-container matColumnDef=\"id\">\n                      <th mat-header-cell *matHeaderCellDef class=\"width-30\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_NO' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-30\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ elementRateNumberLabel(element.id) | translate }}\n                          {{ element.id === 0 ? null : element.id }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <ng-container matColumnDef=\"amount\">\n                      <th mat-header-cell *matHeaderCellDef class=\"width-40\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_AMOUNT' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-40\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ format(element.amount) }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <ng-container matColumnDef=\"payableBy\">\n                      <th mat-header-cell *matHeaderCellDef class=\"below-all width-30\" scope=\"col\">\n                        <div class=\"aligned-to-center white row-height\">\n                          {{ 'UI_LIB.SELL_PREVIEW.INSTALLMENT_OF' | translate }}\n                        </div>\n                      </th>\n                      <td mat-cell *matCellDef=\"let element\" class=\"width-30\">\n                        <div class=\"aligned-to-center row-height\">\n                          {{ element.payableBy | date: 'MM/yyyy' }}\n                        </div>\n                      </td>\n                    </ng-container>\n\n                    <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"\n                        class=\"zero-height table-header\"></tr>\n\n                    <tr mat-row *matRowDef=\"let row; columns: displayedColumns\" class=\"zero-height\"></tr>\n                  </table>\n                </perfect-scrollbar>\n              </div>\n            </ng-template>\n            <div class=\"padding\" *ngIf=\"flagPerpetual\">\n              <em>{{'UI_LIB.SELL_PREVIEW.FLEX_PAY_ACTIVE' | translate}}</em>\n            </div>\n          </div>\n        </ng-container>\n\n        <!-- Execute payments -->\n        <div class=\"conclude-selling__content\" *ngIf=\"operation && !flagMultipleRatesAvailable\"\n             [class.hidden]=\"flagShowLoader\">\n          <div [class.hidden]=\"!flagShowModuleLoader\">\n            <div class=\"table-spinner sp-bottom-spacing-s aligned-to-center\">\n              <mat-progress-spinner class=\"aligned-to-center\" color=\"warn\" mode=\"indeterminate\"></mat-progress-spinner>\n            </div>\n          </div>\n          <div [class.hidden]=\"flagShowModuleLoader\">\n            <h3 *ngIf=\"!hidetitle\">{{ 'UI_LIB.SELL_PREVIEW.TITLE' | translate }}</h3>\n\n            <ng-content></ng-content>\n          </div>\n        </div>\n\n        <!-- Loader -->\n        <ng-container *ngIf=\"flagShowLoader\">\n          <div class=\"sp-grid-cell-span-12\">\n            <div class=\"table-spinner sp-bottom-spacing-s aligned-to-center\">\n              <mat-progress-spinner class=\"aligned-to-center\" color=\"warn\" mode=\"indeterminate\"></mat-progress-spinner>\n            </div>\n          </div>\n        </ng-container>\n\n        <ng-template #unavailableOperation>\n          <div class=\"aligned-to-center login-form\">\n            <div class=\"sp-bottom-spacing-m formcard\">\n              <h1 class=\"warning aligned-to-center\">\n                {{ 'UI_LIB.SELL_PREVIEW.CAUTION' | translate }}\n              </h1>\n              <h3 class=\"warning aligned-to-center\">\n                {{ 'CONCLUDE_SELLING.UNAVALIABLE_SELLING' | translate }}\n              </h3>\n            </div>\n          </div>\n        </ng-template>\n\n        <div class=\"conclude-selling__bank-logo\" *ngIf=\"!flagShowLoader && !flagUnavailableSelling && !isStripe\">\n          powered by\n          <div\n            class=\"conclude-selling__bank-logo__img\"\n            [ngClass]=\"{\n            'conclude-selling__bank-logo__img--nexi': operation.channel === 'NEXI',\n            'conclude-selling__bank-logo__img--nexi_3': operation.channel === 'NEXI_3_PAYPAL',\n            'conclude-selling__bank-logo__img--nexi_paypal': operation.channel === 'NEXI_PAYPAL',\n            'conclude-selling__bank-logo__img--apppago': operation.channel === 'APPPAGO'\n          }\"\n          ></div>\n        </div>\n      </div>\n    </ng-container>\n  </perfect-scrollbar>\n</div>\n",
        styles: [":host .warning{color:#fb480c}:host .sp-grid-container{display:flex;justify-content:center;position:absolute;top:0;width:100vw;height:100vh;background-color:transparent;padding:0!important;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .conclude-selling__container{display:flex;flex-direction:column;padding:32px 0;width:80%;max-width:800px;margin:0 auto}:host .conclude-selling__logo{width:60%;-o-object-fit:cover;object-fit:cover;margin:0 auto 32px}:host .conclude-selling__content{display:flex;flex-direction:column;background:#fff;margin:8px 0;padding:20px;border-radius:10px}:host .conclude-selling__content h1,:host .conclude-selling__content h3{color:#f8b133;text-align:center}:host .conclude-selling__content .product{padding:10px}:host .conclude-selling__content .product .product-label{color:#f8b133;font-weight:700}:host .conclude-selling__payment-info{display:flex}:host .conclude-selling__payment-info>*{flex:1}:host .conclude-selling__payment-info>:not(:last-child){margin-right:16px}:host .conclude-selling__bank-logo{display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:24px}:host .conclude-selling__bank-logo__img{background-size:contain;background-repeat:no-repeat;width:100px;height:33px}:host .conclude-selling__bank-logo__img--nexi{background-image:url(assets/img/Nexi_Logo.png)}:host .conclude-selling__bank-logo__img--nexi_3{background-image:url(assets/img/Nexi_Logo.png)}:host .conclude-selling__bank-logo__img--stripe{background-image:url(assets/img/Stripe_Logo.png)}:host .conclude-selling__bank-logo__img--nexi_paypal{background-image:url(assets/img/PayPal_logo.png)}:host .conclude-selling__bank-logo__img--nexi_3_paypal{background-image:url(assets/img/PayPal_3_logo.png);width:160px;height:100px}:host .conclude-selling__bank-logo__img--klarna_nexi{background-image:url(assets/img/Klarna_x_Nexi.png);width:160px;height:100px}:host .conclude-selling__bank-logo__img--klarna{background-image:url(assets/img/Klarna_logo.png)}:host .conclude-selling__bank-logo__img--pagodil{background-image:url(assets/img/PagoDIL.png);width:160px;height:100px}:host .conclude-selling__bank-logo__img--apppago{background-image:url(assets/img/APPpago+SPC-footer.png);background-position:center}:host .conclude-selling__table{overflow-y:auto;border-radius:10px;margin-top:16px;box-shadow:0 2px 5px 1px rgba(0,0,0,.15)}:host table{width:100%;height:100%}:host table .width-30{width:30%}:host table .width-40{width:40%}:host table .table-header{background-color:#f7a615}:host table .table-head{background-color:#fc7335;color:#fff;font-weight:700;border-radius:5px;margin:0 5px;flex-grow:1;flex-basis:0}:host table .table-item{font-weight:700;flex-grow:1;flex-basis:0}:host table .row-height{height:30px;white-space:nowrap}:host table .zero-height{height:auto!important}:host table .white{color:#fff}:host .table-height-one{height:60px}:host .table-height-twor{height:90px}:host .table-height-three{height:120px}:host .table-height-4{height:155px}:host .table-height-5{height:186px}:host .table-height-6{height:217px}:host .table-height-7{height:248px}:host .table-height-8{height:279px}:host .table-height-9{height:310px}:host .table-height-10{height:341px}:host .table-height-11{height:372px}:host .table-height-12{height:403px}:host .table-height-max{height:150px}:host .invisible{opacity:0}:host .hidden{opacity:0}@media screen and (max-width:620px){.sp-grid-container .img-bottom-left-2,.sp-grid-container .img-center-right,.sp-grid-container .img-top-left,.sp-grid-container .resizable{display:none}::ng-deep .flex{flex-direction:column}::ng-deep .flex>:not(:last-child){margin-bottom:16px}::ng-deep .conclude-selling__payment-info{flex-direction:column}::ng-deep .conclude-selling__payment-info>*{margin-right:0}::ng-deep .conclude-selling__payment-info>:not(:last-child){margin-top:8px}::ng-deep .conclude-selling__payment-info>* .label-value-wrapper span{flex:1!important;margin-bottom:12px}::ng-deep .conclude-selling__payment-info>* .label-value-wrapper span:first-child{margin-right:16px}::ng-deep .conclude-selling__payment-info>* .label-value-wrapper span:last-child{justify-content:flex-end!important}::ng-deep .conclude-selling__payment-info__table{margin-top:8px!important}::ng-deep table td{padding:0 8px!important;font-size:14px!important}::ng-deep table .row-height{height:auto!important;padding:8px 0!important;white-space:normal!important;justify-content:flex-start!important}::ng-deep table .width-30{width:auto!important}}@media screen and (max-width:1066px){.sp-grid-container .img-center-right{display:none}}.custom-grid{display:grid;flex-wrap:wrap;gap:16px;grid-template-columns:1fr}@media screen and (min-width:620px){.custom-grid{grid-template-columns:repeat(2,1fr)}.custom-flex-grid__item--full{grid-column:1/3}}.padding{padding-top:16px}.rate-error{display:flex;justify-content:center;padding-top:16px;color:#fb480c}"]
    })
], SpConcludeSellingPreviewComponent);

let SpDividerComponent = class SpDividerComponent {
};
SpDividerComponent = __decorate([
    Component({
        selector: 'sp-divider',
        template: "<mat-divider></mat-divider>\n",
        styles: [""]
    })
], SpDividerComponent);

let SpDividerModule = class SpDividerModule {
};
SpDividerModule = __decorate([
    NgModule({
        declarations: [SpDividerComponent],
        imports: [
            CommonModule,
            MatDividerModule
        ],
        exports: [SpDividerComponent]
    })
], SpDividerModule);

var SpInputComponent_1;
let SpInputComponent = SpInputComponent_1 = class SpInputComponent {
    constructor() {
        /**
         * @property {boolean} flagPassword
         * Proprietà di @Input().
         * Definisce la lunghezza minima di input
         */
        this.flagPassword = false;
        /**
         * @property {boolean} flagReducedWidth
         * Proprietà di @Input().
         * Riduce a 60 px la larghezza massima dell'input
         */
        this.flagReducedWidth = false;
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} flagUppercase
         * Proprietà di @Input().
         * Determina se i valori dell'input sono uppercase
         */
        this.flagUppercase = false;
        /**
         * @property {boolean} flagDisabled
         * Proprietà di @Input().
         * Definisce se il form è o meno abilitato
         */
        this.flagDisabled = false;
        this.initValue = '';
        /**
         * @property {EventEmitter<void>} changeValue
         * Proprietà di @Output().
         * Volta a emettere il valore dell'input
         */
        this.changeValue = new EventEmitter();
        /**
         * @property {EventEmitter<string>} emitValue
         * Proprietà di @Output().
         * Volta a emettere il valore dell'input
         */
        this.emitValue = new EventEmitter();
        this.flagCancelIconVisible = false;
    }
    ngOnInit() {
        this.flagHidden = this.flagPassword;
    }
    writeValue(val) {
        this.initValue = val;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onChange(value) {
        // do nothing
    }
    onTouch() {
        // do nothing
    }
    modelChange(e) {
        if (this.flagUppercase) {
            this.initValue = e.toUpperCase();
        }
    }
    emitChange(value) {
        this.flagCancelIconVisible = !!value;
        this.onChange(value);
        this.onTouch();
        this.changeValue.emit();
        this.emitValue.emit(value);
    }
    resetValue() {
        if (this.flagCancelIconVisible) {
            this.flagCancelIconVisible = false;
            this.initValue = '';
            this.onChange('');
            this.onTouch();
            this.changeValue.emit();
        }
    }
    toggleHiddenStatus() {
        this.flagHidden = !this.flagHidden;
    }
    buttonClick() {
        if (this.flagPassword) {
            this.toggleHiddenStatus();
        }
        else {
            this.resetValue();
        }
    }
    get ariaLabel() {
        if (this.flagPassword) {
            return 'Hide password';
        }
        return 'Clear';
    }
    get ariaPressed() {
        if (this.flagPassword) {
            return this.flagHidden;
        }
        return undefined;
    }
    get iconName() {
        if (this.flagPassword) {
            if (this.flagHidden) {
                return 'visibility_off';
            }
            return 'visibility';
        }
        return 'cancel';
    }
};
__decorate([
    Input()
], SpInputComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "maxLength", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "minLength", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagPassword", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagReducedWidth", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagUppercase", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpInputComponent.prototype, "initValue", void 0);
__decorate([
    Output()
], SpInputComponent.prototype, "changeValue", void 0);
__decorate([
    Output()
], SpInputComponent.prototype, "emitValue", void 0);
SpInputComponent = SpInputComponent_1 = __decorate([
    Component({
        selector: 'sp-input',
        template: "<div>\n  <mat-form-field appearance=\"fill\"\n                  color=\"accent\"\n                  class=\"sp-form-field\"\n                  [ngClass]=\"{'inputMaxwidth': flagReducedWidth}\">\n    <mat-label>{{ label | translate }}</mat-label>\n    <input matInput\n           maxlength=\"{{ maxLength }}\"\n           [type]=\"(flagPassword && flagHidden) ? 'password' : 'text'\"\n           [placeholder]=\"placeholder\"\n           [disabled]=\"flagDisabled\"\n           [(ngModel)]=\"initValue\"\n           (ngModelChange)=\"modelChange($event)\"\n           (input)=\"emitChange($event.target.value)\"\n           (keydown.enter)=\"$event.preventDefault()\">\n    <button [class.hidden]=\"!flagPassword && !flagCancelIconVisible\"\n            mat-icon-button\n            matSuffix\n            type=\"button\"\n            tabindex=\"-1\"\n            [disabled]=\"flagDisabled\"\n            [attr.aria-label]=\"ariaLabel\"\n            [attr.aria-pressed]=\"ariaPressed\"\n            (click)=\"buttonClick()\">\n      <mat-icon tabindex=\"-1\"\n                type=\"button\">{{ iconName }}</mat-icon>\n    </button>\n  </mat-form-field>\n  <ng-container *ngIf=\"flagTable\">\n    <ng-container *ngIf=\"flagShowErrorMessage\">\n      <div class=\"error-message\">\n        <span class=\"message\">\n          {{ errorMessage | translate }}\n        </span>\n      </div>\n    </ng-container>\n  </ng-container>\n</div>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpInputComponent_1) }
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpInputComponent);

let SpInputModule = class SpInputModule {
};
SpInputModule = __decorate([
    NgModule({
        declarations: [SpInputComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatFormFieldModule,
            MatInputModule,
            MatButtonModule,
            MatIconModule, TranslateModule
        ],
        exports: [SpInputComponent]
    })
], SpInputModule);

let EmptyPlaceholderPipe = class EmptyPlaceholderPipe {
    transform(value, placeholder) {
        if (!value || (typeof value === 'string' && this.isStringValid(value))) {
            return placeholder ? placeholder : '-';
        }
        return value;
    }
    isStringValid(value) {
        return value.trim().length === 0 || value === 'null' || value === 'undefined';
    }
};
EmptyPlaceholderPipe = __decorate([
    Pipe({
        name: 'emptyPlaceholder'
    })
], EmptyPlaceholderPipe);

let SpEmptyPlaceholderModule = class SpEmptyPlaceholderModule {
};
SpEmptyPlaceholderModule = __decorate([
    NgModule({
        declarations: [EmptyPlaceholderPipe],
        exports: [EmptyPlaceholderPipe]
    })
], SpEmptyPlaceholderModule);

let SpLabelValueComponent = class SpLabelValueComponent {
    get hasRightValueAlignment() {
        return this.valueAlignment === 'right';
    }
    get hasCenterValueAlignment() {
        return this.valueAlignment === 'center';
    }
};
__decorate([
    Input()
], SpLabelValueComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpLabelValueComponent.prototype, "value", void 0);
__decorate([
    Input()
], SpLabelValueComponent.prototype, "valueAlignment", void 0);
__decorate([
    HostBinding('class.right-value-alignment')
], SpLabelValueComponent.prototype, "hasRightValueAlignment", null);
__decorate([
    HostBinding('class.center-value-alignment')
], SpLabelValueComponent.prototype, "hasCenterValueAlignment", null);
SpLabelValueComponent = __decorate([
    Component({
        selector: 'sp-label-value',
        template: "<div class=\"label-value-wrapper\">\n  <span class=\"label\">{{ label | translate }}&nbsp;</span><span class=\"value\"><strong>{{ value |\n      emptyPlaceholder }}</strong></span>\n</div>\n",
        styles: [":host{display:block}:host strong{font-weight:600}:host.right-value-alignment .label-value-wrapper{display:flex;flex-flow:row nowrap}:host.right-value-alignment .label{flex:1 1 40%;display:flex;align-items:center;justify-content:flex-start}:host.right-value-alignment .value{flex:1 1 60%;display:flex;align-items:center;justify-content:flex-end}:host.center-value-alignment .label-value-wrapper{display:flex;flex-flow:row nowrap}:host.center-value-alignment .label{flex:1 1 40%;display:flex;align-items:center;justify-content:flex-start}:host.center-value-alignment .value{flex:1 1 60%;display:flex;align-items:center;justify-content:flex-start}"]
    })
], SpLabelValueComponent);

let SpLabelValueModule = class SpLabelValueModule {
};
SpLabelValueModule = __decorate([
    NgModule({
        declarations: [SpLabelValueComponent],
        imports: [CommonModule, TranslateModule, SpEmptyPlaceholderModule],
        exports: [SpLabelValueComponent]
    })
], SpLabelValueModule);

var SpNumericInputComponent_1;
let SpNumericInputComponent = SpNumericInputComponent_1 = class SpNumericInputComponent {
    constructor(translateService, _cdr) {
        this.translateService = translateService;
        this._cdr = _cdr;
        /**
         * @property {boolean} required
         * Proprietà di @Input().
         * Attiva la validazione
         */
        this.required = false;
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {number} maxValue
         * Proprietà di @Input().
         * Determina il valore massimo che può avere questo componente
         */
        this.maxValue = 10000000000;
        /**
         * @property {number} minValue
         * Proprietà di @Input().
         * Determina il valore minimo che deve avere questo componente
         */
        this.minValue = -10000000000;
        /**
         * @property {boolean} flagPassword
         * Proprietà di @Input().
         * Definisce se il form è o meno abilitato
         */
        this.flagDisabled = false;
        /**
         * @property {boolean} flagEnableDecimal
         * Proprietà di @Input().
         * Definisce se il form supporta decimali
         */
        this.flagEnableDecimal = false;
        /**
         * @property {EventEmitter<void>} changeValue
         * Proprietà di @Output().
         * Volta a emettere il valore dell'input
         */
        this.changeValue = new EventEmitter();
    }
    get flagCancelIconVisible() {
        return this.initValue !== '';
    }
    get initValue() {
        var _a, _b, _c;
        return _c = (_b = (_a = this) === null || _a === void 0 ? void 0 : _a.currencyInput) === null || _b === void 0 ? void 0 : _b.nativeElement.value, (_c !== null && _c !== void 0 ? _c : '');
    }
    set initValue(val) {
        if (this.currencyInput) {
            this.currencyInput.nativeElement.value = !!this.finalAdditionalSign ? val + ` ${this.finalAdditionalSign}` : val;
        }
    }
    get locale() {
        if (this.translateService) {
            return this.translateService.getBrowserCultureLang().split('-')[0];
        }
        return null;
    }
    ngAfterViewInit() {
        this.initValue = this.localInitValue ? this.localInitValue : '';
    }
    validate() {
        if (this.required) {
            if (!!this.currencyInput
                && Number(this.currencyInput.nativeElement.value) >= this.minValue
                && Number(this.currencyInput.nativeElement.value) <= this.maxValue) {
                return (!!this.currencyInput.nativeElement.value && this.currencyInput.nativeElement.value !== '') ? false : { invalid: true };
            }
            else {
                return { invalid: true };
            }
        }
        else {
            return true;
        }
    }
    writeValue(val) {
        if (!!val && val !== '') {
            this.localInitValue = val;
            this._cdr.detectChanges();
            this.initValue = val;
            this.onChange(val);
            this.changeValue.emit();
        }
        else {
            this.resetValue();
            this.onChange(val);
        }
    }
    emitChange(value) {
        if (!isNaN(+value)) {
            value = this.flagEnableDecimal ? value : value.replace(/[^0-9]*/g, '');
            if (value) {
                this.initValue = value;
                this.onChange(value);
                this.changeValue.emit(value);
            }
            else {
                this.resetValue();
            }
        }
        else {
            this.initValue = '';
        }
    }
    resetValue() {
        this.onChange(undefined);
        this.initValue = '';
        this.changeValue.emit();
    }
    buttonClick() {
        this.resetValue();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onChange(value) {
        // do nothing
    }
    onTouch() {
        // do nothing
    }
};
SpNumericInputComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], SpNumericInputComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "required", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "maxLength", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "minLength", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "maxValue", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "minValue", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "finalAdditionalSign", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpNumericInputComponent.prototype, "flagEnableDecimal", void 0);
__decorate([
    Output()
], SpNumericInputComponent.prototype, "changeValue", void 0);
__decorate([
    ViewChild('currencyInput')
], SpNumericInputComponent.prototype, "currencyInput", void 0);
SpNumericInputComponent = SpNumericInputComponent_1 = __decorate([
    Component({
        selector: 'sp-numeric-input',
        template: "<div>\n  <mat-form-field appearance=\"fill\"\n                  color=\"accent\"\n                  class=\"sp-form-field\">\n    <mat-label>{{ label | translate }}</mat-label>\n    <input #currencyInput\n           [attr.aria-label]=\"placeholder\"\n           matInput\n           type=\"text\"\n           [placeholder]=\"placeholder\"\n           [disabled]=\"flagDisabled\"\n           (input)=\"emitChange($event.target.value)\">\n    <button *ngIf=\"!flagDisabled\"\n            [ngClass]=\"{ 'hidden': !flagCancelIconVisible }\"\n            mat-icon-button\n            matSuffix\n            (click)=\"buttonClick()\"\n            [attr.aria-label]=\"'Clear'\"\n            type=\"button\"\n            tabindex=\"-1\">\n      <mat-icon tabindex=\"-1\">cancel</mat-icon>\n    </button>\n  </mat-form-field>\n  <ng-container *ngIf=\"flagShowErrorMessage && flagTable\">\n    <div class=\"error-message\">\n      <span [ngClass]=\"{ 'hidden': !flagShowErrorMessage }\"\n            class=\"message\">\n        {{ errorMessage | translate }}\n      </span>\n    </div>\n  </ng-container>\n</div>\n",
        providers: [
            [
                { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpNumericInputComponent_1) },
                { provide: NG_VALIDATORS, useExisting: SpNumericInputComponent_1, multi: true }
            ]
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpNumericInputComponent);

let SpNumericInputModule = class SpNumericInputModule {
};
SpNumericInputModule = __decorate([
    NgModule({
        declarations: [SpNumericInputComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatFormFieldModule,
            MatInputModule,
            MatButtonModule,
            MatIconModule,
            TranslateModule
        ],
        exports: [
            SpNumericInputComponent
        ]
    })
], SpNumericInputModule);

var SpSelectComponent_1;
let SpSelectComponent = SpSelectComponent_1 = class SpSelectComponent {
    constructor(translate) {
        this.translate = translate;
        this.flagIsAllAvailable = true;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {boolean} flagReducedWidth
         * Proprietà di @Input().
         * Riduce a 60 px la larghezza massima dell'input
         */
        this.flagReducedWidth = false;
        this.compareValues = (a, b) => {
            if (!!this.compareFunction) {
                return this.compareFunction(a, b);
            }
            if (a === b) {
                return true;
            }
            if (!!a && !!b && typeof a === 'object' && typeof b === 'object') {
                const idA = a.id;
                const idB = b.id;
                return idA !== undefined && idA === idB;
            }
            return false;
        };
        this.changeSelection = new EventEmitter();
    }
    /**
     * @property {string } initValue
     * Definisce il valore iniziale del select box
     */
    set initValue(value) {
        this.internalInitValue = value;
        this.onChange(value);
    }
    ngOnChanges(changes) {
        if (changes.values && JSON.stringify(changes.values.currentValue) !== JSON.stringify(changes.values.previousValue)) {
            this.internalValues = (this.values || []).map(value => ({ displayValue: this.retrieveDisplayValue(value), value }));
            if (this.flagIsAllAvailable) {
                const allFilter = { displayValue: this.translate.instant('UI_LIB.SELECT.ALL'), value: '' };
                if (!this.allFilterOrder) {
                    this.internalValues.unshift(allFilter);
                }
                else {
                    this.internalValues.splice(this.allFilterOrder, 0, allFilter);
                }
            }
        }
    }
    writeValue(val) {
        this.internalInitValue = val;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
        this.flagDisabled = flagDisabled;
    }
    onChange(val) {
        // do nothing
    }
    emitChange(value) {
        this.onChange(value);
        this.changeSelection.emit(value);
    }
    retrieveDisplayValue(item) {
        if (!!item) {
            if (!!this.displayFunction) {
                return this.displayFunction(item);
            }
            if (typeof item === 'string') {
                return item;
            }
        }
        return '';
    }
};
SpSelectComponent.ctorParameters = () => [
    { type: TranslateService }
];
__decorate([
    Input()
], SpSelectComponent.prototype, "flagIsAllAvailable", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "flagReducedWidth", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "values", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "allFilterOrder", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "displayFunction", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "compareFunction", void 0);
__decorate([
    Input()
], SpSelectComponent.prototype, "initValue", null);
__decorate([
    Output()
], SpSelectComponent.prototype, "changeSelection", void 0);
SpSelectComponent = SpSelectComponent_1 = __decorate([
    Component({
        selector: 'sp-select',
        template: "<mat-form-field appearance=\"fill\"\n                color=\"accent\"\n                class=\"sp-form-field\"\n                [ngClass]=\"{ 'inputMaxwidth': flagReducedWidth }\">\n  <mat-label>{{ label | translate }}</mat-label>\n\n  <mat-select [id]=\"id\"\n              [ngClass]=\"{ 'inputMaxwidth': flagReducedWidth }\"\n              [(value)]=\"internalInitValue\"\n              (selectionChange)=\"emitChange($event.value)\"\n              [compareWith]=\"compareValues\"\n              [disabled]=\"flagDisabled\">\n    <mat-option *ngFor=\"let x of internalValues\"\n                [value]=\"x.value\">\n      {{ x.displayValue | translate }}\n    </mat-option>\n  </mat-select>\n</mat-form-field>\n\n<ng-container *ngIf=\"flagTable\">\n  <div class=\"error-message\">\n    <span [ngClass]=\"{ 'hidden': !flagShowErrorMessage }\"\n          class=\"message\">\n      {{ errorMessage | translate }}\n    </span>\n  </div>\n</ng-container>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpSelectComponent_1) }
        ],
        styles: [":host .spacer{flex:1 1 auto}:host .icon{padding:0 14px}:host .hidden{visibility:hidden}:host .message{position:absolute}"]
    })
], SpSelectComponent);

let SpSelectModule = class SpSelectModule {
};
SpSelectModule = __decorate([
    NgModule({
        declarations: [SpSelectComponent],
        imports: [MatSelectModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, CommonModule, TranslateModule],
        exports: [SpSelectComponent]
    })
], SpSelectModule);

var SpDatePickerComponent_1;
let SpDatePickerComponent = SpDatePickerComponent_1 = class SpDatePickerComponent {
    constructor() {
        /**
         * @property {boolean} flagReducedWidth
         * Proprietà di @Input().
         * Riduce a 60 px la larghezza massima dell'input
         */
        this.flagReducedWidth = false;
        /**
         * @property {string} label
         * Proprietà di @Input().
         * Definisce il testo della label del button
         */
        this.label = '';
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra la data in nero anzichè in grigino
         */
        this.flaghighlightDate = false;
        /**
         * @property {boolean} flagDisabled
         * Proprietà di @Input().
         * Definisce l'abilitazione del calendario
         */
        this.flagDisabled = false;
        /**
         * @property {EventEmitter} dateChange
         * Proprietà di @Output().
         * Emette la data quando viene selezionata nel datepicker
         */
        this.dateChange = new EventEmitter();
        this.dateValue = {
            date: null
        };
    }
    get data() {
        return this.dateValue.date;
    }
    set data(date) {
        this.dateValue.date = date;
    }
    ngOnInit() {
        if (!!this.initValue) {
            this.dateValue.date = this.initValue;
        }
    }
    writeValue(date) {
        this.dateValue.date = !!date ? date : '';
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onChange(date) {
        // do nothing
    }
    resetValue(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.flagDisabled) {
            this.dateValue = { date: null };
            this.onChange(null);
            this.dateChange.emit();
        }
    }
    emitDate(date) {
        this.onChange(this.dateValue);
        this.dateChange.emit();
    }
};
__decorate([
    Input()
], SpDatePickerComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "flagReducedWidth", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "flaghighlightDate", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "startDate", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "minDate", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "maxDate", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpDatePickerComponent.prototype, "initValue", void 0);
__decorate([
    Output()
], SpDatePickerComponent.prototype, "dateChange", void 0);
SpDatePickerComponent = SpDatePickerComponent_1 = __decorate([
    Component({
        selector: 'sp-date-picker',
        template: "<div>\n  <mat-form-field appearance=\"fill\"\n                  color=\"accent\"\n                  class=\"sp-form-field\"\n                  [ngClass]=\"{ inputMaxwidth: flagReducedWidth }\">\n    <mat-label [ngClass]=\"{ black: flaghighlightDate }\">{{ label | translate }}</mat-label>\n    <input [ngClass]=\"{ black: flaghighlightDate }\"\n           matInput\n           disabled\n           [min]=\"minDate\"\n           [max]=\"maxDate\"\n           [matDatepicker]=\"picker\"\n           [id]=\"id\"\n           (dateChange)=\"emitDate($event.value)\"\n           [(ngModel)]=\"data\" />\n    <mat-datepicker-toggle matSuffix\n                           [for]=\"picker\">\n      <ng-container *ngIf=\"flagDisabled\">\n        <mat-icon *ngIf=\"!!data; else daterange\"\n                  (click)=\"resetValue($event)\"\n                  matDatepickerToggleIcon>cancel</mat-icon>\n      </ng-container>\n      <ng-template #daterange>\n        <mat-icon matDatepickerToggleIcon>date_range</mat-icon>\n      </ng-template>\n    </mat-datepicker-toggle>\n    <mat-datepicker #picker\n                    [startAt]=\"startDate\"\n                    [disabled]=\"flagDisabled\"></mat-datepicker>\n  </mat-form-field>\n  <ng-container *ngIf=\"flagTable\">\n    <div class=\"error-message\">\n      <span [ngClass]=\"{ hidden: !flagShowErrorMessage }\"\n            class=\"message\">\n        {{ errorMessage | translate }}\n      </span>\n    </div>\n  </ng-container>\n</div>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpDatePickerComponent_1) }
        ],
        styles: [":host .hidden{visibility:hidden;display:none}:host .message{position:absolute}:host .black{color:#000!important}"]
    })
], SpDatePickerComponent);

let SpDatePickerModule = class SpDatePickerModule {
};
SpDatePickerModule = __decorate([
    NgModule({
        declarations: [SpDatePickerComponent],
        imports: [
            CommonModule,
            MatFormFieldModule,
            MatDatepickerModule,
            MatInputModule,
            ReactiveFormsModule,
            MatNativeDateModule,
            TranslateModule,
            MomentDateModule,
            MatIconModule,
            FormsModule
        ],
        exports: [SpDatePickerComponent, MomentDateModule],
        providers: [
            { provide: DateAdapter, useClass: CustomDateAdapter },
            { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
        ]
    })
], SpDatePickerModule);

var SpDateRangePickerComponent_1;
let SpDateRangePickerComponent = SpDateRangePickerComponent_1 = class SpDateRangePickerComponent {
    constructor() {
        /**
         * @property {string} label
         * Proprietà di @Input().
         * Definisce il testo della label del button
         */
        this.label = '';
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {EventEmitter} dateChange
         * Proprietà di @Output().
         * Emette la coppia di date selezionate
         */
        this.dateChange = new EventEmitter();
        this.dateRange = { start: null, end: null };
    }
    ngOnInit() {
        if (!!this.initValue) {
            if (!!this.initValue.start && !!this.initValue.end) {
                this.dateRange = this.initValue;
            }
        }
    }
    get start() {
        return this.dateRange.start;
    }
    set start(start) {
        this.dateRange.start = start;
    }
    get end() {
        return this.dateRange.end;
    }
    set end(end) {
        this.dateRange.end = end;
    }
    onChange(newVal) {
        // do nothing
    }
    writeValue(value) {
        if (!value && !this.initValue) {
            this.dateRange = { start: null, end: null };
        }
        if (!!value.start && !!value.end) {
            this.dateRange = value;
            this.onChange(value);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onClose() {
        this.onChange(this.dateRange);
        this.dateChange.emit();
    }
    onOpen(picker) {
        picker.select(null);
        this.start = null;
        this.end = null;
    }
    resetValue(event) {
        event.stopPropagation();
        event.preventDefault();
        this.start = null;
        this.end = null;
        this.onChange(this.dateRange);
        this.dateChange.emit();
    }
    get valuesSelected() {
        return !!this.start && !!this.end;
    }
};
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "startDate", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "minDate", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "maxDate", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpDateRangePickerComponent.prototype, "initValue", void 0);
__decorate([
    Output()
], SpDateRangePickerComponent.prototype, "dateChange", void 0);
SpDateRangePickerComponent = SpDateRangePickerComponent_1 = __decorate([
    Component({
        selector: 'sp-date-range-picker',
        template: "<mat-form-field appearance=\"fill\"\n                color=\"accent\"\n                class=\"sp-form-field\">\n  <mat-label>{{ label | translate }}</mat-label>\n  <mat-date-range-input [rangePicker]=\"picker\"\n                        disabled>\n    <input matInput\n           matStartDate\n           placeholder=\"Start date\"\n           disabled\n           [(ngModel)]=\"start\">\n    <input matEndDate\n           placeholder=\"End date\"\n           [(ngModel)]=\"end\">\n  </mat-date-range-input>\n  <mat-datepicker-toggle matSuffix\n                         [for]=\"picker\">\n    <mat-icon *ngIf=\"valuesSelected; else daterange\"\n              (click)=\"resetValue($event)\"\n              matDatepickerToggleIcon>cancel</mat-icon>\n    <ng-template #daterange>\n      <mat-icon matDatepickerToggleIcon>date_range</mat-icon>\n    </ng-template>\n  </mat-datepicker-toggle>\n  <mat-date-range-picker #picker\n                         disabled=\"false\"\n                         (opened)=\"onOpen(picker)\"\n                         (closed)=\"onClose()\"></mat-date-range-picker>\n</mat-form-field>\n<ng-container *ngIf=\"flagTable\">\n  <div class=\"error-message\">\n    <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n          class=\"message\">\n      {{ errorMessage | translate }}\n    </span>\n  </div>\n</ng-container>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpDateRangePickerComponent_1) }
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpDateRangePickerComponent);

let SpDateRangePickerModule = class SpDateRangePickerModule {
};
SpDateRangePickerModule = __decorate([
    NgModule({
        declarations: [SpDateRangePickerComponent],
        imports: [
            MatFormFieldModule,
            MatDatepickerModule,
            MatInputModule,
            ReactiveFormsModule,
            MatIconModule,
            MatNativeDateModule,
            TranslateModule,
            FormsModule,
            CommonModule
        ],
        exports: [SpDateRangePickerComponent],
        providers: [
            { provide: DateAdapter, useClass: CustomDateAdapter },
            { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
        ]
    })
], SpDateRangePickerModule);

const MONTH_YEAR_PICKER_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

var SpMonthYearPickerComponent_1;
const ɵ0$1 = MONTH_YEAR_PICKER_FORMATS;
let SpMonthYearPickerComponent = SpMonthYearPickerComponent_1 = class SpMonthYearPickerComponent {
    constructor() {
        /**
         * @property {boolean} flagReducedWidth
         * Proprietà di @Input().
         * Riduce a 60 px la larghezza massima dell'input
         */
        this.flagReducedWidth = false;
        /**
         * @property {boolean} flagTable
         * Proprietà di @Input().
         * Property impostata a false solo nella sp-table per questioni grafiche
         */
        this.flagTable = true;
        /**
         * @property {string} label
         * Proprietà di @Input().
         * Definisce il testo della label del datePicker
         */
        this.label = '';
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} flagDisabled
         * Proprietà di @Input().
         * Definisce l'abilitazione del datePicker
         */
        this.flagDisabled = false;
        /**
         * @property {EventEmitter} dateChange
         * Proprietà di @Output().
         * Emette la data quando viene selezionata nel datepicker
         */
        this.dateChange = new EventEmitter();
        this.dateValue = moment();
    }
    get dateToEmit() {
        if (this.dateValue) {
            return {
                month: this.dateValue.month(),
                year: this.dateValue.year()
            };
        }
        return undefined;
    }
    writeValue(obj) {
        if (!!obj && obj instanceof Date) {
            this.dateValue.year(obj.getFullYear());
            this.dateValue.month(obj.getMonth());
            this.change(this.dateToEmit);
        }
    }
    registerOnChange(fn) {
        this.change = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    change(dateToEmit) {
        // do nothing
    }
    chosenYearHandler(normalizedYear) {
        this.dateValue.year(normalizedYear.year());
    }
    chosenMonthHandler(normalizedMonth, datepicker) {
        this.dateValue.month(normalizedMonth.month());
        datepicker.select(this.dateValue);
        datepicker.close();
        this.emitDateChange();
    }
    emitDateChange() {
        this.change(this.dateToEmit);
        this.dateChange.emit(this.dateToEmit);
    }
};
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "flagReducedWidth", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "flagTable", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "minDate", void 0);
__decorate([
    Input()
], SpMonthYearPickerComponent.prototype, "maxDate", void 0);
__decorate([
    Output()
], SpMonthYearPickerComponent.prototype, "dateChange", void 0);
SpMonthYearPickerComponent = SpMonthYearPickerComponent_1 = __decorate([
    Component({
        selector: 'sp-month-year-picker',
        template: "<mat-form-field appearance=\"fill\"\n                color=\"accent\"\n                class=\"sp-form-field\">\n  <mat-label>{{ label | translate }}</mat-label>\n  <input matInput\n         [matDatepicker]=\"dp\"\n         disabled\n         [value]=\"dateValue\"\n         [min]=\"minDate\"\n         [max]=\"maxDate\"\n         [ngClass]=\"{'inputMaxwidth': flagReducedWidth}\">\n  <mat-datepicker-toggle matSuffix\n                         [for]=\"dp\"></mat-datepicker-toggle>\n  <mat-datepicker #dp\n                  startView=\"multi-year\"\n                  (yearSelected)=\"chosenYearHandler($event)\"\n                  (monthSelected)=\"chosenMonthHandler($event, dp)\"               \n                  panelClass=\"example-month-picker\"\n                  [disabled]=\"flagDisabled\">\n  </mat-datepicker>\n</mat-form-field>\n<ng-container *ngIf=\"flagTable\">\n  <div class=\"error-message\">\n    <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n          class=\"message\">\n      {{ errorMessage | translate }}\n    </span>\n  </div>\n</ng-container>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpMonthYearPickerComponent_1) },
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
            },
            { provide: MAT_DATE_FORMATS, useValue: ɵ0$1 },
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}input{color:#000!important}"]
    })
], SpMonthYearPickerComponent);

let SpMonthYearPickerModule = class SpMonthYearPickerModule {
};
SpMonthYearPickerModule = __decorate([
    NgModule({
        declarations: [SpMonthYearPickerComponent],
        imports: [
            CommonModule,
            MatDatepickerModule,
            ReactiveFormsModule,
            FormsModule,
            MatIconModule,
            MomentDateModule,
            MatFormFieldModule,
            MatInputModule,
            TranslateModule
        ],
        exports: [SpMonthYearPickerComponent, MomentDateModule]
    })
], SpMonthYearPickerModule);

const LABELS$1 = {
    TRUE: 'UI_LIB.BOOLEAN.TRUE',
    FALSE: 'UI_LIB.BOOLEAN.FALSE'
};
let SpTableComponent = class SpTableComponent {
    constructor(fb, translateService, cdr) {
        this.fb = fb;
        this.translateService = translateService;
        this.cdr = cdr;
        this.displayedColumns = new Array();
        this.displayedFilters = new Array();
        this.flagShowLoader = true;
        this.flagShowTable = false;
        this.selectedItemsStore = new Array();
        /**
         * @property {Array<TableColumn>} tableColumnData
         * Proprietà di @Input().
         * Array di oggetti che definiscono il titolo della colonna e il campo osservato
         */
        this.tableColumnData = new Array();
        /**
         * @property {Array<TableAction<T>>} tableActions
         * Proprietà di @Input().
         * Definisce le azioni eseguibili su ciascuna riga
         */
        this.tableActions = new Array();
        /**
         * @property {boolean} showIdColumn
         * Proprietà di @Input().
         * Definisce l'esistenza della colonna 'id'
         */
        this.showIdColumn = false;
        /**
         * @property {boolean} flagSelectRow
         * Proprietà di @Input().
         * Definisce l'esistenza della colonna 'stato'
         */
        this.flagSelectRow = false;
        /**
         * @property {EventEmitter} filtered
         * Proprietà di @Output().
         * Fire di evento quando viene digitato un filtro
         */
        this.filtered = new EventEmitter();
        this.selectAllCheckboxState = false;
        this.tableFiltersFormGroup = this.fb.group({ floatLabel: 'auto' });
        this.isActionColumnVisibile = false;
        this.defaultElementsPerPage = 12;
        this.emitFilterDelay = 1000;
        this.timeout = null;
        this.filterData = {
            pageIndex: 0,
            pageSize: this.defaultElementsPerPage,
            fieldFilters: {}
        };
        this.booleanSelectValues = [LABELS$1.TRUE, LABELS$1.FALSE];
        this.booleanNullableSelectValues = [LABELS$1.TRUE, LABELS$1.FALSE, '-'];
    }
    /**
     * @property {PaginableInterface<T>} dataSource
     * Setter di @Input().
     * Array di oggetti che costituiscono il corpo della tabella
     */
    set dataSource(paginableInterface) {
        if (!!paginableInterface) {
            this.flagShowLoader = false;
            this.totalElements = paginableInterface.totalElements;
            this.selectedItemsStore = [];
            this.localDataSource = new MatTableDataSource(paginableInterface.content.map((element, index) => (Object.assign(Object.assign({}, element), { index }))));
            this.initActionColumn();
        }
    }
    /**
     * Return selected rows
     */
    get retrieveSelectedRows() { return this.selectedItemsStore; }
    ngOnInit() {
        this.browserLang = this.translateService.getBrowserLang();
        this.initColumns();
        this.initCustomFiltersAndSort();
        this.reloadData();
    }
    ngAfterViewInit() {
        this.flagShowTable = true;
        this.cdr.detectChanges();
    }
    updateFilterData(tableColumn) {
        if (!!this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => this.emitFilterData(tableColumn), this.emitFilterDelay);
    }
    emitFilterData(tableColumn) {
        const _a = this.tableFiltersFormGroup.getRawValue(), { floatLabel } = _a, filters = __rest(_a, ["floatLabel"]);
        if (filters[tableColumn.columnData] === '') {
            delete this.filterData.fieldFilters[tableColumn.columnData];
        }
        else {
            switch (tableColumn.columnFilter) {
                case 'numeric':
                    if (filters[tableColumn.columnData] === undefined) {
                        delete this.filterData.fieldFilters[tableColumn.columnData];
                    }
                    else {
                        this.filterData.fieldFilters[tableColumn.columnData] = String(filters[tableColumn.columnData]);
                    }
                    break;
                case 'input':
                    if (filters[tableColumn.columnData].trim() === this.filterData.fieldFilters[tableColumn.columnData] || filters[tableColumn.columnData].trim() === '') {
                        return;
                    }
                    this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData].trim();
                    break;
                case 'boolean':
                    this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData] === this.booleanSelectValues[0];
                    break;
                case 'boolean-nullable':
                    this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData] === '-'
                        ? null
                        : filters[tableColumn.columnData] === this.booleanSelectValues[0];
                    break;
                default:
                    this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData];
                    break;
            }
        }
        this.resetPageIndex();
        this.reloadData();
    }
    reloadData() {
        this.flagShowLoader = true;
        this.selectedItemsStore = [];
        this.filtered.emit(this.filterData);
    }
    setFiltersPageData(pageEvent) {
        this.filterData = Object.assign(Object.assign({}, this.filterData), { pageSize: pageEvent.pageSize, pageIndex: pageEvent.pageIndex });
        this.reloadData();
    }
    isFilterRowVisible() {
        return (!this.forceHideFilters &&
            (Object.keys(this.filterData.fieldFilters).length > 0 ||
                (!!this.localDataSource &&
                    !!this.paginator &&
                    this.paginator.length >= this.defaultElementsPerPage)) &&
            this.tableColumnData.some(column => column.columnFilter && column.columnFilter !== 'none'));
    }
    isPaginatorHidden() {
        return this.flagShowLoader || this.checkResultsVisibility() || !this.isFilterRowVisible();
    }
    /**
     * Check if a cell is clickable by checking empty value and callback function,
     * @param column The column.
     * @param element The element.
     */
    isClickable(column, element) {
        return column.clickCallback && element && element[column.columnData];
    }
    checkResultsVisibility() {
        return !this.flagShowLoader && !!this.localDataSource && this.localDataSource.data.length === 0;
    }
    retrieveColumnData(element) {
        if (Array.isArray(element) && element.length > 0) {
            element = element.reduce((previousValue, value) => `${previousValue}<br/>${value}`);
        }
        else if (typeof element === 'boolean') {
            element = element ? LABELS$1.TRUE : LABELS$1.FALSE;
        }
        return `${element}`;
    }
    sortChanged(sort) {
        let sortById = sort.active;
        const column = this.tableColumnData.find(data => data.columnData === sort.active);
        if (!!column && !!column.customSort) {
            sortById = column.customSort;
        }
        this.filterData = Object.assign(Object.assign({}, this.filterData), { sortBy: sort.direction !== '' ? sortById : null, sortingMethod: sort.direction.toUpperCase() });
        this.reloadData();
    }
    /**
     * Toggle row selection.
     * @param element
     */
    toggleAllRowsSelection() {
        this.selectAllCheckboxState = !this.selectAllCheckboxState;
        this.selectedItemsStore = this.selectAllCheckboxState
            ? this.localDataSource.data.filter(x => !this.isCheckboxDisabled(x))
            : [];
    }
    /**
     * Toggle row selection.
     * @param element
     */
    toggleRowSelection(element) {
        this.selectedItemsStore = this.isCheckboxChecked(element)
            ? this.selectedItemsStore.filter(x => x['index'] !== element['index'])
            : [...this.selectedItemsStore, element];
        this.selectAllCheckboxState =
            this.selectedItemsStore.length === this.localDataSource.data.filter(x => !this.isCheckboxDisabled(x)).length;
    }
    /**
     * Check if the all checkbox is disabled for a row.
     * @return True is the all checkbox must be disabled.
     */
    isAllCheckboxDisabled() {
        return this.localDataSource
            ? this.localDataSource.data.every(x => this.isCheckboxDisabled(x))
            : true;
    }
    /**
    * Check if the checkbox is disabled for a row.
    * @param item The current item row.
    * @return True is the checkbox must be disabled.
    */
    isCheckboxDisabled(item) {
        return !!item && !!this.isCheckboxDisableFunction
            ? this.isCheckboxDisableFunction(item)
            : false;
    }
    /**
    * Check if the checkbox is checked for a row.
    * @param item The current item row.
    * @return True is the checkbox must be disabled.
    */
    isCheckboxChecked(item) {
        return this.selectedItemsStore.some(x => x['index'] === item['index']);
    }
    checkFilterDisabled(action, item) {
        return action.hasOwnProperty('flagDisabled') ? action.flagDisabled(item) : false;
    }
    actionCallBack(action, item) {
        if (!this.checkFilterDisabled(action, item)) {
            action.callback(item);
        }
    }
    actionTooltip(action, item) {
        return this.checkFilterDisabled(action, item)
            ? (action.hasOwnProperty('disabledTooltip') ? action.disabledTooltip : '')
            : action.tooltip;
    }
    initColumns() {
        // id column
        if (this.showIdColumn) {
            this.tableColumnData.unshift({
                columnData: 'id',
                columnLabel: 'Id',
                columnFilter: 'numeric'
            });
        }
        // select
        if (this.flagSelectRow) {
            this.displayedColumns.push('select');
            this.displayedFilters.push('selectF');
        }
        // columns
        this.tableColumnData.forEach(column => {
            this.displayedColumns.push(column.columnData);
            this.displayedFilters.push(column.columnData.concat('F'));
            if (column.columnFilter !== 'none') {
                this.tableFiltersFormGroup.addControl(column.columnData, new FormControl(column.initFilterValue || ''));
            }
        });
        this.initActionColumn();
    }
    initCustomFiltersAndSort() {
        const _a = this.tableFiltersFormGroup.getRawValue(), { floatLabel } = _a, filters = __rest(_a, ["floatLabel"]);
        const initFieldsFilters = this.tableColumnData.filter(column => !!column.initFilterValue);
        initFieldsFilters.forEach(tableColumn => {
            if (typeof filters[tableColumn.columnData] === 'string') {
                if ((filters[tableColumn.columnData].trim() !== this.filterData.fieldFilters[tableColumn.columnData])) {
                    this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData].trim();
                    this.resetPageIndex();
                }
            }
            else {
                this.filterData.fieldFilters[tableColumn.columnData] = filters[tableColumn.columnData];
                this.resetPageIndex();
            }
        });
        const sortedEl = this.tableColumnData.find(el => el.beginsSortedBy === 'asc' || el.beginsSortedBy === 'desc');
        if (!!sortedEl) {
            this.filterData = Object.assign(Object.assign({}, this.filterData), { sortBy: sortedEl.columnData, sortingMethod: sortedEl.beginsSortedBy.toUpperCase() });
            this.initSorting = sortedEl.columnData;
            this.initSortDirection = sortedEl.beginsSortedBy;
        }
    }
    initActionColumn() {
        var _a, _b;
        this.displayedColumns = this.displayedColumns.filter(x => x !== 'actions');
        this.displayedFilters = this.displayedFilters.filter(x => x !== 'actionsF');
        const atLeastOneRowHasAnAction = ((_b = (_a = this) === null || _a === void 0 ? void 0 : _a.localDataSource) === null || _b === void 0 ? void 0 : _b.data) && this.tableActions
            ? this.localDataSource.data.some(row => this.tableActions.some(action => action.isVisible(row)))
            : false;
        this.isActionColumnVisibile = this.tableActions.length > 0 && atLeastOneRowHasAnAction;
        if (this.isActionColumnVisibile) {
            this.displayedColumns.push('actions');
            this.displayedFilters.push('actionsF');
        }
    }
    resetPageIndex() {
        this.filterData = Object.assign(Object.assign({}, this.filterData), { pageIndex: 0 });
        if (!!this.paginator) {
            this.paginator.pageIndex = 0;
        }
    }
};
SpTableComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslateService },
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], SpTableComponent.prototype, "tableColumnData", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "tableActions", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "showIdColumn", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "flagSelectRow", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "isCheckboxDisableFunction", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "initSelectFilterValue", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "forceHideFilters", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "initDateFilterValue", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "initDateRangeFilterValue", void 0);
__decorate([
    Input()
], SpTableComponent.prototype, "dataSource", null);
__decorate([
    Output()
], SpTableComponent.prototype, "filtered", void 0);
__decorate([
    ViewChild(MatPaginator)
], SpTableComponent.prototype, "paginator", void 0);
SpTableComponent = __decorate([
    Component({
        selector: 'sp-table',
        template: "<div class=\"rounded\"\n     *ngIf=\"flagShowTable\">\n  <form class=\"scrollable-x\"\n        [formGroup]=\"tableFiltersFormGroup\">\n    <table class=\"sp-table\"\n           aria-describedby=\"Data Table\"\n           mat-table\n           matSort\n           [matSortActive]=\"initSorting\"\n           [matSortDirection]=\"initSortDirection\"\n           [dataSource]=\"localDataSource\"\n           (matSortChange)=\"sortChanged($event)\">\n\n      <!-- Select -->\n      <ng-container *ngIf=\"flagSelectRow\">\n        <ng-container [matColumnDef]=\"'select'\">\n          <th scope=\"col\"\n              mat-header-cell\n              *matHeaderCellDef>\n            <sp-checkbox class=\"aligned-to-center\"\n                         [flagDisabled]=\"isAllCheckboxDisabled()\"\n                         [flagChecked]=\"selectAllCheckboxState\"\n                         (changed)=\"toggleAllRowsSelection()\">\n            </sp-checkbox>\n          </th>\n          <td mat-cell\n              *matCellDef=\"let element\">\n            <sp-checkbox class=\"aligned-to-center\"\n                         [flagDisabled]=\"isCheckboxDisabled(element)\"\n                         [flagChecked]=\"isCheckboxChecked(element)\"\n                         (changed)=\"toggleRowSelection(element)\">\n            </sp-checkbox>\n          </td>\n        </ng-container>\n        <ng-container [matColumnDef]=\"'selectF'\">\n          <th scope=\"col\"\n              mat-header-cell\n              *matHeaderCellDef>&nbsp;</th>\n        </ng-container>\n      </ng-container>\n\n      <!-- Columns -->\n      <ng-container *ngFor=\"let columnInfo of tableColumnData; let i = index\">\n        <ng-container [matColumnDef]=\"columnInfo.columnData\">\n          <ng-container *ngIf=\"!!columnInfo.unsortable; else sortable\">\n            <th scope=\"col\"\n                mat-header-cell\n                *matHeaderCellDef>\n              <div class=\"table-flex-head\">\n                <span>{{ columnInfo.columnLabel | translate }}</span>\n                <ng-container *ngIf=\"tableActions.length < 1 && i + 1 === tableColumnData.length\">\n                  <button class=\"margin-auto\"\n                          [matTooltip]=\"'UI_LIB.TABLE.RELOAD_TABLE' | translate\"\n                          mat-icon-button\n                          color=\"accent\"\n                          (click)=\"reloadData()\">\n                    <sp-icon [fontIcon]=\"'autorenew'\"></sp-icon>\n                  </button>\n                </ng-container>\n              </div>\n            </th>\n          </ng-container>\n          <ng-template #sortable>\n            <th scope=\"col\"\n                mat-header-cell\n                *matHeaderCellDef>\n              <div class=\"table-flex-head\">\n                <span>{{ columnInfo.columnLabel | translate }}</span>\n                <span mat-sort-header></span>\n                <ng-container *ngIf=\"tableActions.length < 1 && i + 1 === tableColumnData.length\">\n                  <button class=\"margin-auto\"\n                          [matTooltip]=\"'UI_LIB.TABLE.RELOAD_TABLE' | translate\"\n                          mat-icon-button\n                          color=\"accent\"\n                          (click)=\"reloadData()\">\n                    <sp-icon [fontIcon]=\"'autorenew'\"></sp-icon>\n                  </button>\n                </ng-container>\n              </div>\n            </th>\n          </ng-template>\n          <td mat-cell\n              *matCellDef=\"let element\">\n            <ng-container [ngSwitch]=\"columnInfo.dataDisplay\">\n              <ng-container *ngSwitchCase=\"'amountRange'\">\n                {{ element[columnInfo.columnData] | currency:'EUR':'symbol-narrow':'1.2-2':'it' }}\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'date'\">\n                {{ element[columnInfo.columnData] | date:'dd/MM/yyyy' }}\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'monthYear'\">\n                {{ element[columnInfo.columnData] | date:'MMMM, y':'+0200':browserLang | titlecase }}\n              </ng-container>\n              <ng-container *ngSwitchDefault>\n                <span [ngClass]=\"{ 'clickable': isClickable(columnInfo, element) }\"\n                      [innerHTML]=\"retrieveColumnData(element[columnInfo.columnData]) | emptyPlaceholder | translate\"\n                      (click)=\"isClickable(columnInfo, element) && columnInfo.clickCallback(element)\"></span>\n              </ng-container>\n            </ng-container>\n          </td>\n        </ng-container>\n\n        <!-- Filters -->\n        <ng-container [matColumnDef]=\"columnInfo.columnData + 'F'\">\n          <th scope=\"col\"\n              mat-header-cell\n              *matHeaderCellDef>\n            <ng-container [ngSwitch]=\"columnInfo.columnFilter\">\n              <ng-container *ngSwitchCase=\"'numeric'\">\n                <sp-numeric-input [label]=\"columnInfo.columnLabel\"\n                          [formControlName]=\"columnInfo.columnData\"\n                          [flagTable]=\"false\"\n                          (changeValue)=\"emitFilterData(columnInfo)\"></sp-numeric-input>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'input'\">\n                <sp-input [label]=\"columnInfo.columnLabel\"\n                          [formControlName]=\"columnInfo.columnData\"\n                          [flagTable]=\"false\"\n                          (changeValue)=\"updateFilterData(columnInfo)\"></sp-input>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'select'\">\n                <sp-select [label]=\"columnInfo.columnLabel\"\n                           [formControlName]=\"columnInfo.columnData\"\n                           [values]=\"columnInfo.columnOptions\"\n                           [initValue]=\"initSelectFilterValue\"\n                           [flagTable]=\"false\"\n                           [allFilterOrder]=\"columnInfo.allFilterOrder\"\n                           (changeSelection)=\"emitFilterData(columnInfo)\">\n                </sp-select>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'boolean'\">\n                <sp-select [label]=\"columnInfo.columnLabel\"\n                           [formControlName]=\"columnInfo.columnData\"\n                           [values]=\"booleanSelectValues\"\n                           [flagTable]=\"false\"\n                           (changeSelection)=\"emitFilterData(columnInfo)\">\n                </sp-select>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'boolean-nullable'\">\n                <sp-select [label]=\"columnInfo.columnLabel\"\n                           [formControlName]=\"columnInfo.columnData\"\n                           [values]=\"booleanNullableSelectValues\"\n                           [flagTable]=\"false\"\n                           (changeSelection)=\"emitFilterData(columnInfo)\">\n                </sp-select>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'date'\">\n                <sp-date-picker [label]=\"columnInfo.columnLabel\"\n                                [initValue]=\"initDateFilterValue\"\n                                [formControlName]=\"columnInfo.columnData\"\n                                [flagTable]=\"false\"\n                                (dateChange)=\"emitFilterData(columnInfo)\">\n                </sp-date-picker>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'dateRange'\">\n                <sp-date-range-picker [label]=\"columnInfo.columnLabel\"\n                                      [initValue]=\"initDateRangeFilterValue\"\n                                      [formControlName]=\"columnInfo.columnData\"\n                                      [flagTable]=\"false\"\n                                      (dateChange)=\"emitFilterData(columnInfo)\">\n                </sp-date-range-picker>\n              </ng-container>\n              <ng-container *ngSwitchCase=\"'monthYear'\">\n                <sp-month-year-picker [formControlName]=\"columnInfo.columnData\"\n                                      [label]=\"columnInfo.columnLabel\"\n                                      [flagTable]=\"false\"\n                                      (dateChange)=\"emitFilterData(columnInfo)\">\n                </sp-month-year-picker>\n              </ng-container>\n              <ng-container *ngSwitchDefault>&nbsp;</ng-container>\n            </ng-container>\n          </th>\n        </ng-container>\n      </ng-container>\n\n      <!-- Actions -->\n      <ng-container *ngIf=\"isActionColumnVisibile\">\n        <ng-container [matColumnDef]=\"'actions'\">\n          <th scope=\"col\"\n              mat-header-cell\n              *matHeaderCellDef>\n            <div class=\"table-flex-head\">\n              <span>Azioni</span>\n              <button class=\"margin-auto\"\n                      [matTooltip]=\"'UI_LIB.TABLE.RELOAD_TABLE' | translate\"\n                      mat-icon-button\n                      color=\"accent\"\n                      (click)=\"reloadData()\">\n                <sp-icon [fontIcon]=\"'autorenew'\"></sp-icon>\n              </button>\n            </div>\n          </th>\n          <td mat-cell\n              *matCellDef=\"let element\">\n            <ng-container *ngFor=\"let action of tableActions\">\n              <button [ngClass]=\"{'gray' : checkFilterDisabled(action, element)}\"\n                      *ngIf=\"action.isVisible(element)\"\n                      [matTooltip]=\"actionTooltip(action, element) | translate\"\n                      mat-icon-button\n                      color=\"accent\"\n                      (click)=\"actionCallBack(action, element)\">\n                <sp-icon [fontIcon]=\"action.iconName\"></sp-icon>\n              </button>\n            </ng-container>\n          </td>\n        </ng-container>\n        <ng-container [matColumnDef]=\"'actionsF'\">\n          <th scope=\"col\"\n              mat-header-cell\n              *matHeaderCellDef>&nbsp;</th>\n        </ng-container>\n      </ng-container>\n\n      <tr mat-header-row\n          *matHeaderRowDef=\"displayedColumns\"\n          class=\"table-header\"></tr>\n      <tr mat-header-row\n          *matHeaderRowDef=\"displayedFilters\"\n          class=\"table-header\"\n          [hidden]=\"!isFilterRowVisible()\"></tr>\n      <tr mat-row\n          *matRowDef=\"let row; columns: displayedColumns;\"\n          [hidden]=\"flagShowLoader\"></tr>\n    </table>\n  </form>\n\n  <div [hidden]=\"isPaginatorHidden()\">\n    <mat-paginator [pageSizeOptions]=\"[12, 25, 50]\"\n                   showFirstLastButtons\n                   (page)=\"setFiltersPageData($event)\"\n                   [length]=\"totalElements\">\n    </mat-paginator>\n  </div>\n\n  <div *ngIf=\"flagShowLoader\"\n       class=\"table-spinner sp-bottom-spacing-l\">\n    <mat-progress-spinner color=\"warn\"\n                          mode=\"indeterminate\">\n    </mat-progress-spinner>\n  </div>\n\n  <div class=\"sp-top-spacing-m sp-bottom-spacing-m\"\n       *ngIf=\"checkResultsVisibility()\">\n    <span class=\"sp-left-spacing-l\">{{ 'UI_LIB.TABLE.NO_RESULTS' | translate }}</span>\n  </div>\n</div>\n",
        styles: [":host{display:block}:host .hidden{display:none;height:0}:host .gray{color:gray}:host .scrollable-x{overflow-x:auto}:host .sp-table{width:100%}:host .sp-table .table-header{background-color:#f2f2f2}:host .rounded{border-radius:24px;overflow:hidden;box-shadow:0 2px 5px 1px rgba(0,0,0,.15)}:host .table-spinner{display:flex;justify-content:center;align-items:center;margin-top:64px}:host .table-flex-head{display:flex;align-items:center}:host .margin-auto{margin-left:auto}:host .clickable{text-decoration:underline;cursor:pointer}"]
    })
], SpTableComponent);

class SpPaginatorIntl extends MatPaginatorIntl {
    constructor(translate) {
        super();
        this.translate = translate;
        this.itemsPerPageLabel = this.translate.instant('UI_LIB.TABLE.ITEMS_PER_PAGE');
        this.nextPageLabel = this.translate.instant('UI_LIB.TABLE.NEXT_PAGE');
        this.previousPageLabel = this.translate.instant('UI_LIB.TABLE.PREV_PAGE');
        this.firstPageLabel = this.translate.instant('UI_LIB.TABLE.FIRST_PAGE');
        this.lastPageLabel = this.translate.instant('UI_LIB.TABLE.LAST_PAGE');
        this.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return `0 / ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return `${startIndex + 1} - ${endIndex} / ${length}`;
        };
    }
}

let SpTableModule = class SpTableModule {
};
SpTableModule = __decorate([
    NgModule({
        declarations: [SpTableComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            MatButtonModule,
            MatSortModule,
            MatTooltipModule,
            MatPaginatorModule,
            MatTableModule,
            MomentDateModule,
            SpIconModule,
            SpInputModule,
            SpSelectModule,
            SpCheckBoxModule,
            SpDatePickerModule,
            SpMonthYearPickerModule,
            SpDateRangePickerModule,
            MatCardModule,
            MatProgressSpinnerModule,
            SpEmptyPlaceholderModule,
            SpNumericInputModule,
            TranslateModule
        ],
        providers: [{ provide: MatPaginatorIntl, useClass: SpPaginatorIntl }],
        exports: [SpTableComponent]
    })
], SpTableModule);

let SpConcludeSellingPreviewModule = class SpConcludeSellingPreviewModule {
};
SpConcludeSellingPreviewModule = __decorate([
    NgModule({
        declarations: [SpConcludeSellingPreviewComponent, PayerInfoFormComponent, InstallmentsNumberFormComponent],
        imports: [
            CommonModule,
            TranslateModule,
            SpButtonModule,
            SpDividerModule,
            SpInputModule,
            SpSelectModule,
            FormsModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            SpTableModule,
            SpNumericInputModule,
            MatProgressSpinnerModule,
            SpLabelValueModule,
            PerfectScrollbarModule,
            MatTableModule
        ],
        exports: [SpConcludeSellingPreviewComponent]
    })
], SpConcludeSellingPreviewModule);

let SpContainerComponent = class SpContainerComponent {
    constructor() {
        /**
         * @property {Array<MenuSectionItem>} menuSectionItems
         * Proprietà di @Output().
         * Emette la voce di menu selezionata dall'utente
         */
        this.menuItemSelected = new EventEmitter();
        this.menuSubItemSelected = new EventEmitter();
        this.logOutBtnEvent = new EventEmitter();
        this.localUnitEmitted = new EventEmitter();
        this.allUnitsEmitted = new EventEmitter();
    }
    emitMenuItemSelected(item) {
        this.menuItemSelected.emit(item);
    }
    emitMenuSubItemSelected(item) {
        this.menuSubItemSelected.emit(item);
    }
    logOutEvent() {
        this.logOutBtnEvent.emit();
    }
    emitLocalUnit(unit) {
        this.localUnitEmitted.emit(unit);
    }
    emitAllUnits() {
        this.allUnitsEmitted.emit();
    }
    checkLocalUnitsExistence() {
        return !!this.localUnits && this.localUnits.length > 1;
    }
    get hasRightValueAlignment() {
        return this.checkLocalUnitsExistence();
    }
};
__decorate([
    Input()
], SpContainerComponent.prototype, "menuSectionItems", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "env", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "flagCompletlyDisabled", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "loggedMerchantAuthority", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "flagLocalUnitsDisabled", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "localUnits", void 0);
__decorate([
    Input()
], SpContainerComponent.prototype, "username", void 0);
__decorate([
    Output()
], SpContainerComponent.prototype, "menuItemSelected", void 0);
__decorate([
    Output()
], SpContainerComponent.prototype, "menuSubItemSelected", void 0);
__decorate([
    Output()
], SpContainerComponent.prototype, "logOutBtnEvent", void 0);
__decorate([
    Output()
], SpContainerComponent.prototype, "localUnitEmitted", void 0);
__decorate([
    Output()
], SpContainerComponent.prototype, "allUnitsEmitted", void 0);
__decorate([
    HostBinding('class.container-local-unit-left')
], SpContainerComponent.prototype, "hasRightValueAlignment", null);
SpContainerComponent = __decorate([
    Component({
        selector: 'sp-container',
        template: "<sp-local-units-sidenav *ngIf=\"checkLocalUnitsExistence()\"\n                        [localUnits]=\"localUnits\"\n                        [flagDisabled]=\"flagLocalUnitsDisabled\"\n                        [flagCompletlyDisabled]=\"flagCompletlyDisabled\"\n                        class=\"local-unit\"\n                        (localUnitEmitted)=\"emitLocalUnit($event)\"\n                        (selectAllEmitted)=\"emitAllUnits()\">\n</sp-local-units-sidenav>\n<mat-sidenav-container class=\"container\">\n  <mat-sidenav mode=\"rail\"\n               closeWidth=\"70px\"\n               expandedWidth=\"290px\"\n               opened\n               #appDrawer>\n    <sp-menu [menuSectionItems]=\"menuSectionItems\"\n             [loggedMerchantAuthority]=\"loggedMerchantAuthority\"\n             (menuItemSelected)=\"emitMenuItemSelected($event)\"\n             (menuSubItemSelected)=\"emitMenuSubItemSelected($event)\"\n             (menuButtonClicked)=\"appDrawer.toggle()\"></sp-menu>\n  </mat-sidenav>\n\n  <mat-sidenav-content>\n    <sp-toolbar [env]=\"env\"\n                [label]=\"'SHARED.AMBIENT' | translate\"\n                [username]=\"username\"\n                (logOutBtnEvent)=\"logOutEvent()\"></sp-toolbar>\n    <ng-content></ng-content>\n  </mat-sidenav-content>\n</mat-sidenav-container>\n",
        styles: [":host .container{position:absolute;top:0;bottom:0;left:0;right:0}:host.container-local-unit-left .container{left:70px}"]
    })
], SpContainerComponent);

let LocalUnitsSidenavComponent = class LocalUnitsSidenavComponent {
    constructor() {
        /**
         * @property {Array<LocalUnit>} localUnits
         * Proprietà di @Input().
         * Definisce le unità locali del merchant
         */
        this.localUnits = [];
        /**
         * @property {EventEmitter<LocalUnit>} localUnitEmitted
         * Proprietà di @Output().
         * Emette l'unità locale cliccata
         */
        this.localUnitEmitted = new EventEmitter();
        /**
         * @property {EventEmitter<void>} selectAllEmitted
         * Proprietà di @Output().
         * Emette il click del bottone "all"
         */
        this.selectAllEmitted = new EventEmitter();
    }
    select(unit) {
        this.localUnitEmitted.emit(unit);
    }
    get isAllSelected() {
        return !this.localUnits.find(unit => unit.flagSelected);
    }
    selectAll() {
        this.selectAllEmitted.emit();
    }
    retrieveElementClass(isSelected) {
        if (this.flagDisabled && this.flagCompletlyDisabled) {
            return isSelected ? 'selected' : 'disabled';
        }
        else {
            return isSelected ? 'selected' : '';
        }
    }
};
__decorate([
    Input()
], LocalUnitsSidenavComponent.prototype, "localUnits", void 0);
__decorate([
    Input()
], LocalUnitsSidenavComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], LocalUnitsSidenavComponent.prototype, "flagCompletlyDisabled", void 0);
__decorate([
    Output()
], LocalUnitsSidenavComponent.prototype, "localUnitEmitted", void 0);
__decorate([
    Output()
], LocalUnitsSidenavComponent.prototype, "selectAllEmitted", void 0);
LocalUnitsSidenavComponent = __decorate([
    Component({
        selector: 'sp-local-units-sidenav',
        template: "<div class=\"local-unit\">\n  <perfect-scrollbar>\n    <button mat-stroked-button\n            class=\"sp-top-spacing-s local-units-button\"\n            [class.selected]=\"isAllSelected\"\n            [class.disabled]=\"flagDisabled\"\n            (click)=\"selectAll()\"\n            [disabled]=\"flagDisabled\">{{ 'UI_LIB.LOCAL_UNITS.ALL_UNITS' | translate }}</button>\n    <ng-container *ngFor=\"let unit of localUnits\">\n      <button mat-stroked-button\n              class=\"sp-top-spacing-s local-units-button\"\n              (click)=\"select(unit)\"\n              [matTooltip]=\"unit.signboard\"\n              [matTooltipPosition]=\"'right'\"\n              [ngClass]=\"retrieveElementClass(unit.flagSelected)\"\n              [disabled]=\"flagCompletlyDisabled\"> <span class=\"inner-text\">{{ unit.label }}</span></button>\n    </ng-container>\n  </perfect-scrollbar>\n</div>\n",
        styles: [":host{height:100vh;width:70px}:host .local-unit{overflow:hidden}:host .local-units-button{border:2px solid #fff;color:#fff;margin:8px;width:48px;min-width:48px;padding:0;height:48px}:host .inner-text{font-size:.8em}"]
    })
], LocalUnitsSidenavComponent);

const ɵ0$2 = {
    suppressScrollX: true
};
let SpLocalUnitsSidenavModule = class SpLocalUnitsSidenavModule {
};
SpLocalUnitsSidenavModule = __decorate([
    NgModule({
        declarations: [LocalUnitsSidenavComponent],
        imports: [
            CommonModule,
            MatSidenavModule,
            MatButtonModule,
            MatListModule,
            PerfectScrollbarModule,
            TranslateModule,
            MatTooltipModule
        ],
        exports: [LocalUnitsSidenavComponent],
        providers: [
            {
                provide: PERFECT_SCROLLBAR_CONFIG,
                useValue: ɵ0$2
            }
        ]
    })
], SpLocalUnitsSidenavModule);

let SpAnimatedIconComponent = class SpAnimatedIconComponent {
    constructor() {
        this.animateFromParent = false;
    }
    toggle() {
        if (!this.animateFromParent) {
            this.flagAnimate = !this.flagAnimate;
        }
    }
};
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "start", void 0);
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "end", void 0);
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "colorStart", void 0);
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "colorEnd", void 0);
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "flagAnimate", void 0);
__decorate([
    Input()
], SpAnimatedIconComponent.prototype, "animateFromParent", void 0);
SpAnimatedIconComponent = __decorate([
    Component({
        selector: 'sp-animated-icon',
        template: "<mat-icon [ngClass]=\"{'flagAnimate' : flagAnimate}\"\n          color=\"{{ flagAnimate ? colorEnd : colorStart }}\"\n          (click)=\"toggle()\">{{ flagAnimate ? end : start }}</mat-icon>\n",
        styles: [":host .material-icons{transition:transform .5s;font-weight:600}:host .material-icons.flagAnimate{transform:rotate(360deg)}"]
    })
], SpAnimatedIconComponent);

let SpAnimatedIconModule = class SpAnimatedIconModule {
};
SpAnimatedIconModule = __decorate([
    NgModule({
        declarations: [SpAnimatedIconComponent],
        imports: [CommonModule, MatIconModule],
        exports: [SpAnimatedIconComponent]
    })
], SpAnimatedIconModule);

let SpMenuComponent = class SpMenuComponent {
    constructor() {
        /**
         * @property {EventEmitter<MenuItem>} menuItemSelected
         * Proprietà di @Output().
         * Emette la voce di menu selezionata dall'utente
         */
        this.menuItemSelected = new EventEmitter();
        /**
         * @property {EventEmitter<MenuSubItem>} menuSubItemSelected
         * Proprietà di @Output().
         * Emette la sub voce di menu selezionata dall'utente
         */
        this.menuSubItemSelected = new EventEmitter();
        this.menuButtonClicked = new EventEmitter();
    }
    get isMenuClosed() {
        return this.flagClosedMenu;
    }
    emitMenuItemSelected(menuItem) {
        this.menuItemSelected.emit(menuItem);
    }
    emitMenuSubitemSelected(menuItem) {
        this.menuSubItemSelected.emit(menuItem);
    }
    menuButtonClick() {
        this.flagClosedMenu = !this.flagClosedMenu;
        this.menuButtonClicked.emit();
    }
    isNotEmpty(label) {
        return !!label && label !== '';
    }
    isSectionVisible(allowedAuths) {
        if (!!allowedAuths.isVisibleTo) {
            return allowedAuths.isVisibleTo.filter(auth => auth === this.loggedMerchantAuthority).length > 0;
        }
        else {
            return true;
        }
    }
    retrieveClassForSubItemsContainer(subMenuItems) {
        if (!!subMenuItems && subMenuItems.length > 0) {
            return `sub-menu-items-${subMenuItems.length}`;
        }
        return 'sub-menu-items-empty';
    }
};
__decorate([
    Input()
], SpMenuComponent.prototype, "menuSectionItems", void 0);
__decorate([
    Input()
], SpMenuComponent.prototype, "loggedMerchantAuthority", void 0);
__decorate([
    Output()
], SpMenuComponent.prototype, "menuItemSelected", void 0);
__decorate([
    Output()
], SpMenuComponent.prototype, "menuSubItemSelected", void 0);
__decorate([
    Output()
], SpMenuComponent.prototype, "menuButtonClicked", void 0);
__decorate([
    HostBinding('class.closed-menu')
], SpMenuComponent.prototype, "isMenuClosed", null);
SpMenuComponent = __decorate([
    Component({
        selector: 'sp-menu',
        template: "<mat-nav-list>\n  <div class=\"menu-toggle-container\">\n    <a mat-list-item\n       (click)=\"menuButtonClick()\">\n      <div class=\"menu-toggle-icon\">\n        <sp-animated-icon matListIcon\n                          [start]=\"'keyboard_arrow_left'\"\n                          [end]=\"'keyboard_arrow_right'\"\n                          [colorStart]=\"'default'\"\n                          [colorEnd]=\"'default'\"\n                          [flagAnimate]=\"flagClosedMenu\"\n                          [animateFromParent]=\"true\"></sp-animated-icon>\n      </div>\n    </a>\n  </div>\n  <perfect-scrollbar>\n    <div class=\"menu-container\">\n      <ng-container *ngFor=\"let menuSectionItem of menuSectionItems\">\n        <div *ngIf=\"isSectionVisible(menuSectionItem)\">\n          <div matSubheader\n               *ngIf=\"isNotEmpty(menuSectionItem.label | translate)\">\n            <h3>{{ menuSectionItem.label | translate }}</h3>\n          </div>\n          <ng-container *ngFor=\"let menuItem of menuSectionItem.menuItems\">\n            <div *ngIf=\"isSectionVisible(menuItem)\">\n              <a mat-list-item\n                 [class.active-status]=\"menuItem.flagActive\"\n                 (click)=\"emitMenuItemSelected(menuItem)\">\n                <mat-icon matListIcon\n                          class=\"wide-padding\"\n                          [matTooltip]=\"flagClosedMenu ? (menuItem.label | translate) : ''\"\n                          [matTooltipPosition]=\"'right'\">{{ menuItem.icon }}</mat-icon>\n                <p matLine>{{ menuItem.label | translate }}</p>\n              </a>\n              <div [ngClass]=\"retrieveClassForSubItemsContainer(menuItem.subItems)\">\n                <div *ngFor=\"let menuSubItem of menuItem.subItems\"\n                     class=\"menu-sub-item\">\n                  <a mat-list-item\n                     [class.active-status]=\"menuSubItem.flagActive\"\n                     (click)=\"emitMenuSubitemSelected(menuSubItem)\">\n                    <div class=\"sub-item-padding\">\n                      <p matLine>{{ menuSubItem.label | translate }}</p>\n                    </div>\n                  </a>\n                </div>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n  </perfect-scrollbar>\n</mat-nav-list>\n",
        styles: [":host .sub-menu-items-1{height:48px;overflow:hidden}:host .sub-menu-items-2{height:96px;overflow:hidden}:host .sub-menu-items-3{height:144px;overflow:hidden}:host .sub-menu-items-4{height:192px;overflow:hidden}:host .sub-menu-items-5{height:240px;overflow:hidden}:host .sub-menu-items-empty{display:none}:host .mat-subheader{white-space:nowrap;height:56px;overflow:hidden}:host .mat-subheader,:host div[class*=sub-menu-items]{transition:.3s linear}:host.closed-menu .mat-subheader{height:0;padding-top:0;padding-bottom:0}:host.closed-menu div[class*=sub-menu-items]{height:0}:host .menu-toggle-container{height:56px;width:100%}:host .menu-toggle-container .menu-toggle-icon{padding-right:18px;position:absolute;right:0}:host .menu-toggle-container a{height:100%}:host .sub-item-padding{padding-left:56px}:host .active-status{background-color:#33333333}:host .menu-container{max-height:calc(100vh - 56px)}"]
    })
], SpMenuComponent);

const ɵ0$3 = {
    suppressScrollX: true
};
let SpMenuModule = class SpMenuModule {
};
SpMenuModule = __decorate([
    NgModule({
        declarations: [SpMenuComponent],
        imports: [
            MatSidenavModule,
            MatListModule,
            MatIconModule,
            MatTooltipModule,
            CommonModule,
            MatButtonModule,
            SpIconModule,
            SpAnimatedIconModule,
            PerfectScrollbarModule,
            TranslateModule
        ],
        exports: [SpMenuComponent],
        providers: [
            {
                provide: PERFECT_SCROLLBAR_CONFIG,
                useValue: ɵ0$3
            }
        ]
    })
], SpMenuModule);

let SpToolbarComponent = class SpToolbarComponent {
    constructor() {
        /**
         * @property {EventEmitter} logOutBtnEvent
         * Proprietà di @Output().
         * Emissione dell'evento per aprire il dialog di confirm logout
         */
        this.logOutBtnEvent = new EventEmitter();
    }
    openQuitDialog() {
        this.logOutBtnEvent.emit();
    }
};
__decorate([
    Input()
], SpToolbarComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpToolbarComponent.prototype, "env", void 0);
__decorate([
    Input()
], SpToolbarComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpToolbarComponent.prototype, "username", void 0);
__decorate([
    Output()
], SpToolbarComponent.prototype, "logOutBtnEvent", void 0);
SpToolbarComponent = __decorate([
    Component({
        selector: 'sp-toolbar',
        template: "<mat-toolbar [id]=\"id\"\n             color=\"accent\">\n  <mat-toolbar-row>\n    <span class=\"left-area\"><img class=\"logo-smallpay\"\n           src=\"assets/img/small_pay_logo_small.png\"\n           alt=\"Logo Smallpay\">{{ label }}</span>\n    <ng-container *ngIf=\"env === 'staging'\">\n      <span class=\"sp-left-spacing-l\"> {{ 'UI_LIB.STAGING_ENV' | translate }} </span>\n    </ng-container>\n    <span class=\"spacer\">&nbsp;</span>\n    <span class=\"right-area\">{{ username }}\n      <button mat-icon-button\n              aria-label=\"Esci\"\n              (click)=\"openQuitDialog()\"\n              class=\"logout-button\">\n        <sp-icon class=\"inherit-line-height\"\n                 [id]=\"'log-out'\"\n                 [fontIcon]=\"'logout'\"></sp-icon>\n      </button>\n    </span>\n  </mat-toolbar-row>\n</mat-toolbar>\n",
        styles: [":host{position:absolute;top:0;width:100%}:host .left-area{display:inline-flex;align-items:center;font-weight:300}:host .left-area .logo-smallpay{margin-right:16px}:host .spacer{flex:1 1 auto}:host .right-area{display:inline-flex;align-items:center;font-size:20px;font-weight:300}:host .right-area .logout-button{margin-left:16px}"]
    })
], SpToolbarComponent);

let SpToolbarModule = class SpToolbarModule {
};
SpToolbarModule = __decorate([
    NgModule({
        declarations: [SpToolbarComponent],
        imports: [
            CommonModule,
            MatToolbarModule,
            SpIconModule,
            TranslateModule,
            MatButtonModule
        ],
        exports: [SpToolbarComponent]
    })
], SpToolbarModule);

const ɵ0$4 = {
    suppressScrollX: true
};
let SpContainerModule = class SpContainerModule {
};
SpContainerModule = __decorate([
    NgModule({
        declarations: [SpContainerComponent],
        imports: [
            SpToolbarModule,
            MatSidenavModule,
            SpMenuModule,
            SpLocalUnitsSidenavModule,
            MatListModule,
            DrawerRailModule,
            CommonModule,
            PerfectScrollbarModule,
            TranslateModule
        ],
        exports: [SpContainerComponent],
        providers: [
            {
                provide: PERFECT_SCROLLBAR_CONFIG,
                useValue: ɵ0$4
            }
        ]
    })
], SpContainerModule);

let SpCountDownComponent = class SpCountDownComponent {
    constructor() {
        this.onTimerTick = new EventEmitter();
        this.leftMinutes = 0;
        this.leftSeconds = 0;
    }
    ngOnInit() {
        this.startCountDown();
    }
    startCountDown() {
        this.countDownDate = Date.now() + 1000 * 60 * this.minutes + 30;
        this.leftMinutes = this.minutes;
        const interval = setInterval(() => {
            const now = Date.now();
            const distance = this.countDownDate - now;
            this.leftMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            this.leftSeconds = Math.floor((distance % (1000 * 60)) / 1000);
            this.onTimerTick.emit(this.leftMinutes + ':' + this.leftSeconds);
            if (distance < 1) {
                clearInterval(interval);
            }
        }, 1000);
    }
};
__decorate([
    Input()
], SpCountDownComponent.prototype, "minutes", void 0);
__decorate([
    Output()
], SpCountDownComponent.prototype, "onTimerTick", void 0);
SpCountDownComponent = __decorate([
    Component({
        selector: 'sp-count-down',
        template: "<div class=\"countdown-container\">\n  <div class=\"countdown-card\">\n    <h3 class=\"aligned-to-center\">{{leftMinutes >= 0 ? leftMinutes : 0}}</h3>\n  </div>\n  <div class=\"sp-left-spacing-s sp-right-spacing-s\">\n    <h3 class=\"aligned-to-center\">:</h3>\n  </div>\n  <div class=\"countdown-card\">\n    <h3 class=\"aligned-to-center\">{{leftSeconds >= 0 ? leftSeconds : 0}}</h3>\n  </div>\n</div>\n",
        styles: [":host .countdown-container{display:flex;width:120px;align-items:center;justify-content:center;border-radius:15px;box-shadow:0 2px 5px 1px rgba(0,0,0,.15);padding:8px;background-color:#f8b133;color:#fff}:host .countdown-card{display:block;padding:8px;width:70px}:host .aligned-to-center{margin:0!important}:host span{font-size:x-small}:host .relative{position:relative}:host .absolute{position:absolute}"]
    })
], SpCountDownComponent);

let SpCountdownModule = class SpCountdownModule {
};
SpCountdownModule = __decorate([
    NgModule({
        declarations: [SpCountDownComponent],
        imports: [
            CommonModule
        ],
        exports: [SpCountDownComponent]
    })
], SpCountdownModule);

var SpCurrencyInputComponent_1;
let SpCurrencyInputComponent = SpCurrencyInputComponent_1 = class SpCurrencyInputComponent extends CurrencyPipe {
    constructor(translateService) {
        super(translateService.getBrowserCultureLang());
        this.translateService = translateService;
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} flagPassword
         * Proprietà di @Input().
         * Definisce se il form è o meno abilitato
         */
        this.flagDisabled = false;
        /**
         * @property {EventEmitter<void>} changeValue
         * Proprietà di @Output().
         * Volta a emettere il valore dell'input
         */
        this.changeValue = new EventEmitter();
    }
    get flagCancelIconVisible() {
        return this.initValue !== '0.00 €' && this.initValue !== '0,00 €';
    }
    get initValue() {
        return this.currencyInput ? this.currencyInput.nativeElement.value : '';
    }
    set initValue(val) {
        if (this.currencyInput) {
            this.currencyInput.nativeElement.value = this.transform(+val, 'EUR', 'symbol', '1.2-2', this.locale);
        }
    }
    get locale() {
        return this.translateService ? this.translateService.getBrowserCultureLang().split('-')[0] : null;
    }
    ngAfterViewInit() {
        this.initValue = '0.00';
    }
    writeValue(val) {
        if (!!val && val !== '') {
            this.initValue = val;
            this.changeValue.emit();
        }
        else {
            this.resetValue(false);
        }
    }
    onKeydown(e, target) {
        if (e.key === 'ENTER' || e.key === ',') {
            e.preventDefault();
        }
        if (e.key === ',') {
            const caretPosition = target.selectionStart;
            target.setSelectionRange(caretPosition + 1, caretPosition + 1);
        }
    }
    emitChange(value, target) {
        let caretPosition = target.selectionStart;
        const startingLength = target.value.length;
        value = value.replace(/[^0-9.,]*/g, '');
        if (this.locale === 'it') {
            value = value.replace(/[^0-9,]*/g, '').replace(/,/g, '.');
        }
        if (value.includes('.')) {
            value = value.slice(0, value.indexOf('.') + 3);
        }
        const numberValue = +value;
        if (!isNaN(numberValue)) {
            this.initValue = value;
            this.onChange(numberValue);
            const endingLength = target.value.length;
            this.changeValue.emit(numberValue);
            if (startingLength === 1) {
                target.setSelectionRange(caretPosition, caretPosition);
            }
            else if (endingLength - startingLength === -1) {
                target.setSelectionRange(caretPosition, caretPosition);
            }
            else {
                caretPosition = caretPosition + (endingLength - startingLength);
                target.setSelectionRange(caretPosition, caretPosition);
            }
        }
        else {
            this.resetValue();
        }
    }
    resetValue(emit = true) {
        if (this.flagCancelIconVisible) {
            this.onChange(0);
        }
        this.initValue = '0.00';
        if (emit) {
            this.changeValue.emit();
        }
    }
    buttonClick() {
        this.resetValue();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    onChange(value) {
        // do nothing
    }
    onTouch() {
        // do nothing
    }
};
SpCurrencyInputComponent.ctorParameters = () => [
    { type: TranslateService }
];
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "maxLength", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "minLength", void 0);
__decorate([
    Input()
], SpCurrencyInputComponent.prototype, "flagDisabled", void 0);
__decorate([
    Output()
], SpCurrencyInputComponent.prototype, "changeValue", void 0);
__decorate([
    ViewChild('currencyInput')
], SpCurrencyInputComponent.prototype, "currencyInput", void 0);
SpCurrencyInputComponent = SpCurrencyInputComponent_1 = __decorate([
    Component({
        selector: 'sp-currency-input',
        template: "<div>\n  <mat-form-field appearance=\"fill\"\n                  color=\"accent\"\n                  class=\"sp-form-field\">\n    <mat-label>{{ label | translate }}</mat-label>\n    <input #currencyInput\n           matInput\n           [placeholder]=\"placeholder\"\n           [type]=\"'text'\"\n           [disabled]=\"flagDisabled\"\n           (input)=\"emitChange($event.target.value, $event.target)\"\n           (keydown)=\"onKeydown($event, $event.target)\"\n           (click)=\"currencyInput.select()\">\n    <button *ngIf=\"!flagDisabled\"\n            [class.hidden]=\"!flagCancelIconVisible\"\n            mat-icon-button\n            matSuffix\n            [attr.aria-label]=\"'Clear'\"\n            type=\"button\"\n            tabindex=\"-1\"\n            (click)=\"buttonClick()\">\n      <mat-icon tabindex=\"-1\">cancel</mat-icon>\n    </button>\n  </mat-form-field>\n  <ng-container *ngIf=\"flagShowErrorMessage\">\n    <div class=\"error-message\">\n      <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n            class=\"message\">\n        {{ errorMessage | translate }}\n      </span>\n    </div>\n  </ng-container>\n</div>\n",
        providers: [[{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpCurrencyInputComponent_1) }]],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpCurrencyInputComponent);

let SpCurrencyInputModule = class SpCurrencyInputModule {
};
SpCurrencyInputModule = __decorate([
    NgModule({
        declarations: [
            SpCurrencyInputComponent
        ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatFormFieldModule,
            MatInputModule,
            MatButtonModule,
            MatIconModule,
            TranslateModule
        ],
        exports: [
            SpCurrencyInputComponent
        ]
    })
], SpCurrencyInputModule);

const CARD_EXPIRATION_PICKER_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

let CardExpirationDateAdapter = class CardExpirationDateAdapter extends MomentDateAdapter {
    constructor(dateLocale, _options) {
        super(dateLocale, _options);
    }
    getMonthNames(style) {
        return style === 'long' ? super.getMonthNames(style) : ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    }
};
CardExpirationDateAdapter.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DATE_LOCALE,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_MOMENT_DATE_ADAPTER_OPTIONS,] }] }
];
CardExpirationDateAdapter = __decorate([
    Injectable(),
    __param(0, Optional()), __param(0, Inject(MAT_DATE_LOCALE)),
    __param(1, Optional()), __param(1, Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS))
], CardExpirationDateAdapter);

var SpCardExpirationPickerComponent_1;
const ɵ0$5 = CARD_EXPIRATION_PICKER_FORMATS;
let SpCardExpirationPickerComponent = SpCardExpirationPickerComponent_1 = class SpCardExpirationPickerComponent extends SpMonthYearPickerComponent {
};
SpCardExpirationPickerComponent = SpCardExpirationPickerComponent_1 = __decorate([
    Component({
        selector: 'sp-card-expiration-picker',
        template: "<mat-form-field appearance=\"fill\"\n                color=\"accent\"\n                class=\"sp-form-field\">\n  <mat-label>{{ label | translate }}</mat-label>\n  <input matInput\n         [matDatepicker]=\"dp\"\n         disabled\n         [value]=\"dateValue\"\n         [min]=\"minDate\"\n         [max]=\"maxDate\"\n         [ngClass]=\"{'inputMaxwidth': flagReducedWidth}\">\n  <mat-datepicker-toggle matSuffix\n                         [for]=\"dp\"></mat-datepicker-toggle>\n  <mat-datepicker #dp\n                  startView=\"multi-year\"\n                  (yearSelected)=\"chosenYearHandler($event)\"\n                  (monthSelected)=\"chosenMonthHandler($event, dp)\"\n                  panelClass=\"example-month-picker\"\n                  [disabled]=\"flagDisabled\">\n  </mat-datepicker>\n</mat-form-field>\n<ng-container *ngIf=\"flagTable\">\n  <div class=\"error-message\">\n    <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n          class=\"message\">\n      {{ errorMessage | translate }}\n    </span>\n  </div>\n</ng-container>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpCardExpirationPickerComponent_1) },
            {
                provide: DateAdapter,
                useClass: CardExpirationDateAdapter,
                deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
            },
            { provide: MAT_DATE_FORMATS, useValue: ɵ0$5 }
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}input{color:#000!important}"]
    })
], SpCardExpirationPickerComponent);

let SpCardExpirationPickerModule = class SpCardExpirationPickerModule {
};
SpCardExpirationPickerModule = __decorate([
    NgModule({
        declarations: [SpCardExpirationPickerComponent],
        imports: [
            CommonModule,
            MatDatepickerModule,
            ReactiveFormsModule,
            FormsModule,
            MatIconModule,
            MomentDateModule,
            MatFormFieldModule,
            MatInputModule,
            TranslateModule
        ],
        exports: [SpCardExpirationPickerComponent, MomentDateModule]
    }) //
], SpCardExpirationPickerModule);

let SpDialogModule = class SpDialogModule {
};
SpDialogModule = __decorate([
    NgModule({
        declarations: [SpDialogComponent],
        imports: [CommonModule,
            MatButtonModule, MatDialogModule, TranslateModule, SpIconModule, QRCodeModule],
        exports: [SpDialogComponent]
    })
], SpDialogModule);

let SpHelpChatComponent = class SpHelpChatComponent {
    constructor() {
        this.messages = [{
                id: 0,
                dateCreation: new Date(),
                textMessage: '',
                ticketId: 1,
                owner: '',
                thread: 'SUPPORT',
            }];
        this.messageEmitted = new EventEmitter();
    }
    ngOnInit() {
        this.messageForm = new FormGroup({
            message: new FormControl('')
        });
        this.scrollToBottom();
    }
    ngOnChanges() {
        this.scrollToBottom();
    }
    emitMessage() {
        const message = {
            ticketId: this.ticket.id,
            textMessage: this.messageForm.get('message').value,
            applicationId: this.ticket.applicationId
        };
        this.messageEmitted.emit(message);
    }
    isTextAreaDisabled() {
        var _a;
        return this.messageContext === 'SUPPORT' ? ((_a = this.ticket) === null || _a === void 0 ? void 0 : _a.state) === 'NUOVO' : false;
    }
    messageOrigin(origin) {
        return origin === this.messageContext ? 'from-market' : 'from-support';
    }
    isSameContext(origin) {
        return origin === this.messageContext;
    }
    scrollToBottom() {
        if (this.perfectScrollBar) {
            setTimeout(() => {
                var _a;
                (_a = this.perfectScrollBar['directiveRef']) === null || _a === void 0 ? void 0 : _a.scrollToBottom();
            }, 250);
        }
    }
};
__decorate([
    Input()
], SpHelpChatComponent.prototype, "messages", void 0);
__decorate([
    Input()
], SpHelpChatComponent.prototype, "ticket", void 0);
__decorate([
    Input()
], SpHelpChatComponent.prototype, "messageContext", void 0);
__decorate([
    Output()
], SpHelpChatComponent.prototype, "messageEmitted", void 0);
__decorate([
    ViewChild('perfectScrollbar')
], SpHelpChatComponent.prototype, "perfectScrollBar", void 0);
SpHelpChatComponent = __decorate([
    Component({
        selector: 'sp-help-chat',
        template: "<div class=\"flexbox sp-top-spacing-l\">\n  <perfect-scrollbar #perfectScrollbar>\n    <div>\n      <div class=\"sp-grid\">\n        <div *ngFor=\"let message of messages\"\n             class=\"sp-grid-cell-span-12 message\"\n             [ngClass]=\"isSameContext(message.thread) ? 'aligned-to-end' : 'aligned-to-start'\">\n\n          <div class=\"chat-box\">\n            <div *ngIf=\"!isSameContext(message.thread)\"\n                 class=\"chat-box__owner\">\n              {{ message.thread === 'SUPPORT' ? 'SUPPORTO SMALLPAY' : message.owner }}\n            </div>\n            <div class=\"chat-box__message\"\n                 [ngClass]=\"messageOrigin(message.thread)\">\n              {{ message.textMessage }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </perfect-scrollbar>\n  <div>\n    <form [formGroup]=\"messageForm\">\n      <sp-text-area formControlName=\"message\"\n                    [id]=\"'new-message-support-input'\"\n                    [label]=\"'UI_LIB.TEXT_AREA.WRITE_MSG' | translate\"\n                    [flagDisabled]=\"isTextAreaDisabled()\">\n      </sp-text-area>\n    </form>\n    <div class=\"sp-grid\">\n      <div class=\"sp-grid-cell-span-10\"></div>\n      <sp-button class=\"sp-grid-cell-span-2 button-inline aligned-to-end\"\n                [id]=\"'support-btn-send-new-msg'\"\n                [label]=\"'UI_LIB.BUTTON.SEND_MSG' | translate\"\n                [buttonColor]=\"'primary'\"\n                (click)=\"emitMessage()\">\n      </sp-button>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .chat-box{display:flex;flex-direction:column}:host .chat-box__owner{color:#333;font-size:12px;margin-left:2px;font-weight:700}:host .chat-box__message{max-width:50vw;border-radius:15px;padding:16px}:host .from-support{background-color:#f2f2f2}:host .from-market{background-color:#fce2b3}:host .flexbox{height:70vh;display:flex;flex-direction:column;justify-content:stretch}:host .positioned-bottom{position:fixed;bottom:2%;width:69vw}:host .message{margin:8px 16px}:host .flex-chat{flex:1 1 0;overflow-y:scroll}"]
    })
], SpHelpChatComponent);

var SpTextAreaComponent_1;
let SpTextAreaComponent = SpTextAreaComponent_1 = class SpTextAreaComponent {
    constructor() {
        this.initValue = '';
    }
    writeValue(val) {
        this.initValue = val;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(isDisabled) {
        // do nothing
    }
    onChange(value) {
        // do nothing
    }
};
__decorate([
    Input()
], SpTextAreaComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpTextAreaComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpTextAreaComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SpTextAreaComponent.prototype, "flagDisabled", void 0);
SpTextAreaComponent = SpTextAreaComponent_1 = __decorate([
    Component({
        selector: 'sp-text-area',
        template: "<div>\n  <mat-form-field class=\"full-width\">\n    <label [for]=\"id\">\n      {{ label | translate }}\n      <textarea class=\"height\"\n                name=\"textarea\"\n                matInput\n                [id]=\"id\"\n                [placeholder]=\"placeholder\"\n                [disabled]=\"flagDisabled\"\n                (input)=\"onChange($event.target.value)\">{{ initValue }}</textarea>\n    </label>\n  </mat-form-field>\n</div>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpTextAreaComponent_1) }
        ],
        styles: [":host .full-width{width:100%}:host .height{max-height:400px;height:200px}"]
    })
], SpTextAreaComponent);

let SpTextAreaModule = class SpTextAreaModule {
};
SpTextAreaModule = __decorate([
    NgModule({
        declarations: [SpTextAreaComponent],
        imports: [
            CommonModule,
            MatFormFieldModule,
            ReactiveFormsModule,
            TranslateModule,
            MatInputModule
        ],
        exports: [SpTextAreaComponent]
    })
], SpTextAreaModule);

const ɵ0$6 = {
    suppressScrollX: true
};
let SpHelpChatModule = class SpHelpChatModule {
};
SpHelpChatModule = __decorate([
    NgModule({
        declarations: [SpHelpChatComponent],
        imports: [
            CommonModule,
            FormsModule,
            TranslateModule,
            SpButtonModule,
            PerfectScrollbarModule,
            SpTextAreaModule,
            ReactiveFormsModule
        ],
        exports: [SpHelpChatComponent],
        providers: [
            {
                provide: PERFECT_SCROLLBAR_CONFIG,
                useValue: ɵ0$6
            }
        ]
    })
], SpHelpChatModule);

let SpImageComponent = class SpImageComponent {
    constructor() {
        /**
        * @property {boolean}
        * Proprietà di @Input().
        * Definisce il flag per mostrare/non mostrare il pulsante di salvataggio
        */
        this.flagHideSaveButton = false;
        this.imageSelected = new EventEmitter();
        this.imgSource = 'assets/img/empty.jpg';
    }
    set loggedMerchant(merchant) {
        if (!!merchant) {
            if (!!merchant.logoPath) {
                this.imgSource = merchant.logoPath;
            }
            this.merchant = merchant;
        }
    }
    storeImage(changeEvent) {
        if (changeEvent.target.files && changeEvent.target.files[0]) {
            const reader = new FileReader();
            reader.onload = element => {
                this.imgSource = element.target.result;
            };
            reader.readAsDataURL(changeEvent.target.files[0]);
            this.selectedImage = changeEvent.target.files[0];
            // Se il pulsante di salvataggio non è visibile, sarà quando seleziono l'immagine ad emettere l'evento
            if (this.flagHideSaveButton) {
                this.emitImage();
            }
        }
    }
    emitImage() {
        if (!!this.selectedImage) {
            this.imageSelected.emit({ file: this.selectedImage });
        }
    }
};
__decorate([
    Input()
], SpImageComponent.prototype, "maxHeight", void 0);
__decorate([
    Input()
], SpImageComponent.prototype, "maxWidth", void 0);
__decorate([
    Input()
], SpImageComponent.prototype, "flagHideSaveButton", void 0);
__decorate([
    Input()
], SpImageComponent.prototype, "loggedMerchant", null);
__decorate([
    Output()
], SpImageComponent.prototype, "imageSelected", void 0);
SpImageComponent = __decorate([
    Component({
        selector: 'sp-image',
        template: "<div class=\"image-container\">\n  <img alt=\"img\"\n       class=\"img\"\n       [src]=\"imgSource\" />\n  <div class=\"bottom-button\">\n    <button class=\"registry-button\"\n            (click)=\"fileUploader.click()\"\n            mat-icon-button>\n      <mat-icon>edit</mat-icon>\n    </button>\n  </div>\n  <label for=\"file-input\"></label>\n  <input name=\"file-input\"\n         id=\"file-input\"\n         type=\"file\"\n         (change)=\"storeImage($event)\"\n         #fileUploader\n         class=\"input\" />\n</div>\n<div *ngIf=\"!flagHideSaveButton\" class=\"submitbutton aligned-to-end sp-top-spacing-l\">\n  <sp-button [id]=\"'image-ui-component-emit'\"\n             [label]=\"'UI_LIB.IMAGE.CONFIRM' | translate\"\n             (buttonClick)=\"emitImage()\">\n  </sp-button>\n</div>\n",
        styles: [":host input{display:none}:host .registry-button{align-self:flex-end;justify-self:flex-end}:host .bottom-button{position:absolute;z-index:2}:host .image-container{display:flex;align-items:flex-end;justify-content:flex-end;max-width:600px;max-height:300px;min-width:300px;min-height:100px;border:2px solid #f8b133;border-radius:2px;box-sizing:content-box;overflow:hidden}:host .img{-o-object-fit:fill;object-fit:fill;max-width:300px;max-height:300px;width:auto;height:auto;z-index:1}:host .input{display:none}:host .submitbutton{width:300px}"]
    })
], SpImageComponent);

let SpImageModule = class SpImageModule {
};
SpImageModule = __decorate([
    NgModule({
        declarations: [SpImageComponent],
        imports: [
            CommonModule,
            SpButtonModule,
            SpIconModule,
            ReactiveFormsModule,
            MatIconModule,
            MatButtonModule,
            TranslateModule
        ],
        exports: [SpImageComponent]
    })
], SpImageModule);

let SpFileUploaderComponent = class SpFileUploaderComponent {
    constructor() {
        /**
      * Proprietà di @Input().
      * Definisce il tooltip del bottone di caricamento
      */
        this.buttonTooltip = '';
        this.fileSelected = new EventEmitter();
    }
    storeFile(changeEvent) {
        if (changeEvent.target.files && changeEvent.target.files[0]) {
            const reader = new FileReader();
            reader.onload = element => {
                this.fileSource = element.target.result;
            };
            reader.readAsDataURL(changeEvent.target.files[0]);
            this.selectedFile = changeEvent.target.files[0];
            this.emitFile();
        }
    }
    emitFile() {
        if (!!this.selectedFile) {
            this.fileSelected.emit({ file: this.selectedFile, fileSource: this.fileSource });
        }
    }
};
__decorate([
    Input()
], SpFileUploaderComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpFileUploaderComponent.prototype, "fileType", void 0);
__decorate([
    Input()
], SpFileUploaderComponent.prototype, "buttonColor", void 0);
__decorate([
    Input()
], SpFileUploaderComponent.prototype, "buttonTooltip", void 0);
__decorate([
    Output()
], SpFileUploaderComponent.prototype, "fileSelected", void 0);
SpFileUploaderComponent = __decorate([
    Component({
        selector: 'sp-file-uploader',
        template: "<div class=\"file-container\">\n\n  <div class=\"bottom-button\">\n    <sp-button [fontIcon]=\"'upload'\" [tooltip]=\"buttonTooltip | translate\" [buttonColor]=\"buttonColor\" class=\"button-inline\" [id]=\"'pdf-accepter-skip'\" [label]=\"label | translate\"\n      (buttonClick)=\"fileUploader.click()\">\n    </sp-button>\n\n  </div>\n  <label for=\"file-input\"></label>\n  <input name=\"file-input\" id=\"file-input\" type=\"file\" accept=\"fileType\" (change)=\"storeFile($event)\" #fileUploader class=\"input\" />\n</div>",
        styles: [":host input{display:none}:host .registry-button{align-self:flex-end;justify-self:flex-end}:host .bottom-button{z-index:2}:host .file-container{display:flex;align-items:flex-end;justify-content:flex-end}:host .submitbutton{width:300px}"]
    })
], SpFileUploaderComponent);

let SpFileUploaderModule = class SpFileUploaderModule {
};
SpFileUploaderModule = __decorate([
    NgModule({
        declarations: [SpFileUploaderComponent],
        imports: [
            CommonModule,
            SpButtonModule,
            SpIconModule,
            ReactiveFormsModule,
            MatIconModule,
            MatButtonModule,
            TranslateModule
        ],
        exports: [SpFileUploaderComponent]
    })
], SpFileUploaderModule);

let SpLoaderComponent = class SpLoaderComponent {
    get hasRightValueAlignment() {
        return this.flagBackgroundVisible;
    }
};
__decorate([
    Input()
], SpLoaderComponent.prototype, "flagBackgroundVisible", void 0);
__decorate([
    Input()
], SpLoaderComponent.prototype, "flagPagePublic", void 0);
__decorate([
    Input()
], SpLoaderComponent.prototype, "flagLocalSpinner", void 0);
__decorate([
    HostBinding('class.spinner-transparent')
], SpLoaderComponent.prototype, "hasRightValueAlignment", null);
SpLoaderComponent = __decorate([
    Component({
        selector: 'sp-loader',
        template: "<div\n     [ngClass]=\"{'spinner': !flagPagePublic && !flagLocalSpinner, 'generic-spinner': flagPagePublic && !flagLocalSpinner}\">\n  <mat-spinner></mat-spinner>\n</div>\n",
        styles: [":host .spinner{display:flex;top:56px;height:calc(100% - 56px);width:100%;background-color:rgba(0,0,0,.32);position:absolute;z-index:999;align-items:center;justify-content:center}:host .generic-spinner{display:flex;height:100%;width:100%;background-color:rgba(0,0,0,.32);position:absolute;z-index:999;align-items:center;justify-content:center}:host.spinner-transparent .spinner{top:0;height:100%;background-color:rgba(0,0,0,.32)}"]
    })
], SpLoaderComponent);

let SpLoaderModule = class SpLoaderModule {
};
SpLoaderModule = __decorate([
    NgModule({
        declarations: [SpLoaderComponent],
        imports: [CommonModule, MatDialogModule, MatProgressSpinnerModule, MatSnackBarModule],
        exports: [SpLoaderComponent]
    })
], SpLoaderModule);

let SpForgotPasswordComponent = class SpForgotPasswordComponent {
    constructor() {
        this.returnToLogin = new EventEmitter();
        this.resetPassword = new EventEmitter();
    }
    ngOnInit() {
        this.forgotPasswordForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email])
        });
    }
    emitResetPassword() {
        this.resetPassword.emit(this.forgotPasswordForm.get('email').value);
    }
    emitReturnToLogin() {
        this.returnToLogin.emit();
    }
};
__decorate([
    Output()
], SpForgotPasswordComponent.prototype, "returnToLogin", void 0);
__decorate([
    Output()
], SpForgotPasswordComponent.prototype, "resetPassword", void 0);
SpForgotPasswordComponent = __decorate([
    Component({
        selector: 'sp-forgot-password',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"password-form\">\n      <form class=\"sp-grid\"\n            [formGroup]=\"forgotPasswordForm\">\n        <div class=\"sp-grid-cell-span-12\">\n          <h1 class=\"text-center login-title\">{{ 'UI_LIB.LOGIN.FORGOT_PASSWORD' | translate }}</h1>\n          <p class=\"subtitle\">{{ 'UI_LIB.LOGIN.RETRIEVE_PASSWORD' | translate }}</p>\n        </div>\n        <div class=\"sp-grid-cell-span-12\">\n          <sp-input [id]=\"'input-email'\"\n                    [label]=\"('UI_LIB.LOGIN.EMAIL' | translate) + ' *'\"\n                    formControlName=\"email\"></sp-input>\n        </div>\n        <div class=\"sp-grid-cell-span-6 aligned-to-start\">\n          <sp-button [buttonType]=\"'button'\"\n                     [id]=\"'forgot-pwd-btn-submit'\"\n                     [label]=\"'UI_LIB.LOGIN.RETURN_TO_LOGIN' | translate\"\n                     (buttonClick)=\"emitReturnToLogin()\">\n          </sp-button>\n        </div>\n        <div class=\"sp-grid-cell-span-6 aligned-to-end\">\n          <sp-button [buttonType]=\"'button'\"\n                     [id]=\"'forgot-pwd-btn-submit'\"\n                     [label]=\"'UI_LIB.LOGIN.SEND' | translate\"\n                     [flagDisabled]=\"forgotPasswordForm.invalid\"\n                     (buttonClick)=\"emitResetPassword()\">\n          </sp-button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .password-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}"]
    })
], SpForgotPasswordComponent);

let SpLoginComponent = class SpLoginComponent {
    constructor() {
        this.id = 'sp-login-default-id';
        this.username = '';
        this.flagShowForgotPw = true;
        this.forgotPassword = new EventEmitter();
        this.signingIn = new EventEmitter();
    }
    ngOnInit() {
        this.loginForm = new FormGroup({
            username: new FormControl(this.username, [Validators.required]),
            password: new FormControl('', [Validators.required]),
            rememberMe: new FormControl(this.username !== ''),
        });
    }
    submitUser() {
        this.signingIn.emit({
            username: this.loginForm.get('username').value,
            password: this.loginForm.get('password').value,
            flagRememberMe: this.loginForm.get('rememberMe').value
        });
    }
    submitOnEnter(key) {
        if (key.key === 'Enter' && this.loginForm.valid) {
            this.submitUser();
        }
    }
    emitForgotPassword() {
        this.forgotPassword.emit();
    }
};
__decorate([
    Input()
], SpLoginComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpLoginComponent.prototype, "username", void 0);
__decorate([
    Input()
], SpLoginComponent.prototype, "env", void 0);
__decorate([
    Input()
], SpLoginComponent.prototype, "flagShowForgotPw", void 0);
__decorate([
    Output()
], SpLoginComponent.prototype, "forgotPassword", void 0);
__decorate([
    Output()
], SpLoginComponent.prototype, "signingIn", void 0);
SpLoginComponent = __decorate([
    Component({
        selector: 'sp-login',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <ng-container *ngIf=\"env === 'staging'\">\n      <div class=\"env-title\">\n        {{ 'UI_LIB.STAGING_ENV' | translate }}\n      </div>\n    </ng-container>\n    <div class=\"logo\"></div>\n    <div class=\"login-form\">\n      <form class=\"sp-grid\"\n            [formGroup]=\"loginForm\">\n        <div class=\"sp-grid-cell-span-12\">\n          <h1 class=\"text-center login-title\">{{ 'UI_LIB.LOGIN.TITLE' | translate }}</h1>\n          <p class=\"subtitle\">{{ 'UI_LIB.LOGIN.ENTER_SMALLPAY' | translate }}</p>\n        </div>\n        <div class=\"sp-grid-cell-span-12\">\n          <sp-input [id]=\"'input-user'\"\n                    [label]=\"'UI_LIB.LOGIN.USERNAME' | translate\"\n                    formControlName=\"username\"\n                    (keydown)=\"submitOnEnter($event)\"></sp-input>\n        </div>\n        <div class=\"sp-grid-cell-span-12\">\n          <sp-input [id]=\"'input-password'\"\n                    [flagPassword]=\"true\"\n                    [label]=\"'UI_LIB.LOGIN.PASSWORD' | translate\"\n                    class=\"sp-top-spacing-l\"\n                    formControlName=\"password\"\n                    (keydown)=\"submitOnEnter($event)\"></sp-input>\n        </div>\n        <div class=\"sp-grid-cell-span-6\">\n          <sp-checkbox [id]=\"'input-remember-password'\"\n                       [label]=\"'UI_LIB.LOGIN.REMEMBER_PW' | translate\"\n                       formControlName=\"rememberMe\"\n                       (keydown)=\"submitOnEnter($event)\">\n          </sp-checkbox>\n        </div>\n        <div class=\"sp-grid-cell-span-6\">\n        </div>\n        <div class=\"sp-grid-cell-span-6 link-container\">\n          <ng-container *ngIf=\"flagShowForgotPw\">\n            <div>\n              <a class=\"forgot-password\"\n                 (click)=\"emitForgotPassword()\"> {{ 'UI_LIB.LOGIN.FORGOT_PASSWORD' | translate }}?</a>\n            </div>\n          </ng-container>\n        </div>\n        <div class=\"sp-grid-cell-span-6 aligned-to-end\">\n          <sp-button [buttonType]=\"'submit'\"\n                     [id]=\"'login-btn-submit'\"\n                     [label]=\"'UI_LIB.LOGIN.SUBMIT' | translate\"\n                     [flagDisabled]=\"loginForm.invalid\"\n                     (buttonClick)=\"submitUser()\">\n          </sp-button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .login-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}:host .link-container{display:flex;align-items:flex-start}:host .link-container div{margin-top:auto;margin-bottom:auto}:host .link-container div a{font-weight:700;cursor:pointer}:host .env-title{color:red;font-size:large;font-weight:700}"]
    })
], SpLoginComponent);

let ExpiredLinkComponent = class ExpiredLinkComponent {
    constructor() {
        this.returnToLogin = new EventEmitter();
    }
    emitReturnToLogin() {
        this.returnToLogin.emit();
    }
};
__decorate([
    Output()
], ExpiredLinkComponent.prototype, "returnToLogin", void 0);
ExpiredLinkComponent = __decorate([
    Component({
        selector: 'sp-expired-link',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"password-form\">\n      <div class=\"sp-grid\">\n        <div class=\"sp-grid-cell-span-12\">\n          <h1 class=\"text-center login-title\">{{ 'UI_LIB.LOGIN.LINK_EXPIRED' | translate }}</h1>\n          <p class=\"subtitle\">{{ 'UI_LIB.LOGIN.LINK_EXPIRED_HINT' | translate }}</p>\n        </div>\n        <div class=\"sp-grid-cell-span-12 aligned-to-end\">\n          <sp-button [buttonType]=\"'button'\"\n                     [id]=\"'forgot-pwd-btn-submit'\"\n                     [label]=\"'UI_LIB.LOGIN.RETURN_TO_LOGIN' | translate\"\n                     (buttonClick)=\"emitReturnToLogin()\">\n          </sp-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .password-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}"]
    })
], ExpiredLinkComponent);

let NewPasswordComponent = class NewPasswordComponent {
    constructor() {
        this.returnToLogin = new EventEmitter();
        this.changePassword = new EventEmitter();
    }
    ngOnInit() {
        this.passwordChangedForm = new FormGroup({
            password: new FormControl('', [Validators.required,
                Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?&].{7,}')]),
            confirmPassword: new FormControl('', [Validators.required,
                Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?&].{7,}')])
        });
    }
    get flagPassword() {
        return this.passwordChangedForm.get('password').value !== '' && !!this.passwordChangedForm.get('password').value;
    }
    get flagMatchingPasswords() {
        return this.flagPassword &&
            this.passwordChangedForm.get('password').value === this.passwordChangedForm.get('confirmPassword').value;
    }
    get displayFirstError() {
        return this.passwordChangedForm.get('password').touched ? this.passwordChangedForm.get('password').invalid : false;
    }
    get displaySecondError() {
        return this.passwordChangedForm.get('confirmPassword').touched ? this.passwordChangedForm.get('confirmPassword').invalid : false;
    }
    emitChangePassword() {
        if (this.flagMatchingPasswords) {
            this.changePassword.emit(this.passwordChangedForm.get('password').value);
        }
    }
    emitReturnToLogin() {
        this.returnToLogin.emit();
    }
    showErrorMessage() {
        return this.flagPassword && !this.flagMatchingPasswords && !this.passwordChangedForm.get('confirmPassword').pristine;
    }
};
__decorate([
    Output()
], NewPasswordComponent.prototype, "returnToLogin", void 0);
__decorate([
    Output()
], NewPasswordComponent.prototype, "changePassword", void 0);
NewPasswordComponent = __decorate([
    Component({
        selector: 'sp-new-password',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"password-form\">\n      <form class=\"sp-grid\"\n            [formGroup]=\"passwordChangedForm\">\n        <div class=\"sp-grid-cell-span-12\">\n          <h1 class=\"text-center login-title\">{{ 'UI_LIB.LOGIN.NEW_PASSWORD' | translate }}</h1>\n          <p class=\"subtitle\">{{ 'UI_LIB.LOGIN.NEW_PASSWORD_HINT' | translate }}</p>\n        </div>\n        <div class=\"sp-grid-cell-span-12\">\n          <sp-input [id]=\"'input-email'\"\n                    [flagPassword]=\"true\"\n                    [label]=\"'UI_LIB.LOGIN.PASSWORD' | translate\"\n                    [errorMessage]=\"('UI_LIB.VALIDATORS.PWD_ERROR' | translate) + ' *'\"\n                    [flagShowErrorMessage]=\"displayFirstError\"\n                    formControlName=\"password\"></sp-input>\n        </div>\n        <div class=\"sp-grid-cell-span-12\">\n          <sp-input [id]=\"'input-email'\"\n                    [flagPassword]=\"true\"\n                    [flagShowErrorMessage]=\"displaySecondError\"\n                    [label]=\"('UI_LIB.LOGIN.CONFIRM_PASSWORD' | translate) + ' *'\"\n                    [errorMessage]=\"'UI_LIB.VALIDATORS.PWD_ERROR' | translate\"\n                    formControlName=\"confirmPassword\"></sp-input>\n          <div class=\"hint-wrapper sp-top-spacing-l\">\n            <p class=\"password-hint\"\n               *ngIf=\"showErrorMessage()\">\n              {{ 'UI_LIB.LOGIN.NOT_MATCHING_PASSWORD' | translate }}</p>\n          </div>\n        </div>\n        <div class=\"sp-grid-cell-span-6 aligned-to-start\">\n          <sp-button [buttonType]=\"'submit'\"\n                     [label]=\"'UI_LIB.LOGIN.RETURN_TO_LOGIN' | translate\"\n                     (buttonClick)=\"emitReturnToLogin()\">\n          </sp-button>\n        </div>\n        <div class=\"sp-grid-cell-span-6 aligned-to-end\">\n          <sp-button [buttonType]=\"'submit'\"\n                     [label]=\"'UI_LIB.LOGIN.CONFIRM' | translate\"\n                     [flagDisabled]=\"passwordChangedForm.invalid || !flagMatchingPasswords\"\n                     (buttonClick)=\"emitChangePassword()\">\n          </sp-button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .password-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .password-form .password-hint{color:#d9001b;font-weight:600;padding-top:8px;padding-right:8px}:host .aligned-to-center .password-form .hint-wrapper{height:32px}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}"]
    })
], NewPasswordComponent);

let PasswordChangedComponent = class PasswordChangedComponent {
    constructor() {
        this.returnToLogin = new EventEmitter();
    }
    emitReturnToLogin() {
        this.returnToLogin.emit();
    }
};
__decorate([
    Output()
], PasswordChangedComponent.prototype, "returnToLogin", void 0);
PasswordChangedComponent = __decorate([
    Component({
        selector: 'sp-password-changed',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"password-form\">\n      <div class=\"sp-grid\">\n        <div class=\"sp-grid-cell-span-12\">\n          <h1 class=\"text-center login-title\">{{ 'UI_LIB.LOGIN.PASSWORD_CHANGED' | translate }}</h1>\n          <p class=\"subtitle\">{{ 'UI_LIB.LOGIN.PASSWORD_UPDATED' | translate }}</p>\n        </div>\n        <div class=\"sp-grid-cell-span-12 aligned-to-end\">\n          <sp-button [buttonType]=\"'button'\"\n                     [id]=\"'forgot-pwd-btn-submit'\"\n                     [label]=\"'UI_LIB.LOGIN.RETURN_TO_LOGIN' | translate\"\n                     (buttonClick)=\"emitReturnToLogin()\">\n          </sp-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .password-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}"]
    })
], PasswordChangedComponent);

let SpLoginModule = class SpLoginModule {
};
SpLoginModule = __decorate([
    NgModule({
        declarations: [SpLoginComponent, SpForgotPasswordComponent, ExpiredLinkComponent, NewPasswordComponent, PasswordChangedComponent],
        imports: [
            CommonModule,
            TranslateModule,
            ReactiveFormsModule,
            MatFormFieldModule,
            SpInputModule,
            SpCheckBoxModule,
            SpButtonModule
        ],
        exports: [SpLoginComponent, SpForgotPasswordComponent, ExpiredLinkComponent, NewPasswordComponent, PasswordChangedComponent]
    })
], SpLoginModule);

let SpMerchantRegisteredComponent = class SpMerchantRegisteredComponent {
    constructor() {
        this.routeToApplication = new EventEmitter();
    }
};
__decorate([
    Output()
], SpMerchantRegisteredComponent.prototype, "routeToApplication", void 0);
SpMerchantRegisteredComponent = __decorate([
    Component({
        selector: 'sp-merchant-registered',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"login-form\">\n      <div class=\"sp-grid-cell-span-12\">\n        <h1 class=\"text-center login-title\">{{ 'UI_LIB.WELCOME.TITLE' | translate }}</h1>\n      </div>\n      <div class=\"sp-grid-cell-span-12 aligned-to-center\">\n        <p> {{ 'UI_LIB.WELCOME.MESSAGE' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .login-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}"]
    })
], SpMerchantRegisteredComponent);

let SpMerchantRegisteredModule = class SpMerchantRegisteredModule {
};
SpMerchantRegisteredModule = __decorate([
    NgModule({
        declarations: [SpMerchantRegisteredComponent],
        imports: [
            CommonModule,
            SpButtonModule,
            TranslateModule
        ],
        exports: [SpMerchantRegisteredComponent]
    })
], SpMerchantRegisteredModule);

var SpMultiSelectComponent_1;
let SpMultiSelectComponent = SpMultiSelectComponent_1 = class SpMultiSelectComponent {
    constructor() {
        /**
         * @property {boolean} flagShowErrorMessage
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagShowErrorMessage = false;
        /**
         * @property {boolean} multiple
         * Proprietà di @Input().
         * Definisce l'identificativo della select
         */
        this.flagMultiple = false;
    }
    writeValue(val) {
        var _a;
        (_a = this.selectForm) === null || _a === void 0 ? void 0 : _a.setValue((val !== null && val !== void 0 ? val : []));
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    ngOnInit() {
        var _a;
        this.selectForm = new FormControl((_a = this.values, (_a !== null && _a !== void 0 ? _a : [])).filter(option => option.flagActive === true));
    }
    ngOnChanges(changes) {
        var _a;
        if (!!changes['values'] && !!this.selectForm) {
            this.selectForm.setValue((_a = this.values, (_a !== null && _a !== void 0 ? _a : [])).filter(option => option.flagActive === true));
        }
    }
    onChange(val) {
        // do nothing
    }
    emitChange(value) {
        this.onChange(value);
    }
    retrieveDisplayValue(item) {
        if (!!item) {
            if (!!this.displayFunction) {
                return this.displayFunction(item);
            }
            if (typeof item === 'string') {
                return item;
            }
        }
        return '';
    }
    compare(c1, c2) {
        return c1 && c2 && c1.id === c2.id;
    }
};
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "flagShowErrorMessage", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "flagMultiple", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "values", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpMultiSelectComponent.prototype, "displayFunction", void 0);
SpMultiSelectComponent = SpMultiSelectComponent_1 = __decorate([
    Component({
        selector: 'sp-multi-select',
        template: "<mat-form-field appearance=\"fill\"\n                color=\"accent\"\n                class=\"sp-form-field\">\n  <mat-label>{{ label | translate }}</mat-label>\n\n  <mat-select [id]=\"id\"\n              (selectionChange)=\"emitChange($event.value)\"\n              multiple\n              [formControl]=\"selectForm\"\n              [disabled]=\"flagDisabled\"\n              [compareWith]=\"compare\">\n\n    <sp-select-all-options *ngIf=\"flagMultiple\"\n                           [model]=\"selectForm\"\n                           [values]=\"values\"\n                           (multiSelection)=\"emitChange($event)\">\n    </sp-select-all-options>\n\n    <mat-option *ngFor=\"let value of values\"\n                [value]=\"value\">\n      {{ retrieveDisplayValue(value) }}\n    </mat-option>\n  </mat-select>\n\n</mat-form-field>\n\n<ng-container *ngIf=\"flagShowErrorMessage\">\n  <div class=\"error-message\">\n    <span [ngClass]=\"{'hidden': !flagShowErrorMessage}\"\n          class=\"message\">\n      {{ errorMessage | translate }}\n    </span>\n  </div>\n</ng-container>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpMultiSelectComponent_1) }
        ],
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpMultiSelectComponent);

let SpSelectAllOptionsComponent = class SpSelectAllOptionsComponent {
    constructor() {
        /**
         * @property {Array<string>} values
         * Proprietà di @Input().
         * Definisce l'array di valori iniziali del componente
         */
        this.values = [];
        /**
         * @property {EventEmitter<Array<string>>} multiSelection
         * Proprietà di @Output().
         * Emette i valori del componente
         */
        this.multiSelection = new EventEmitter();
    }
    ngOnInit() {
        this.model.setValue(this.values.filter(option => option.flagActive === true));
        this.multiSelection.emit(this.model.value);
    }
    isChecked() {
        return this.model.value && this.values.length
            && this.model.value.length === this.values.length;
    }
    toggleSelection(change) {
        if (change.checked) {
            this.model.setValue(this.values);
        }
        else {
            this.model.setValue([]);
        }
        this.multiSelection.emit(this.model.value);
    }
};
__decorate([
    Input()
], SpSelectAllOptionsComponent.prototype, "model", void 0);
__decorate([
    Input()
], SpSelectAllOptionsComponent.prototype, "values", void 0);
__decorate([
    Output()
], SpSelectAllOptionsComponent.prototype, "multiSelection", void 0);
SpSelectAllOptionsComponent = __decorate([
    Component({
        selector: 'sp-select-all-options',
        template: "<mat-checkbox class=\"mat-option\"\n              [checked]=\"isChecked()\"\n              (click)=\"$event.stopPropagation()\"\n              (change)=\"toggleSelection($event)\">\n  {{ 'UI_LIB.CHECKBOX.SELECT_ALL' | translate }}\n</mat-checkbox>\n"
    })
], SpSelectAllOptionsComponent);

let SpMultiSelectModule = class SpMultiSelectModule {
};
SpMultiSelectModule = __decorate([
    NgModule({
        declarations: [SpMultiSelectComponent, SpSelectAllOptionsComponent],
        imports: [
            MatSelectModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, CommonModule, TranslateModule, MatCheckboxModule
        ],
        exports: [SpMultiSelectComponent, SpSelectAllOptionsComponent]
    })
], SpMultiSelectModule);

const notificationStates = [
    'SUCCESS',
    'ERROR',
    'WARN',
    'ALERT',
    'INFO',
];

let SpNotificationsListComponent = class SpNotificationsListComponent {
    hasNotifications() {
        return !!this.notifications && this.notifications.length > 0;
    }
    retrieveIconName(status) {
        switch (status) {
            case 'SUCCESS':
                return 'check';
            case 'ERROR':
                return 'priority_high';
            case 'WARN':
            case 'ALERT':
                return 'calendar_today';
            case 'INFO':
            default:
                return 'notifications_none';
        }
    }
    retrieveIconColor(status) {
        switch (status) {
            case 'SUCCESS':
                return 'green';
            case 'ERROR':
                return 'red';
            case 'WARN':
            case 'ALERT':
                return 'yellow';
            case 'INFO':
            default:
                return 'cyan';
        }
    }
    retrieveParams(parameters) {
        // const params = {};
        // parameters.forEach((param, index) => params[`${index}`] = param);
        // return params;
        return Object.assign({}, parameters);
    }
};
__decorate([
    Input()
], SpNotificationsListComponent.prototype, "notifications", void 0);
SpNotificationsListComponent = __decorate([
    Component({
        selector: 'sp-notifications-list',
        template: "<div class=\"sp-top-padding-s\">\n  <ng-container *ngIf=\"hasNotifications(); else noNotifications\">\n    <ng-container *ngFor=\"let notification of notifications; let i = index\">\n      <p>\n        <sp-icon class=\"sp-rounded-icon\"\n                 [id]=\"'notification-icon-' + i\"\n                 [fontIcon]=\"retrieveIconName(notification.notificationType)\"\n                 [ngClass]=\"retrieveIconColor(notification.notificationType)\"></sp-icon>\n        <span> <strong>{{ notification.dateCreation | date:'dd/MM/yyyy' }} -\n            {{ notification.template | translate: retrieveParams(notification.parameters) }}</strong></span>\n      </p>\n    </ng-container>\n  </ng-container>\n  <ng-template #noNotifications>\n    <p>{{ 'SHARED.NOTIFICATION_LIST.NO_NOTIFICATIONS' | translate }}</p>\n  </ng-template>\n</div>\n",
        styles: [":host .sp-rounded-icon.cyan,:host .sp-rounded-icon.green,:host .sp-rounded-icon.red,:host .sp-rounded-icon.yellow{vertical-align:middle;margin-right:8px}:host .sp-rounded-icon{background-color:#fff}:host .sp-rounded-icon.red{color:#d9001b}:host .sp-rounded-icon.cyan{color:#02a7f0}:host .sp-rounded-icon.green{color:#1c9252}:host .sp-rounded-icon.yellow{color:#daa520}"]
    })
], SpNotificationsListComponent);

let SpNotificationListModule = class SpNotificationListModule {
};
SpNotificationListModule = __decorate([
    NgModule({
        declarations: [SpNotificationsListComponent],
        imports: [
            CommonModule,
            SpIconModule,
            TranslateModule
        ],
        exports: [
            CommonModule,
            SpNotificationsListComponent
        ]
    })
], SpNotificationListModule);

var SpNumberCounterComponent_1;
let SpNumberCounterComponent = SpNumberCounterComponent_1 = class SpNumberCounterComponent {
    constructor() {
        /**
         * @property {string} buttonColor
         * Proprietà di @Input().
         * Definisce il colore del bottone. opzioni disponibili: primary, accent, warn. Per lasciare il pulsante bianco, valorizzare a undefined
         */
        this.buttonColor = 'primary';
        this.addNumberLimit = 100;
        this.flagAllDisabled = false;
        this.defaultValue = 0;
        this.valueChanged = new EventEmitter();
        this.counter = 0;
    }
    get defaultValueInstallments() {
        var _a, _b;
        if (this.numbersEnabled && 1 === ((_a = this.numbersEnabled) === null || _a === void 0 ? void 0 : _a.length)) {
            return this.numbersEnabled[0];
        }
        else if (this.currentFormValue && this.numbersEnabled && 1 < ((_b = this.numbersEnabled) === null || _b === void 0 ? void 0 : _b.length)) {
            if (this.currentFormValue > 0 && this.numbersEnabled.includes(this.currentFormValue)) {
                return this.currentFormValue;
            }
            return 0;
        }
        else {
            return 0;
        }
    }
    ngOnChanges(changes) {
        if (changes && changes['numbersEnabled'] && changes['numbersEnabled'].currentValue) {
            this.counter = this.defaultValueInstallments;
            this.onChange(this.counter);
            this.valueChanged.emit(this.counter);
        }
    }
    writeValue(val) {
        if (!isNaN(val)) {
            this.counter = val;
        }
        else {
            this.counter = 0;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(isDisabled) {
        // do nothing
    }
    validate() {
        if (this.counter === 0) {
            return { invalid: true };
        }
        else {
            return this.flagAllDisabled ? { invalid: true } : false;
        }
    }
    onChange(value) {
        // do nothing
    }
    counterPlus() {
        var _a;
        if (((_a = this.numbersEnabled) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (this.counter < this.numbersEnabled[0]) {
                this.counter = this.numbersEnabled[0];
            }
            else {
                const currentNumberIndex = this.currentNumberIndex;
                this.counter = this.numbersEnabled[currentNumberIndex + 1 > (this.numbersEnabled.length - 1) ? this.numbersEnabled.length - 1 : currentNumberIndex + 1];
            }
        }
        else {
            this.counter = ++this.counter;
        }
        this.onChange(this.counter);
        this.valueChanged.emit(this.counter);
    }
    counterMinus() {
        var _a;
        if (((_a = this.numbersEnabled) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const currentNumberIndex = this.currentNumberIndex;
            this.counter = this.numbersEnabled[currentNumberIndex - 1 < 0 ? 0 : currentNumberIndex - 1];
        }
        else {
            this.counter = --this.counter;
        }
        this.onChange(this.counter);
        this.valueChanged.emit(this.counter);
    }
    get currentNumberIndex() {
        return this.numbersEnabled && this.numbersEnabled.reduce((foundIndex, numberEnabled, currentIndex) => {
            if (numberEnabled === this.counter) {
                foundIndex = currentIndex;
            }
            return foundIndex;
        }, null);
    }
    get isMinusDisabled() {
        var _a;
        if (this.flagAllDisabled) {
            return this.flagAllDisabled;
        }
        if (((_a = this.numbersEnabled) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.counter === this.numbersEnabled[0];
        }
        return this.counter < 1;
    }
    get isPlusDisabled() {
        var _a;
        if (this.flagAllDisabled) {
            return this.flagAllDisabled;
        }
        if (((_a = this.numbersEnabled) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.counter >= this.addNumberLimit ||
                this.numbersEnabled[0] > this.addNumberLimit ||
                (this.currentNumberIndex !== null && this.numbersEnabled[this.currentNumberIndex + 1] > this.addNumberLimit) ||
                this.counter === this.numbersEnabled[this.numbersEnabled.length - 1];
        }
        return this.counter >= this.addNumberLimit;
    }
};
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "buttonColor", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "addNumberLimit", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "flagAllDisabled", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "numbersEnabled", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "defaultValue", void 0);
__decorate([
    Input()
], SpNumberCounterComponent.prototype, "currentFormValue", void 0);
__decorate([
    Output()
], SpNumberCounterComponent.prototype, "valueChanged", void 0);
SpNumberCounterComponent = SpNumberCounterComponent_1 = __decorate([
    Component({
        selector: 'sp-number-counter',
        template: "<div class=\"label\">{{ label }}</div>\n<div class=\"flex\">\n  <sp-button [id]=\"'number-counter-minus'\"\n             [buttonColor]=\"buttonColor\"\n             [flagDisabled]=\"isMinusDisabled\"\n             fontIcon=\"remove\"\n             (buttonClick)=\"counterMinus()\">\n  </sp-button>\n  <div class=\"count-card\">\n    <h3 class=\"aligned-to-center\">\n      {{ counter }}\n    </h3>\n  </div>\n  <sp-button [id]=\"'number-counter-minus'\"\n             [buttonColor]=\"buttonColor\"\n             [flagDisabled]=\"isPlusDisabled\"\n             fontIcon=\"add\"\n             (buttonClick)=\"counterPlus()\">\n  </sp-button>\n</div>\n",
        providers: [
            { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpNumberCounterComponent_1) },
            { provide: NG_VALIDATORS, useExisting: SpNumberCounterComponent_1, multi: true }
        ],
        styles: [":host h3{margin:0!important;width:100%}:host .count-card{display:flex;border-radius:5px;box-shadow:0 2px 5px 1px rgba(0,0,0,.15);padding:8px 16px;margin:0 8px;background-color:#fff;min-width:90px;justify-items:center;align-content:center}:host .label{color:rgba(51,51,51,.6);font-size:small;padding-left:.5em;padding-bottom:.5em}"]
    })
], SpNumberCounterComponent);

let SpNumberCounterModule = class SpNumberCounterModule {
};
SpNumberCounterModule = __decorate([
    NgModule({
        declarations: [SpNumberCounterComponent],
        imports: [
            CommonModule,
            SpButtonModule
        ],
        exports: [SpNumberCounterComponent]
    })
], SpNumberCounterModule);

/**
 * Componente di input per importi decimali con separatore di migliaia
 * Accetta valori positivi
 *
 * @export
 * @class SpDecimalInputComponent
 * @typedef {SpDecimalInputComponent}
 * @implements {AfterViewInit}
 */
let SpDecimalInputComponent = class SpDecimalInputComponent {
    constructor(vcr, ngControl, renderer, cdr) {
        this.ngControl = ngControl;
        this.renderer = renderer;
        this.cdr = cdr;
        /**
         * Flag per determinare se mostrare il valore 0,00 quando vuoto
         * @type {boolean}
         */
        this.flagShowZeroValue = true;
        /**
         * @property {boolean} flagPassword
         * Proprietà di @Input().
         * Definisce se il form è o meno abilitato
         */
        this.flagDisabled = false;
        /**
         * @property {boolean} flagTooltipDisabled
         * Proprietà di @Input().
         * Mostra il messaggio di errore
         */
        this.flagTooltipDisabled = false;
        /**
         * Proprietà di @Output().
         * Definisce l'evento che viene scatenato al blur dell'input
         *
         * @type {EventEmitter<void>}
         */
        this.blurEvent = new EventEmitter();
        /**
         * Classe relativa a tutti gli input
         *
         * @readonly
         * @type {true}
         */
        this.flagGenericClass = true;
        /**
         * Classe relativa allo specifico input per gli importi
         *
         * @readonly
         * @type {true}
         */
        this.flagSpecificClass = true;
        /**
         * Classe che gestisce l'allineamento interno dell'input
         *
         * @readonly
         * @type {true}
         */
        this.flagRightAligned = true;
        /**
         * Numero di decimali gestiti dal componente
         *
         * @private
         * @readonly
         * @type {2}
         */
        this.numberOfDecimals = 2;
        /**
         * Funzione che se invocata scatena l'evento di StatusChange associato al FormControl rappresentato dal componente.
         * La variazione di stato riflette la proprietà di touched del FormControl.
         * La funzione serve a trasmettere la variazione dello stato del componente al FormGroup a cui è associato.
         * @param {*} _status valore associato al FormControl.
         */
        this.onTouched = (_status) => {
            // Da implementare nell'esetensione
        };
        /**
         * Funzione che se invocato scatena l'evento di ValueChange associato al FormControl rappresentato dal componente.
         * La funzione serve a trasmettere la variazione del valore del componente al FormGroup a cui è associato.
         * @param {*} _newVal valore associato al FormControl.
         */
        this.onChange = _newVal => {
            // Da implementare nell'esetensione
        };
        this.ngControl.valueAccessor = this;
    }
    /**
     * Getter per l'elemento di input HTML
     *
     * @readonly
     * @type {HTMLInputElement}
     */
    get nativeElement() {
        var _a;
        return (_a = this.currencyInput) === null || _a === void 0 ? void 0 : _a.nativeElement;
    }
    /**
     * Flag ricavato a partire dai validatori impostati sul form control, assume valore true se il campo è obbligatorio e viceversa.
     * @returns {boolean}
     */
    get flagRequired() {
        if (this.formControl && this.formControl.validator) {
            const validator = this.formControl.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
        return false;
    }
    /**
     * Tooltip collegato all'errore del formcontrol
     *
     * @readonly
     * @type {string}
     */
    get tooltipErrorMessage() {
        var _a, _b;
        if (this.flagTooltipDisabled || ((_a = this.formControl) === null || _a === void 0 ? void 0 : _a.untouched) || ((_b = this.formControl) === null || _b === void 0 ? void 0 : _b.valid)) {
            return null;
        }
        return this.errorMessage || this.defaultErrorMessage;
    }
    /**
     * Tooltip di default collegato all'errore del formcontrol
     *
     * @readonly
     * @type {string}
     */
    get defaultErrorMessage() {
        var _a;
        if ((_a = this.formControl) === null || _a === void 0 ? void 0 : _a.hasError('required')) {
            return 'SHARED.INPUT.ERRORS.REQUIRED';
        }
        return 'SHARED.INPUT.ERRORS.INVALID';
    }
    /**
     * Ancora del ciclo di vita di Angular.
     * Si occupa dell'aonChangessegnazione della variabile formControl a partire dall'istanza di NgControl iniettata nel costruttore.
     */
    ngOnInit() {
        this.formControl = this.ngControl.control;
    }
    /**
     * Metodo implementato dall'interfaccia ControlValueAccessor.
     * Il metodo è invocato quando l'oggetto FormGroup è istanziato identifica il metodo responsabile di trasmettere i cambiamenti
     * di valore dal componente al FormGroup.
     * @param {*} fn funzione definita all'interno dell'interfaccia per la gestione dell'evento di ValueChange
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * Metodo implementato dall'interfaccia ControlValueAccessor.
     * Il metodo è invocato quando l'oggetto FormGroup è istanziato identifica il metodo responsabile di trasmettere i cambiamenti
     * di stato dal componente al FormGroup.
     * @param {*} fn funzione definita all'interno dell'interfaccia per la gestione dell'evento di StatusChange
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * Ancora del cilco di vita di Angular.
     * Allinea il valore del formcontrol a quello gestito nell'input
     */
    ngAfterViewInit() {
        if (this.formControl) {
            this.writeValue(this.formControl.value);
        }
    }
    /**
     * Implementazione dell'interfaccia ControlValueAccessor richiamato dai metodi setValue()/patchValue()
     * @param {string|number} value valore del form control
     */
    writeValue(value, selectionRange) {
        if (value !== this.value) {
            this.value = value;
        }
        if (this.nativeElement) {
            const currentValue = this.retrieveCurrentValue(value);
            this.renderer.setProperty(this.nativeElement, 'value', currentValue);
            this.cdr.detectChanges();
            if (selectionRange !== undefined) {
                this.nativeElement.setSelectionRange(selectionRange, selectionRange);
            }
        }
    }
    /**
     * Implementazione dell'interfaccia ControlValueAccessor richiamato dai metodi enable()/disable()
     * @param {boolean} flagDisabled true se il componente è da disabilitare
     */
    setDisabledState(flagDisabled) {
        this.flagDisabled = flagDisabled;
    }
    /**
     * Gestisce l'evento di pressione di un tasto da trastiera.
     * In caso di pressione di un tasto invalido (lettere, simboli...) blocca l'evento.
     * Gestisce la posizione del cursore per alcuni casi speciali del tasto Canc e Backspace
     * @param {KeyboardEvent} event
     */
    onKeydown(event) {
        const target = event.target;
        const subsequentElement = target.value.substring(target.selectionStart, target.selectionStart + 1);
        const previousElement = target.value.substring(target.selectionStart - 1, target.selectionStart);
        if (this.checkPreventKeydown(event, target, subsequentElement)) {
            event.preventDefault();
        }
        if (previousElement === ',' && event.key === 'Backspace') {
            event.preventDefault();
            const finalPosition = target.selectionStart - 1;
            target.setSelectionRange(finalPosition, finalPosition);
        }
        if (subsequentElement === ',' && (event.key === 'Delete' || event.key === '.' || event.key === ',')) {
            event.preventDefault();
            const finalPosition = target.selectionStart + 1;
            target.setSelectionRange(finalPosition, finalPosition);
        }
    }
    /**
     * Gestisce l'evento di rialzarsi di un tasto da trastiera.
     * Per il tasto Canc e Backspace aggiorna il valore dell'input
     * @param {KeyboardEvent} event
     */
    onKeyup(event) {
        const target = event.target;
        if (event.key === 'Backspace' || event.key === 'Delete') {
            let numberValue;
            if (target.selectionStart > target.value.indexOf(',')) {
                const firstPart = target.value.substring(0, target.selectionStart);
                const secondPart = target.value.substring(target.selectionStart);
                const insertValue = `${firstPart}0${secondPart}`;
                numberValue = this.formatAmountToNumber(insertValue);
            }
            else {
                numberValue = this.formatAmountToNumber(this.nativeElement.value);
            }
            let finalPosition;
            if (event.key === 'Backspace') {
                finalPosition = this.decreaseSelectionStart(target);
            }
            else {
                finalPosition = target.selectionStart;
            }
            numberValue = numberValue > 0 ? numberValue : null;
            this.writeValue(numberValue, finalPosition);
            this.onChange(numberValue);
        }
    }
    /**
     * Gestisce l'evento di input.
     * Richiama il metodo per la gestione del valore che simula il comportamento del tasto [Ins] e aggiorna il valore del formcontrol
     * @param {KeyboardEvent} event
     */
    onInput(event) {
        const inputEvent = event;
        if (inputEvent.data && inputEvent.data !== ' ') {
            this.insert(inputEvent);
        }
        this.onTouched();
        this.onChange(this.formatValueToNumber(this.nativeElement.value));
    }
    /**
     * Applica lo stato di touched al form control in corrispondenza dell'evento di blur
     */
    blur() {
        this.onTouched();
        this.blurEvent.emit();
    }
    /**
     * Metodo che gestisce la scrittura nell'input simulando il tasto [Ins]. Qualora sia presente sostituisce il caratter successivo con il carattere inputato.
     * @param {InputEvent} event
     */
    insert(event) {
        const target = event.target;
        const value = target.value;
        const subsequentElement = value.substring(target.selectionStart, target.selectionStart + 1);
        const selectionStart = this.retrieveSelectionStart(subsequentElement, target.selectionStart);
        let newPosition = selectionStart;
        const firstPart = value.substring(0, selectionStart);
        let secondPart;
        if (subsequentElement === ',') {
            secondPart = value.substring(selectionStart);
        }
        else {
            secondPart = value.substring(selectionStart + 1);
        }
        const insertValue = `${firstPart}${secondPart}`;
        const numberValue = this.formatAmountToNumber(insertValue);
        this.writeValue(numberValue);
        if (subsequentElement === ',') {
            newPosition = this.nativeElement.value.indexOf(',');
        }
        target.setSelectionRange(newPosition, newPosition);
    }
    /**
     * Determina la posizione del cursore in caso di tasto [Backspace]
     * @param {HTMLInputElement} target
     * @returns {number} nuovo valore della selezione
     */
    decreaseSelectionStart(target) {
        const { selectionStart, value } = target;
        if (selectionStart > value.indexOf(',') || selectionStart - 1 < 0) {
            return target.selectionStart;
        }
        return selectionStart;
    }
    /**
     * Determina la posizione del cursore in caso di evento di input
     * @param {string} target
     * @param {number} selectionStarta
     * @returns {number} nuovo valore della selezione
     */
    retrieveSelectionStart(subsequentElement, selectionStart) {
        if (subsequentElement === ',' || subsequentElement === '.') {
            return selectionStart + 1;
        }
        return selectionStart;
    }
    /**
     * Determina la condizione per cui evitare l'evento di keydown.
     * Verifica tre condizioni:
     * - la pressione di un tasto ammissibile: Frecce, Cancellazione oppure numerico
     * - l'inserimento del numero consentito di decimali
     * - l'inserimento di punteggiatura
     *
     * @param {KeyboardEvent} event
     * @param {HTMLInputElement} target
     * @param {string} subsequentElement
     * @returns {boolean} true se l'evento di keydown è preventuo
     */
    checkPreventKeydown(event, target, subsequentElement) {
        const flagTabPressed = event.key.includes('Tab');
        const flagArrowPressed = event.key.includes('Arrow');
        const flagRemoveChar = event.key === 'Backspace' || event.key === 'Delete';
        const flagKeyAllowed = flagTabPressed || flagArrowPressed || flagRemoveChar || /\b[0-9]\b/.test(event.key);
        const flagExeedingDecimals = /\b[0-9]\b/.test(event.key) && target.selectionStart - target.value.indexOf(',') > this.numberOfDecimals;
        const flagPunctuationPressed = subsequentElement !== ',' && (event.key === '.' || event.key === ',');
        return !flagKeyAllowed || flagExeedingDecimals || flagPunctuationPressed;
    }
    retrieveCurrentValue(value) {
        if (this.flagShowZeroValue) {
            return this.formatImporto(value);
        }
        if (!!value || Number(value) > 0) {
            return this.formatImporto(value);
        }
        return null;
    }
    /**
     * Converte un importo formattato con separatori di migliaia nel relativo valore numerico
     * @param value importo formattato con separatori di migliaia
     * @returns {number} importo numerico
     */
    formatAmountToNumber(value) {
        if (isNaN(Number(value.trim()))) {
            return Number(value.trim().replace(/\./g, '').replace(',', '.'));
        }
        return Number(value.trim());
    }
    /**
     * Converte una stringa formattato come numero con separatori di migliaia nel relativo valore numerico
     * @param value importo formattato con separatori di migliaia
     * @returns {number} importo numerico
     */
    formatValueToNumber(value) {
        if (!!value) {
            return Number(value.trim().replace(/\./g, '').replace(',', '.'));
        }
        return Number(value.trim());
    }
    /**
     * Formatta il numero in valuta tramite la funzione formatCurrency di Angular Common impostando il codice divisa a 'EUR', impostando il
     * numero minimo e massimo di decimali da visualizzare; non accoda il codice divisa al numero formattato.
     * @param {number} value il numero da formattare
     * @param {string} locale codice relativo alla lingua utilizzata nel browser
     * @param {number} minDecimalDigits numero minimo di cifre dopo la virgola, default a 2
     * @param {number} maxDecimalDigits numero massimo di cifre dopo la virgola, default a 2
     * @returns {string} la stringa formattata
     */
    formatValuta(value, locale, minDecimalDigits = 2, maxDecimalDigits = 2) {
        return formatCurrency(value, locale, '', 'EUR', `1.${minDecimalDigits}-${maxDecimalDigits}`);
    }
    /**
     * Formatta gli importi in base alla lingua del browser (se presente come parametro)
     * Segnalazione Sonar: il metodo riceve un qualsiasi possibile evento da tastiera
     * @param {*} value valore da formattare
     * @param {*} args numero massimo di decimali
     * @param {string} currentLocale la stringa contenente la lingua utilizzata nel browser
     * @returns {string} importo formattato
     */
    formatImporto(value, args, currentLocale = 'it-IT') {
        const minDecimals = 2;
        let maxDecimals = 2;
        if (args) {
            maxDecimals = args;
        }
        if (value !== null && value !== undefined) {
            let numericValue;
            if (typeof value === 'string') {
                numericValue = +value;
                if (isNaN(numericValue)) {
                    return value.replace(value, args);
                }
            }
            if (value === 0 || value === Infinity) {
                return this.formatValuta(0, currentLocale).trim();
            }
            return this.formatValuta(value, currentLocale, minDecimals, maxDecimals).trim();
        }
        return null;
    }
};
SpDecimalInputComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: NgControl },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "maxLength", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "minLength", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "flagShowZeroValue", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "flagDisabled", void 0);
__decorate([
    Input()
], SpDecimalInputComponent.prototype, "flagTooltipDisabled", void 0);
__decorate([
    Output()
], SpDecimalInputComponent.prototype, "blurEvent", void 0);
__decorate([
    HostBinding('class.popso-input')
], SpDecimalInputComponent.prototype, "flagGenericClass", void 0);
__decorate([
    HostBinding('class.popso-currency-input')
], SpDecimalInputComponent.prototype, "flagSpecificClass", void 0);
__decorate([
    HostBinding('class.right-aligned')
], SpDecimalInputComponent.prototype, "flagRightAligned", void 0);
__decorate([
    ViewChild('currencyInput')
], SpDecimalInputComponent.prototype, "currencyInput", void 0);
SpDecimalInputComponent = __decorate([
    Component({
        selector: 'sp-decimal-input',
        template: "<div>\n  <mat-form-field appearance=\"outline\" color=\"accent\" class=\"ui-form-field\">\n    <mat-label>{{ label | translate }}</mat-label>\n    <input\n\t\t\t#currencyInput\n      matInput\n      [id]=\"id\"\n      [placeholder]=\"placeholder\"\n      [type]=\"'text'\"\n      [disabled]=\"flagDisabled\"\n      [required]=\"flagRequired\"\n      (keydown)=\"onKeydown($event)\"\n      (keyup)=\"onKeyup($event)\"\n      (input)=\"onInput($event)\"\n      (click)=\"currencyInput.select()\"\n    />\n  </mat-form-field>\n</div>\n",
        styles: [".hidden{visibility:hidden}.message{position:absolute}"]
    })
], SpDecimalInputComponent);

let SpDecimalInputModule = class SpDecimalInputModule {
};
SpDecimalInputModule = __decorate([
    NgModule({
        declarations: [
            SpDecimalInputComponent,
        ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatFormFieldModule,
            MatInputModule,
            MatButtonModule,
            MatIconModule,
            TranslateModule
        ],
        exports: [
            SpDecimalInputComponent
        ]
    })
], SpDecimalInputModule);

let SpOperationInProgressComponent = class SpOperationInProgressComponent {
};
SpOperationInProgressComponent = __decorate([
    Component({
        selector: 'sp-operation-in-progress',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"login-form\">\n      <div class=\"sp-grid-cell-span-12\">\n        <h1 class=\"text-center login-title\">{{ 'UI_LIB.PROGRESS_OPERATION.TITLE' | translate }}</h1>\n      </div>\n      <div class=\"sp-grid-cell-span-12 aligned-to-center\">\n        <p> {{ 'UI_LIB.PROGRESS_OPERATION.BODY' | translate }}</p>\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:640px;height:149px;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom}:host .aligned-to-center .login-form{margin:0 auto;width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}:host .link-container{display:flex;align-items:flex-start}:host .link-container div{margin-top:auto;margin-bottom:auto}:host .link-container div a{font-weight:700;cursor:pointer}"]
    })
], SpOperationInProgressComponent);

let SpOperationInProgressModule = class SpOperationInProgressModule {
};
SpOperationInProgressModule = __decorate([
    NgModule({
        declarations: [SpOperationInProgressComponent],
        imports: [
            CommonModule,
            TranslateModule
        ],
        exports: [
            SpOperationInProgressComponent
        ]
    })
], SpOperationInProgressModule);

let SpPaymentCongratsComponent = class SpPaymentCongratsComponent {
    constructor() {
        this.routeToHome = new EventEmitter();
    }
    emitGoToHome() {
        this.routeToHome.emit();
    }
};
__decorate([
    Output()
], SpPaymentCongratsComponent.prototype, "routeToHome", void 0);
__decorate([
    Input()
], SpPaymentCongratsComponent.prototype, "flagTokenExists", void 0);
SpPaymentCongratsComponent = __decorate([
    Component({
        selector: 'sp-payment-congrats',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\"/>\n\n  <div class=\"sell-preview__container\">\n    <img src=\"./assets/img/small_pay_logo_big.png\"\n         class=\"sell-preview__logo\"\n         alt=\"\"/>\n\n    <div class=\"sell-preview__content\">\n      <h1 [innerHTML]> {{ 'UI_LIB.SELL_PREVIEW.CONGRATS' | translate }}</h1>\n      <h4 class=\"text-center\">{{ 'UI_LIB.SELL_PREVIEW.CONGRATS_TEXT' | translate }}</h4>\n      <ng-container *ngIf=\"flagTokenExists\">\n        <div class=\"sp-grid-cell-span-12 sp-top-spacing-l aligned-to-center\">\n          <sp-button class=\"button-inline\"\n                     [id]=\"'congrats-return-to-dashboard'\"\n                     [label]=\"'UI_LIB.BUTTON.TO_HOME' | translate\"\n                     (buttonClick)=\"emitGoToHome()\">\n          </sp-button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{justify-content:center;top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .sp-grid-container .table-head{background-color:#fc7335;border-radius:5px;margin:0 5px;color:#fff;font-weight:700;flex-grow:1;flex-basis:0}:host .sp-grid-container .table-item{font-weight:700;flex-grow:1;flex-basis:0}:host .sell-preview__container{display:flex;flex-direction:column;justify-content:center;z-index:1}:host .sell-preview__logo{width:100%;-o-object-fit:cover;object-fit:cover}:host .sell-preview__content{display:flex;flex-direction:column;background:#fff;margin:32px 0 24px;padding:20px;border-radius:10px}:host .sell-preview__content h1{color:#f8b133;text-align:center}"]
    })
], SpPaymentCongratsComponent);

let SpPaymentCongratsModule = class SpPaymentCongratsModule {
};
SpPaymentCongratsModule = __decorate([
    NgModule({
        declarations: [SpPaymentCongratsComponent],
        imports: [
            CommonModule,
            TranslateModule,
            SpButtonModule,
        ],
        exports: [SpPaymentCongratsComponent]
    })
], SpPaymentCongratsModule);

let SpPaymentKoComponent = class SpPaymentKoComponent {
    constructor() {
        this.routeToHome = new EventEmitter();
    }
    emitGoToHome() {
        this.routeToHome.emit();
    }
};
__decorate([
    Input()
], SpPaymentKoComponent.prototype, "koMessage", void 0);
__decorate([
    Input()
], SpPaymentKoComponent.prototype, "flagTokenExists", void 0);
__decorate([
    Output()
], SpPaymentKoComponent.prototype, "routeToHome", void 0);
SpPaymentKoComponent = __decorate([
    Component({
        selector: 'sp-payment-ko',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\"/>\n\n  <div class=\"sell-preview__container\">\n    <img src=\"./assets/img/small_pay_logo_big.png\"\n         class=\"sell-preview__logo\"\n         alt=\"\"/>\n    <div class=\"sell-preview__content\">\n      <h1 [innerHTML]> {{ 'UI_LIB.SELL_PREVIEW.CAUTION' | translate }}</h1>\n      <h4 class=\"text-center\">{{ 'UI_LIB.SELL_PREVIEW.PAYMENT_KO' | translate }}</h4>\n      <h4 class=\"text-center\">{{ koMessage }}</h4>\n      <ng-container *ngIf=\"flagTokenExists\">\n        <div class=\"sp-grid-cell-span-12 sp-top-spacing-l aligned-to-center\">\n          <sp-button class=\" button-inline\"\n                     [id]=\"'congrats-return-to-dashboard'\"\n                     [label]=\"'UI_LIB.BUTTON.TO_HOME' | translate\"\n                     (buttonClick)=\"emitGoToHome()\">\n          </sp-button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{justify-content:center;top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .sp-grid-container .table-head{background-color:#fc7335;border-radius:5px;margin:0 5px;color:#fff;font-weight:700;flex-grow:1;flex-basis:0}:host .sp-grid-container .table-item{font-weight:700;flex-grow:1;flex-basis:0}:host .sell-preview__container{display:flex;flex-direction:column;justify-content:center;z-index:1}:host .sell-preview__logo{width:100%;-o-object-fit:cover;object-fit:cover}:host .sell-preview__content{display:flex;flex-direction:column;background:#fff;margin:32px 0 24px;padding:20px;border-radius:10px}:host .sell-preview__content h1{color:#f8b133;text-align:center}"]
    })
], SpPaymentKoComponent);

let SpPaymentKoModule = class SpPaymentKoModule {
};
SpPaymentKoModule = __decorate([
    NgModule({
        declarations: [SpPaymentKoComponent],
        imports: [
            CommonModule,
            TranslateModule,
            SpButtonModule
        ],
        exports: [SpPaymentKoComponent]
    })
], SpPaymentKoModule);

var SpRadioButtonComponent_1;
let SpRadioButtonComponent = SpRadioButtonComponent_1 = class SpRadioButtonComponent {
    constructor() {
        this.flagValue = false;
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    writeValue(val) {
        this.value = val;
        if (this.value == null && this.radios) {
            this.radios.forEach((radio) => (radio.value = 'None'));
        }
    }
    registerOnChange(fn) {
        this.change = fn;
    }
    registerOnTouched(fn) {
        // do nothing
    }
    setDisabledState(flagDisabled) {
        // do nothing
    }
    change(value) {
        // do nothing
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
};
__decorate([
    ViewChildren(MatRadioGroup)
], SpRadioButtonComponent.prototype, "radios", void 0);
__decorate([
    Input()
], SpRadioButtonComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpRadioButtonComponent.prototype, "name", void 0);
__decorate([
    Input()
], SpRadioButtonComponent.prototype, "optionList", void 0);
SpRadioButtonComponent = SpRadioButtonComponent_1 = __decorate([
    Component({
        selector: 'sp-radio-button',
        template: "<mat-radio-group [value]=\"value\" class=\"radio-group-column\">\n  <ng-container *ngFor=\"let option of optionList; let i = index\">\n    <mat-radio-button color=\"accent\" [id]=\"id + '-' + i\" [value]=\"option.value\" (change)=\"change($event.value)\">\n      {{ option.label }}\n    </mat-radio-button>\n  </ng-container>\n</mat-radio-group>\n",
        providers: [{ provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => SpRadioButtonComponent_1) }],
        styles: [".radio-group-column{display:flex;flex-direction:column;gap:5px}"]
    })
], SpRadioButtonComponent);

let SpRadioButtonModule = class SpRadioButtonModule {
};
SpRadioButtonModule = __decorate([
    NgModule({
        declarations: [SpRadioButtonComponent],
        imports: [MatFormFieldModule, MatRadioModule, ReactiveFormsModule, CommonModule],
        exports: [SpRadioButtonComponent]
    })
], SpRadioButtonModule);

let SpRedirectMessageComponent = class SpRedirectMessageComponent {
};
__decorate([
    Input()
], SpRedirectMessageComponent.prototype, "counter", void 0);
__decorate([
    Input()
], SpRedirectMessageComponent.prototype, "sellResponseStatus", void 0);
SpRedirectMessageComponent = __decorate([
    Component({
        selector: 'sp-redirect-message',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\" />\n  <div class=\"aligned-to-center\">\n    <div class=\"logo\"></div>\n    <div class=\"login-form\">\n      <div class=\"sp-grid-cell-span-12\">\n        <h1 class=\"text-center login-title\"\n            [innerHTML]> {{ 'UI_LIB.SELL_PREVIEW.CAUTION' | translate }}</h1>\n      </div>\n      <div class=\"sp-grid-cell-span-12 sp-top-spacing-l\" *ngIf=\"!!sellResponseStatus\">\n        <h4 class=\"text-center\"\n            *ngIf=\"sellResponseStatus.result === 'OK'\">{{ 'UI_LIB.SELL_PREVIEW.CONGRATS_TEXT' | translate }}</h4>\n        <h4 class=\"text-center\"\n            *ngIf=\"sellResponseStatus.result === 'KO'\">{{ 'UI_LIB.SELL_PREVIEW.PAYMENT_KO' | translate }}</h4>\n        <h4 class=\"text-center bolded\"\n            *ngIf=\"sellResponseStatus.result === 'KO'\">\n          {{ sellResponseStatus.message }}\n        </h4>\n        <h4 class=\"text-center\">{{ 'UI_LIB.SELL_PREVIEW.REDIRECT_MESSAGE' | translate }}</h4>\n        <h2 class=\"text-center\">{{ counter }}</h2>\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .grow-1{flex-grow:1}:host .sp-grid-container .cardtitle{color:#fc7335}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .sp-grid-container .flex-col{display:flex;flex-direction:column}:host .sp-grid-container .flex-col .flex{flex-wrap:wrap}:host .sp-grid-container .flex-col .flex .bottom-divided{border-bottom:1px solid #fead88}:host .sp-grid-container .table-head{background-color:#fc7335;border-radius:5px;margin:0 5px;color:#fff;font-weight:700;flex-grow:1;flex-basis:0}:host .sp-grid-container .table-item{font-weight:700;flex-grow:1;flex-basis:0}:host .aligned-to-center{flex-direction:column;margin:0 auto;z-index:20}:host .aligned-to-center .logo{margin:0 auto 40px;width:100%;max-width:640px;height:0;background-color:transparent;background-image:url(assets/img/small_pay_logo_big.png);background-repeat:no-repeat;background-position:center bottom;padding-bottom:23.28125%;background-size:contain}:host .aligned-to-center .login-form{margin:0 auto;max-width:640px;padding:20px;border-radius:10px;background-color:#fff}:host .aligned-to-center .text-center{text-align:center}:host .aligned-to-center .subtitle{font-weight:600}:host .discaimer{display:flex;background-color:#fb3f0a;border-radius:16px;padding:16px;color:#fff;font-weight:700;flex-direction:column}:host .bolded{font-weight:700}"]
    })
], SpRedirectMessageComponent);

let SpRedirectMessageModule = class SpRedirectMessageModule {
};
SpRedirectMessageModule = __decorate([
    NgModule({
        declarations: [SpRedirectMessageComponent],
        imports: [
            CommonModule,
            TranslateModule,
            SpButtonModule
        ],
        exports: [SpRedirectMessageComponent]
    })
], SpRedirectMessageModule);

let SpSellPreviewComponent = class SpSellPreviewComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.flagShowLoader = true;
        this.flagShowModuleLoader = true;
        this.changePaymentMethod = false;
        this.returnToHome = new EventEmitter();
    }
    emitReturnToHome() {
        this.returnToHome.emit();
    }
    format(n) {
        return formatAmount(n, this.translateService);
    }
    get totalAmount() {
        return !!this.operation ? formatAmount(this.operation.amount, this.translateService) : undefined;
    }
    get expiryMonth() {
        return !!this.operation ? dateToYMD(addMonthsToDate(new Date(), this.operation.totalInstallments)) : undefined;
    }
};
SpSellPreviewComponent.ctorParameters = () => [
    { type: TranslateService }
];
__decorate([
    Input()
], SpSellPreviewComponent.prototype, "operation", void 0);
__decorate([
    Input()
], SpSellPreviewComponent.prototype, "flagShowLoader", void 0);
__decorate([
    Input()
], SpSellPreviewComponent.prototype, "flagShowModuleLoader", void 0);
__decorate([
    Input()
], SpSellPreviewComponent.prototype, "changePaymentMethod", void 0);
__decorate([
    Input()
], SpSellPreviewComponent.prototype, "customer", void 0);
__decorate([
    Output()
], SpSellPreviewComponent.prototype, "returnToHome", void 0);
SpSellPreviewComponent = __decorate([
    Component({
        selector: 'sp-sell-preview',
        template: "<div class=\"sp-grid-container mat-typography\">\n  <div class=\"overlay\"></div>\n  <div class=\"img-top-left\"></div>\n  <div class=\"img-bottom-left-2\"></div>\n  <div class=\"img-center-right\"></div>\n  <img class=\"resizable\"\n       src=\"./assets/img/login_person.png\"\n       alt=\"\"/>\n\n  <div class=\"sell-preview__container\">\n    <img src=\"./assets/img/small_pay_logo_big.png\"\n         class=\"sell-preview__logo\"\n         alt=\"\"/>\n\n    <div class=\"sell-preview__content\">\n      <h1>\n        {{ (changePaymentMethod ? 'UI_LIB.SELL_PREVIEW.CHANGE_PAYMENT_METHOD' : 'UI_LIB.SELL_PREVIEW.TITLE') | translate }}\n      </h1>\n\n      <div *ngIf=\"flagShowLoader\"\n           class=\"table-spinner aligned-to-center sp-bottom-spacing-l\">\n        <mat-progress-spinner color=\"warn\"\n                              mode=\"indeterminate\">\n        </mat-progress-spinner>\n      </div>\n\n      <ng-container *ngIf=\"!!operation\">\n        <sp-label-value class=\"sp-top-spacing-m\"\n                        [label]=\"'UI_LIB.SELL_PREVIEW.NAME'\"\n                        [value]=\"operation.payer.firstName\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n        <sp-label-value class=\"sp-top-spacing-m\"\n                        [label]=\"'UI_LIB.SELL_PREVIEW.SURNAME'\"\n                        [value]=\"operation.payer.lastName\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n        <ng-container *ngIf=\"!changePaymentMethod\">\n          <sp-label-value class=\"sp-top-spacing-m\"\n                          [label]=\"'UI_LIB.SELL_PREVIEW.INSTALLMENT_AMOUNT'\"\n                          [value]=\"totalAmount\"\n                          [valueAlignment]=\"'center'\"></sp-label-value>\n          <sp-label-value class=\"sp-top-spacing-m\"\n                          [label]=\"'UI_LIB.SELL_PREVIEW.EXPIRY_MONTH'\"\n                          [value]=\"expiryMonth\"\n                          [valueAlignment]=\"'center'\"></sp-label-value>\n        </ng-container>\n      </ng-container>\n      <div [class.hidden]=\"!flagShowModuleLoader\">\n        <div class=\"table-spinner sp-bottom-spacing-s sp-top-spacing-s aligned-to-center\">\n          <mat-progress-spinner class=\"aligned-to-center\" color=\"warn\" mode=\"indeterminate\"></mat-progress-spinner>\n        </div>\n      </div>\n      <div [class.hidden]=\"flagShowModuleLoader\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n\n    <div class=\"sell-preview__bank-logo\"\n         *ngIf=\"!flagShowLoader\">\n      powered by\n      <div class=\"sell-preview__bank-logo__img\"\n           [ngClass]=\"{\n                'sell-preview__bank-logo__img--nexi': operation.channel === 'NEXI',\n                'sell-preview__bank-logo__img--stripe': operation.channel === 'STRIPE' || operation.channel === 'STRIPE_SDD' || operation.channel === 'STRIPE_KLARNA' || operation.channel === 'STRIPE_ALMA' || operation.channel === 'STRIPE_SCALAPAY'\n              }\">\n      </div>\n    </div>\n  </div>\n</div>\n",
        styles: [":host .sp-grid-container{justify-content:center;top:0;height:100%;display:flex;background-color:transparent;background-image:linear-gradient(340deg,#ffc557 0,orange 100%);transition:background .3s,border .3s,border-radius .3s,box-shadow .3s}:host .sp-grid-container .overlay{z-index:0}:host .sp-grid-container .img-top-left{background-image:url(assets/img/login_credit_card.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:176px;height:116px;top:15%;left:calc(50% - 320px - 227px - 176px);position:absolute}:host .sp-grid-container .resizable{max-width:432px;max-height:679px;width:auto;height:65%;bottom:0;left:calc(50% - 320px - 127px - 432px);position:absolute}:host .sp-grid-container .img-bottom-left-2{background-image:url(assets/img/login_coin.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:146px;height:101px;bottom:15%;left:calc(50% - 320px - 146px);position:absolute}:host .sp-grid-container .img-center-right{background-image:url(assets/img/login_shield.png);background-position:center center;background-repeat:no-repeat;background-size:contain;width:109px;height:121px;top:40%;right:calc(50% - 320px - 103px - 109px);position:absolute}:host .sell-preview__container{display:flex;flex-direction:column;justify-content:center;z-index:1}:host .sell-preview__logo{width:100%;-o-object-fit:cover;object-fit:cover}:host .sell-preview__content{display:flex;flex-direction:column;background:#fff;margin:32px 0 24px;padding:20px;border-radius:10px}:host .sell-preview__content h1{color:#f8b133;text-align:center}:host .sell-preview__disclaimer{display:flex;flex-direction:column;background-color:#ffcb69;border-radius:16px;padding:16px;margin:24px 0;text-align:center;font-weight:700}:host .sell-preview__bank-logo{display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:24px}:host .sell-preview__bank-logo__img{background-size:contain;background-repeat:no-repeat;width:100px;height:33px}:host .sell-preview__bank-logo__img--nexi{background-image:url(assets/img/Nexi_Logo.png)}:host .sell-preview__bank-logo__img--stripe{background-image:url(assets/img/Stripe_Logo.png)}:host .hidden{opacity:0}"]
    })
], SpSellPreviewComponent);

let SpSellPreviewModule = class SpSellPreviewModule {
};
SpSellPreviewModule = __decorate([
    NgModule({
        declarations: [SpSellPreviewComponent],
        imports: [
            CommonModule,
            TranslateModule,
            SpButtonModule,
            MatProgressSpinnerModule,
            SpLabelValueModule
        ],
        exports: [
            SpSellPreviewComponent
        ]
    })
], SpSellPreviewModule);

const OPTION_TYPE = {
    full: 'full',
    yearMonth: 'year-month',
    year: 'year'
};
let SpReportFilterFormComponent = class SpReportFilterFormComponent {
    constructor() {
        this.filterValues = new EventEmitter();
        this.computedDates = {
            today: new Date(),
            startOfCurrentMonth: (() => {
                const date = new Date();
                return new Date(date.getFullYear(), date.getMonth(), 1);
            })(),
            startOfNextMonth: (() => {
                const date = new Date();
                return new Date(date.getFullYear(), date.getMonth() + 1, 1);
            })(),
        };
        this.destroy$ = new Subject();
    }
    get yearValues() {
        const start = 2018;
        const end = this.computedDates.today.getFullYear();
        const result = [];
        for (let year = start; year <= end; year++) {
            result.push(`${year}`);
        }
        return result;
    }
    ngOnInit() {
        this.filterForm.get('dateFrom').valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => {
            if (this.filterForm.get('dateTo')) {
                const innerValue = this.options.type === OPTION_TYPE.yearMonth
                    ? { date: new Date(value.year, value.month + 1, 0) }
                    : value;
                this.filterForm.get('dateTo').setValidators([this.minDateValidator(innerValue), Validators.required]);
                this.filterForm.get('dateTo').updateValueAndValidity();
            }
        });
    }
    ngOnChanges(changes) {
        if (JSON.stringify(changes.options.currentValue) === JSON.stringify(changes.options.previousValue)) {
            return;
        }
        if (!this.options.hideForm) {
            const dateFrom = new Date();
            this.filterForm = new FormGroup({
                dateFrom: new FormControl(this.computedDates.startOfCurrentMonth, Validators.required),
            });
            if (!this.options.showOnlyStartDate) {
                this.filterForm.addControl('dateTo', new FormControl(this.options.type === OPTION_TYPE.yearMonth && this.options.dateType === 'future'
                    ? this.computedDates.startOfNextMonth
                    : this.computedDates.today, [this.minDateValidator({ date: dateFrom }), Validators.required]));
            }
            if (this.localUnits) {
                this.filterForm.addControl('localUnit', new FormControl('', Validators.required));
            }
        }
        else {
            this.filterForm = new FormGroup({
                dateFrom: new FormControl(),
                dateTo: new FormControl()
            });
            this.filterForm.disable();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    get flagShowErrorMessageDataA() {
        var _a;
        return (_a = this.filterForm.get('dateTo')) === null || _a === void 0 ? void 0 : _a.invalid;
    }
    minDateValidator({ date }) {
        return (control) => {
            if (date && this.env === 'market') {
                const dateFrom = new Date(date);
                dateFrom.setHours(0, 0, 0, 0);
                const controlDate = (() => {
                    if (this.options.type === OPTION_TYPE.yearMonth) {
                        return new Date(control.value.year, control.value.month + 1, 0);
                    }
                    return control.value.date && control.value.date instanceof Date
                        ? control.value.date
                        : null;
                })();
                if (controlDate && controlDate < dateFrom) {
                    return { invalid: true };
                }
            }
            return null;
        };
    }
    displayLocalUnit(localUnit) {
        return localUnit.element.name;
    }
    yearChangeSelection(value) {
        this.filterForm.get('dateFrom').setValue(new Date(`1/1/${value}`), { onlySelf: true, emitEvent: false });
        this.filterForm.get('dateTo').setValue(new Date(`1/1/${++value}`), { onlySelf: true, emitEvent: false });
    }
    searchStatistics() {
        var _a;
        const formValues = this.filterForm.getRawValue();
        const dateStart = (() => {
            if (!formValues.dateFrom) {
                return undefined;
            }
            if (formValues.dateFrom instanceof Date) {
                return formValues.dateFrom;
            }
            return formValues.dateFrom.date instanceof Date
                ? formValues.dateFrom.date
                : new Date(`${formValues.dateFrom.month + 1}-1-${formValues.dateFrom.year}`);
        })();
        const dateEnd = (() => {
            if (!formValues.dateTo) {
                return undefined;
            }
            if (formValues.dateTo instanceof Date) {
                return formValues.dateTo;
            }
            return formValues.dateTo.date instanceof Date
                ? formValues.dateTo.date
                : new Date(formValues.dateTo.year, formValues.dateTo.month + 1, 0);
        })();
        const localUnity = ((_a = formValues.localUnit) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? formValues.localUnit.map(lu => lu.id)
            : [];
        this.filterValues.emit({ dateStart, dateEnd, localUnity });
    }
};
__decorate([
    Input()
], SpReportFilterFormComponent.prototype, "options", void 0);
__decorate([
    Input()
], SpReportFilterFormComponent.prototype, "env", void 0);
__decorate([
    Input()
], SpReportFilterFormComponent.prototype, "localUnits", void 0);
__decorate([
    Output()
], SpReportFilterFormComponent.prototype, "filterValues", void 0);
SpReportFilterFormComponent = __decorate([
    Component({
        selector: 'sp-report-filter-form',
        template: "<div class=\"sp-grid\">\n  <ng-container *ngIf=\"!options.hideForm\">\n    <div class=\"sp-grid-cell-span-3\"></div>\n    <div class=\"sp-grid-cell-span-6\">\n      <div class=\"formcard formcard-container\"\n           [ngClass]=\"{\n              'formcard-container--market': env === 'market', \n              'formcard-container--support': env === 'support'\n            }\">\n        <h3 class=\"aligned-to-center\">\n          {{ \"STATISTICS.SET_FILTERS\" | translate }}\n        </h3>\n\n        <form [formGroup]=\"filterForm\">\n          <div class=\"formcard\">\n            <ng-container [ngSwitch]=\"options.type\">\n              <!-- date range -->\n              <ng-container *ngSwitchCase=\"'full'\">\n                <div class=\"sp-top-spacing-l\">\n                  <sp-date-picker formControlName=\"dateFrom\"\n                                  [flaghighlightDate]=\"true\"\n                                  [label]=\"'STATISTICS.DATE_START'\"\n                                  [minDate]=\"options.dateType === 'future' ? computedDates.today : undefined\"\n                                  [maxDate]=\"options.dateType === 'past' ? computedDates.today : undefined\">\n                  </sp-date-picker>\n                </div>\n                <div class=\"sp-top-spacing-l\">\n                  <sp-date-picker formControlName=\"dateTo\"\n                                  [flaghighlightDate]=\"true\"\n                                  [label]=\"'STATISTICS.DATE_END'\"\n                                  [flagShowErrorMessage]=\"flagShowErrorMessageDataA\"\n                                  [errorMessage]=\"'STATISTICS.VALIDATION_RANGE_MESSAGE'\"\n                                  [minDate]=\"options.dateType === 'future' ? computedDates.today : undefined\"\n                                  [maxDate]=\"options.dateType === 'past' ? computedDates.today : undefined\">\n                  </sp-date-picker>\n                </div>\n              </ng-container>\n\n              <!-- monthly picker -->\n              <ng-container *ngSwitchCase=\"'year-month'\">\n                <div class=\"sp-top-spacing-l\">\n                  <sp-month-year-picker formControlName=\"dateFrom\"\n                                        [label]=\"'STATISTICS.DATE_START' | translate\"\n                                        [minDate]=\"options.dateType === 'future' ? computedDates.startOfCurrentMonth : undefined\"\n                                        [maxDate]=\"options.dateType === 'past' ? computedDates.today : undefined\">\n                  </sp-month-year-picker>\n                </div>\n                <div *ngIf=\"!options.showOnlyStartDate\"\n                     class=\"sp-top-spacing-l\">\n                  <sp-month-year-picker formControlName=\"dateTo\"\n                                        [label]=\"'STATISTICS.DATE_END' | translate\"\n                                        [minDate]=\"options.dateType === 'future' ? computedDates.startOfNextMonth : undefined\"\n                                        [maxDate]=\"options.dateType === 'past' ? computedDates.today : undefined\"\n                                        [flagShowErrorMessage]=\"flagShowErrorMessageDataA\"\n                                        [errorMessage]=\"'STATISTICS.VALIDATION_RANGE_MESSAGE'\">\n                  </sp-month-year-picker>\n                </div>\n              </ng-container>\n\n              <!-- year -->\n              <ng-container *ngSwitchCase=\"'year'\">\n                <sp-select [label]=\"'STATISTICS.DATE_START' | translate\"\n                           [values]=\"yearValues\"\n                           [flagIsAllAvailable]=\"false\"\n                           (changeSelection)=\"yearChangeSelection($event)\">\n                </sp-select>\n              </ng-container>\n            </ng-container>\n\n            <!-- local unit selector -->\n            <div class=\"sp-top-spacing-l\">\n              <sp-multi-select *ngIf=\"localUnits\"\n                               formControlName=\"localUnit\"\n                               [label]=\"'STATISTICS.LOCAL_UNIT' | translate\"\n                               [values]=\"localUnits\"\n                               [displayFunction]=\"displayLocalUnit\"\n                               [flagMultiple]=\"true\"\n                               [errorMessage]=\"'SHARED.ERRORS.MANDATORY' | translate\"></sp-multi-select>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </ng-container>\n\n  <div class=\"sp-grid-cell-span-12 aligned-to-center\">\n    <sp-button class=\"button-inline\"\n               (buttonClick)=\"searchStatistics()\"\n               [label]=\"'STATISTICS.SEARCH_STATS' | translate\"\n               [buttonColor]=\"'accent'\"\n               [flagDisabled]=\"filterForm.invalid && !filterForm.disabled\">\n    </sp-button>\n  </div>\n</div>\n",
        styles: [":host .formcard-container{color:#fff}:host .formcard-container--market{background-color:#fc5a11}:host .formcard-container--support{background-color:#128cab}:host .formcard-container--disabled{opacity:.6;pointer-events:none}"]
    })
], SpReportFilterFormComponent);

let SpPosLoaderComponent = class SpPosLoaderComponent {
    constructor() {
        this.onPOSInitialization = new EventEmitter();
    }
    initPostTransaction() {
        this.flagInitPosTransaction = true;
        this.onPOSInitialization.emit(this.flagInitPosTransaction);
    }
};
__decorate([
    Input()
], SpPosLoaderComponent.prototype, "flagInitPosTransaction", void 0);
__decorate([
    Output()
], SpPosLoaderComponent.prototype, "onPOSInitialization", void 0);
SpPosLoaderComponent = __decorate([
    Component({
        selector: 'sp-pos-loader',
        template: "<div class=\"sp-grid-cell-span-3\"></div>\n<div class=\"sp-grid-cell-span-6\">\n  <div class=\"aligned-to-center important-flex loader-container\">\n    <sp-button *ngIf=\"!flagInitPosTransaction\"\n               class=\"button-inline aligned-to-center sp-top-spacing-l\"\n               (buttonClick)=\"initPostTransaction()\" buttonColor=\"primary\"\n               [label]=\"'UI_LIB.CONCLUDE_SELLING.INIT_POS' | translate\"></sp-button>\n    <ng-container *ngIf=\"flagInitPosTransaction\">\n      <h3 class=\"aligned-to-center\">{{'UI_LIB.CONCLUDE_SELLING.AWAITING_TRANSACTION' | translate}}</h3>\n      <div class=\"sp-top-spacing-m aligned-to-center\">\n        <sp-loader\n          [flagBackgroundVisible]=\"true\"\n          [flagLocalSpinner]=\"true\"\n        ></sp-loader>\n      </div>\n      <div class=\"aligned-to-center sp-top-spacing-m\">\n        <sp-count-down [minutes]=\"5\"></sp-count-down>\n      </div>\n      <div class=\"sp-top-spacing-m\">\n        <h5>{{ \"UI_LIB.CONCLUDE_SELLING.PROCESSING_POLLING\" | translate }}</h5>\n      </div>\n    </ng-container>\n\n  </div>\n</div>\n<div class=\"sp-grid-cell-span-3\"></div>\n",
        styles: [".loader-container{display:flex;flex-direction:column;justify-content:center;z-index:1}"]
    })
], SpPosLoaderComponent);

let SpGatewayFormComponent = class SpGatewayFormComponent {
    constructor(fb) {
        this.fb = fb;
        this.showNewOnBoarding = false;
        this.gatewayAdded = new EventEmitter();
        this.gatewayForm = new FormArray([]);
        this.fiscalCodePattern = '^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$';
        this.fiscalCodeLenght = 16;
        this.ibanCodeLenght = 27;
        this.qomodoSectors = [
            { label: 'Car Indipendent', value: 'car_independent', products: ['3', '4', '3-4'] },
            { label: 'Optician', value: 'optician', products: ['3', '4', '3-4'] },
            { label: 'Gym', value: 'gym', products: ['2/10', '3', '4', '3-4'] },
            { label: 'Medical Devices', value: 'medical_devices', products: ['2/10', '3', '4', '3-4'] },
            { label: 'Car Chain', value: 'car_chain', products: ['3', '4', '3-4'] },
            { label: 'Dentist', value: 'dentist', products: ['2/10'] },
            { label: 'Vet', value: 'vet', products: ['2/10'] },
            { label: 'Beauty', value: 'beauty', products: ['2/10', '3', '4', '3-4'] },
            { label: 'Medical Care', value: 'medical_care', products: ['2/10'] },
            { label: 'Clothing', value: 'clothing', products: ['3', '4', '3-4'] },
            { label: 'Mental Health', value: 'mental_health', products: ['3', '4', '3-4'] },
            { label: 'Pharmaceuticals', value: 'pharmaceuticals', products: ['3', '4', '3-4'] },
            { label: 'Education', value: 'education', products: ['3', '4', '3-4'] },
            { label: 'Travel', value: 'travel', products: ['3', '4', '3-4'] },
            { label: 'Software Development', value: 'software_development', products: ['2/10', '3', '4', '3-4'] },
            { label: 'Sports Equipment', value: 'sports_equipment', products: ['3', '4', '3-4'] },
            { label: 'Travel Accessories', value: 'travel_accessories', products: ['3', '4', '3-4'] },
        ];
        this.scalapayOptions = [
            {
                label: '4 Rate',
                value: 'pay-in-4'
            },
            {
                label: '3 Rate',
                value: 'pay-in-3'
            },
            {
                label: 'Entrambi',
                value: 'pay-in-3;pay-in-4'
            }
        ];
        this.qomodoOptionsMapping = {
            '2/10': {
                label: 'Da 2 a 10 Rate',
                value: '-'
            },
            '3': {
                label: '3 Rate',
                value: '3R'
            },
            '4': {
                label: '4 Rate',
                value: '4R'
            },
            '3-4': {
                label: '3 o 4 Rate',
                value: '3-4R'
            }
        };
        this.qomodoDefaultOptions = [
            this.qomodoOptionsMapping['2/10'],
            this.qomodoOptionsMapping['3'],
            this.qomodoOptionsMapping['4'],
            this.qomodoOptionsMapping['3-4']
        ];
        this.qomodoOptions = this.qomodoDefaultOptions;
    }
    get channelValues() {
        return [
            'CONSORZIO',
            'QOMODO',
            'NEXI',
            'SCALAPAY',
            'STRIPE',
            'STRIPE_SDD',
            'STRIPE_KLARNA',
            'STRIPE_ALMA',
            'STRIPE_SCALAPAY',
            'APPPAGO',
            'KLARNA',
            'NEXI_3_PAYPAL',
            'NEXI_PAYPAL',
            'NEXI_PAGODIL',
            'KLARNA_BY_NEXI'
        ];
    }
    onGatewaySelected(channel) {
        // clear form
        this.gatewayForm.clear();
        this.selectedGateway = channel;
        if (['APPPAGO', 'CONSORZIO', 'KLARNA'].includes(channel)) {
            this.initAppagoConsKlarnaForm();
            return;
        }
        if (['NEXI_PAYPAL', 'NEXI_3_PAYPAL', 'NEXI_PAGODIL', 'KLARNA_BY_NEXI', 'NEXI'].includes(channel)) {
            this.initNexiForm(channel);
            return;
        }
        if (['STRIPE_KLARNA', 'STRIPE_SDD', 'STRIPE_ALMA', 'STRIPE_SCALAPAY'].includes(channel)) {
            this.initStripeDerivedForm();
            return;
        }
        if ('STRIPE' === channel) {
            this.initStripeForm();
            return;
        }
        if ('QOMODO' === channel) {
            this.initQomodoForm();
            return;
        }
        if ('SCALAPAY' === channel) {
            this.initScalapayForm();
            return;
        }
        this.gatewayForm = new FormArray([]);
    }
    initAppagoConsKlarnaForm() {
        this.gatewayForm.push(new FormGroup({
            aliasMainGateway: new FormControl('', Validators.required),
            macMainGateway: new FormControl('', Validators.required)
        }));
    }
    initNexiForm(channel) {
        this.gatewayForm.push(new FormGroup({
            aliasMainGateway: new FormControl('', Validators.required),
            macMainGateway: new FormControl('', Validators.required),
            groupMainGateway: new FormControl(''),
            terminalMainGateway: new FormControl('')
        }));
        if (channel === 'NEXI') {
            this.gatewayForm.push(new FormGroup({
                aliasSecondaryGateway: new FormControl(''),
                macSecondaryGateway: new FormControl(''),
                groupSecondaryGateway: new FormControl(''),
                terminalSecondaryGateway: new FormControl('')
            }));
        }
    }
    initStripeDerivedForm() {
        let controls = {
            aliasMainGateway: new FormControl('', Validators.required),
            macMainGateway: new FormControl(''),
            macMainGatewaySelected: new FormControl('')
        };
        if (this.showNewOnBoarding) {
            controls = Object.assign(Object.assign({}, controls), { newOnboarding: new FormControl(false) });
        }
        this.gatewayForm.push(new FormGroup(controls));
    }
    initStripeForm() {
        let controls = {
            aliasMainGateway: new FormControl('', Validators.required)
        };
        if (this.showNewOnBoarding) {
            controls = Object.assign(Object.assign({}, controls), { newOnboarding: new FormControl(false) });
        }
        this.gatewayForm.push(new FormGroup(controls));
    }
    initQomodoForm() {
        const controls = {
            aliasMainGateway: new FormControl('', Validators.required),
            newOnboarding: new FormControl(true)
        };
        this.gatewayForm.push(new FormGroup(controls));
        this.qomodoForm = this.fb.group({
            fiscalCode: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.fiscalCodeLenght),
                    Validators.maxLength(this.fiscalCodeLenght),
                    Validators.pattern(this.fiscalCodePattern)
                ]
            ],
            ibanCode: new FormControl('', [
                Validators.required,
                Validators.minLength(this.ibanCodeLenght),
                Validators.maxLength(this.ibanCodeLenght)
            ]),
            qomodoSector: new FormControl('', [Validators.required]),
            bnplSubFee: new FormControl(0.0, [Validators.required]),
            trialDays: new FormControl(0, [Validators.required]),
            minimunMonthlyTrans: new FormControl(0.0, [Validators.required]),
            sectorType: new FormControl('', Validators.required)
        });
        this.qomodoForm.get('qomodoSector').valueChanges.subscribe(sector => {
            this.qomodoOptions = sector.products.map(product => this.qomodoOptionsMapping[product]);
            this.qomodoForm.get('sectorType').reset(null, { emitEvent: false });
        });
    }
    initScalapayForm() {
        const controls = {
            aliasMainGateway: new FormControl('', Validators.required),
            macMainGateway: new FormControl('', Validators.required)
        };
        this.gatewayForm.push(new FormGroup(controls));
        this.scalapayForm = this.fb.group({
            scalapayProduct: new FormControl('', Validators.required)
        });
    }
    retrieveAliasLabel() {
        var _a;
        return ((_a = this.gatewayForm) === null || _a === void 0 ? void 0 : _a.controls.length) === 1 ? 'UI_LIB.GATEWAYS.ID' : 'UI_LIB.GATEWAYS.ALIAS_FIRST';
    }
    retrieveMacLabel() {
        var _a;
        return ((_a = this.gatewayForm) === null || _a === void 0 ? void 0 : _a.controls.length) === 1 ? 'UI_LIB.GATEWAYS.PW' : 'UI_LIB.GATEWAYS.MAC_FIRST';
    }
    isAddGatewayButtonDisabled(selectedGateway) {
        if (!this.gatewayForm || this.gatewayForm.invalid)
            return true;
        const gatewayRequiresExtraForm = {
            QOMODO: () => { var _a, _b; return _b = (_a = this.qomodoForm) === null || _a === void 0 ? void 0 : _a.invalid, (_b !== null && _b !== void 0 ? _b : true); },
            SCALAPAY: () => { var _a, _b; return _b = (_a = this.scalapayForm) === null || _a === void 0 ? void 0 : _a.invalid, (_b !== null && _b !== void 0 ? _b : true); }
        };
        const extraCheck = gatewayRequiresExtraForm[selectedGateway];
        return extraCheck ? extraCheck() : false;
    }
    addGateway() {
        var _a, _b, _c, _d, _e;
        if (this.gatewayForm.valid) {
            const formValues = this.gatewayForm.getRawValue();
            const mainGateway = formValues[0];
            const secondaryGateway = formValues[1];
            this.gatewayAdded.emit({
                mainGateway: {
                    alias: mainGateway.aliasMainGateway,
                    mac: this.getMainGatewayMAC((_a = mainGateway) === null || _a === void 0 ? void 0 : _a.macMainGateway, (_b = mainGateway) === null || _b === void 0 ? void 0 : _b.macMainGatewaySelected, mainGateway.newOnboarding),
                    group: this.selectedGateway === 'SCALAPAY'
                        ? this.scalapayForm.get('scalapayProduct').value
                        : this.selectedGateway === 'QOMODO'
                            ? this.retrieveQomodoSectorType()
                            : (_c = mainGateway) === null || _c === void 0 ? void 0 : _c.groupMainGateway,
                    terminalId: (_d = mainGateway) === null || _d === void 0 ? void 0 : _d.terminalMainGateway,
                    channel: this.selectedGateway,
                    applicationId: this.applicationId,
                    newOnboarding: mainGateway.newOnboarding,
                    qomodoAttributes: this.selectedGateway === 'QOMODO'
                        ? Object.assign(Object.assign({}, this.qomodoForm.getRawValue()), { qomodoSector: this.retrieveQomodoSectorType() == null ? this.qomodoForm.get('qomodoSector').value.value : `${this.qomodoForm.get('qomodoSector').value.value}_${this.retrieveQomodoSectorType()}`, sectorType: this.retrieveQomodoSectorType() }) : undefined
                },
                secondaryGateway: secondaryGateway && secondaryGateway.aliasSecondaryGateway && secondaryGateway.macSecondaryGateway
                    ? {
                        alias: secondaryGateway.aliasSecondaryGateway,
                        mac: (_e = secondaryGateway.macSecondaryGateway, (_e !== null && _e !== void 0 ? _e : '###')),
                        group: secondaryGateway.groupSecondaryGateway,
                        terminalId: secondaryGateway.terminalSecondaryGateway,
                        channel: this.selectedGateway,
                        applicationId: this.applicationId
                    }
                    : undefined
            });
        }
    }
    retrieveQomodoSectorType() {
        return this.qomodoForm.get('sectorType').value === '-' ? null : this.qomodoForm.get('sectorType').value;
    }
    isNexiOldChannel(selectedGateway) {
        return (selectedGateway === 'NEXI_3_PAYPAL' ||
            selectedGateway === 'NEXI' ||
            selectedGateway === 'NEXI_PAGODIL' ||
            selectedGateway === 'NEXI_PAYPAL');
    }
    isNexiChannel(selectedGateway) {
        return (selectedGateway === 'NEXI_3_PAYPAL' ||
            selectedGateway === 'NEXI' ||
            selectedGateway === 'NEXI_PAGODIL' ||
            selectedGateway === 'NEXI_PAYPAL' ||
            selectedGateway === 'KLARNA_BY_NEXI');
    }
    showNewOnboarding() {
        return ['STRIPE', 'STRIPE_SDD', 'STRIPE_KLARNA', 'STRIPE_ALMA', 'STRIPE_SCALAPAY'].includes(this.selectedGateway);
    }
    checkStripeOnBoarding(showNewOnBoarding, selectedGateway, gatewayForm) {
        var _a;
        return showNewOnBoarding && this.showNewOnboarding() && (selectedGateway === 'STRIPE_SDD' || selectedGateway === 'STRIPE_KLARNA' || selectedGateway === 'STRIPE_ALMA' || selectedGateway === 'STRIPE_SCALAPAY')
            && !((_a = gatewayForm.at(0).get('newOnboarding')) === null || _a === void 0 ? void 0 : _a.value);
    }
    getMainGatewayMAC(mainGateway, mainGatewaySelected, flagNewOnboarding) {
        const defaultMAC = '###';
        if (flagNewOnboarding) {
            return defaultMAC;
        }
        if (!!mainGatewaySelected && !flagNewOnboarding) {
            return mainGatewaySelected.value;
        }
        if (!!mainGateway && !flagNewOnboarding) {
            return mainGateway;
        }
        return defaultMAC;
    }
    displayQomodoSector(qomodoSector) {
        return qomodoSector.label;
    }
    displayStripeGateway(stripeGateway) {
        return stripeGateway.label;
    }
    isErrorVisible(name) {
        return this.qomodoForm.get(`${name}`).invalid && !this.qomodoForm.get(`${name}`).pristine;
    }
};
SpGatewayFormComponent.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input()
], SpGatewayFormComponent.prototype, "activeGateways", void 0);
__decorate([
    Input()
], SpGatewayFormComponent.prototype, "stripeGateways", void 0);
__decorate([
    Input()
], SpGatewayFormComponent.prototype, "applicationId", void 0);
__decorate([
    Input()
], SpGatewayFormComponent.prototype, "showNewOnBoarding", void 0);
__decorate([
    Output()
], SpGatewayFormComponent.prototype, "gatewayAdded", void 0);
SpGatewayFormComponent = __decorate([
    Component({
        selector: 'sp-gateway-form',
        template: "<div class=\"sp-grid\">\n  <div class=\"sp-grid-cell-span-2\"></div>\n  <div class=\"sp-grid-cell-span-8\">\n    <div class=\"select-channel formcard\">\n      <sp-select [flagIsAllAvailable]=\"false\" [label]=\"'UI_LIB.GATEWAYS.CHANNEL' | translate\" [values]=\"channelValues\"\n        (changeSelection)=\"onGatewaySelected($event)\">\n      </sp-select>\n    </div>\n    <form *ngIf=\"gatewayForm && gatewayForm.controls.length > 0\" [formGroup]=\"gatewayForm\">\n      <!-- Main gateway-->\n      <form [formGroup]=\"gatewayForm.controls[0]\">\n        <div class=\"formcard\">\n          <h3>{{ 'UI_LIB.GATEWAYS.FIRST_GATEWAY' | translate }}</h3>\n          <p>{{ 'UI_LIB.GATEWAYS.INFO_FIRST_GATEWAY' | translate }}</p>\n          <div class=\"sp-top-spacing-l\">\n            <sp-input formControlName=\"aliasMainGateway\" [id]=\"'input-alias-main-gateway'\"\n              [label]=\"(retrieveAliasLabel() | translate) + ' *'\">\n            </sp-input>\n          </div>\n          <ng-container *ngIf=\"checkStripeOnBoarding(showNewOnBoarding, selectedGateway, gatewayForm)\">\n            <div class=\"sp-top-spacing-l select-channel\">\n                <sp-select formControlName=\"macMainGatewaySelected\" [flagIsAllAvailable]=\"false\" [label]=\"'UI_LIB.GATEWAYS.CHANNEL_ASSOCIATED' | translate\" [values]=\"stripeGateways\" [displayFunction]=\"displayStripeGateway\">\n                </sp-select>\n            </div>\n            </ng-container>\n          <ng-container *ngIf=\"\n              selectedGateway === 'CONSORZIO' ||\n              selectedGateway === 'APPPAGO' ||\n              selectedGateway === 'KLARNA' ||\n              selectedGateway === 'STRIPE_SDD' ||\n              selectedGateway === 'STRIPE_KLARNA' ||\n              selectedGateway === 'STRIPE_ALMA' ||\n              selectedGateway === 'STRIPE_SCALAPAY' ||\n              selectedGateway === 'SCALAPAY'\n            \">\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"macMainGateway\" [id]=\"'input-mac-main-gateway'\"\n                [label]=\"(retrieveMacLabel() | translate) + ' *'\">\n              </sp-input>\n            </div>\n          </ng-container>\n\n          <ng-container *ngIf=\"isNexiChannel(selectedGateway)\">\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"macMainGateway\" [id]=\"'input-mac-main-gateway'\"\n                [label]=\"(retrieveMacLabel() | translate) + ' *'\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"groupMainGateway\" [id]=\"'input-group-main-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.GROUP_FIRST' | translate\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"terminalMainGateway\" [id]=\"'input-terminal-main-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.TERMINAL_FIRST' | translate\">\n              </sp-input>\n            </div>\n          </ng-container>\n\n          <ng-container *ngIf=\"isNexiOldChannel(selectedGateway)\">\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"macMainGateway\" [id]=\"'input-mac-main-gateway'\"\n                [label]=\"(retrieveMacLabel() | translate) + ' *'\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"groupMainGateway\" [id]=\"'input-group-main-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.GROUP_FIRST' | translate\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"terminalMainGateway\" [id]=\"'input-terminal-main-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.TERMINAL_FIRST' | translate\">\n              </sp-input>\n            </div>\n          </ng-container>\n\n          <div class=\"sp-top-spacing-l\" *ngIf=\"showNewOnBoarding && showNewOnboarding()\">\n            <sp-checkbox [label]=\"'UI_LIB.GATEWAYS.NEW_ONBOARDING' | translate\"\n              formControlName=\"newOnboarding\"></sp-checkbox>\n          </div>\n        </div>\n      </form>\n\n      <!-- Secondary Gateway -->\n      <ng-container *ngIf=\"selectedGateway === 'NEXI'\">\n        <form [formGroup]=\"gatewayForm.controls[1]\">\n          <div class=\"formcard sp-top-spacing-l\">\n            <h3>{{ 'UI_LIB.GATEWAYS.SECOND_GATEWAY' | translate }}</h3>\n            <p>{{ 'UI_LIB.GATEWAYS.INFO_SECOND_GATEWAY' | translate }}</p>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"aliasSecondaryGateway\" [id]=\"'input-alias-secondary-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.ALIAS_SECOND' | translate\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"macSecondaryGateway\" [id]=\"'input-mac-secondary-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.MAC_SECOND' | translate\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"groupSecondaryGateway\" [id]=\"'input-group-secondary-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.GROUP_SECOND' | translate\">\n              </sp-input>\n            </div>\n            <div class=\"sp-top-spacing-l\">\n              <sp-input formControlName=\"terminalSecondaryGateway\" [id]=\"'input-terminal-secondary-gateway'\"\n                [label]=\"'UI_LIB.GATEWAYS.TERMINAL_SECOND' | translate\">\n              </sp-input>\n            </div>\n          </div>\n        </form>\n      </ng-container>\n    </form>\n\n    <!-- Qomodo Gateway -->\n    <ng-container *ngIf=\"selectedGateway === 'QOMODO'\">\n      <form [formGroup]=\"qomodoForm\">\n        <div class=\"formcard sp-top-spacing-l\">\n          <h3>{{ 'UI_LIB.GATEWAYS.QOMODO.TITLE' | translate }}</h3>\n          <div class=\"sp-top-spacing-l\">\n            <sp-input formControlName=\"fiscalCode\" [flagShowErrorMessage]=\"isErrorVisible('fiscalCode')\"\n              [id]=\"'input-qomodo-fiscal-code'\" [errorMessage]=\"'UI_LIB.ERRORS.MANDATORY' | translate\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.FISCAL_CODE' | translate\">\n            </sp-input>\n          </div>\n          <div class=\"sp-top-spacing-l\">\n            <sp-input formControlName=\"ibanCode\" [flagShowErrorMessage]=\"isErrorVisible('ibanCode')\"\n              [id]=\"'input-qomodo-iban-code'\" [errorMessage]=\"'UI_LIB.ERRORS.MANDATORY' | translate\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.IBAN_CODE' | translate\">\n            </sp-input>\n          </div>\n          <div class=\"sp-top-spacing-l\">\n            <sp-select formControlName=\"qomodoSector\" [flagShowErrorMessage]=\"isErrorVisible('qomodoSector')\"\n              [flagIsAllAvailable]=\"false\" [errorMessage]=\"'UI_LIB.ERRORS.MANDATORY' | translate\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.SECTOR' | translate\" [displayFunction]=\"displayQomodoSector\"\n              [values]=\"qomodoSectors\"></sp-select>\n          </div>\n          <div class=\"sp-top-spacing-l\">\n            <sp-numeric-input formControlName=\"trialDays\" [id]=\"'input-qomodo-trial-days'\"\n              [flagShowErrorMessage]=\"isErrorVisible('trialDays')\"\n              [errorMessage]=\"'UI_LIB.ERRORS.MANDATORY' | translate\" [required]=\"true\" [minValue]=\"0\" [maxValue]=\"30\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.TRIAL_DAYS' | translate\"></sp-numeric-input>\n          </div>\n          <div class=\"sp-top-spacing-l\">\n            <sp-decimal-input formControlName=\"bnplSubFee\" [id]=\"'input-qomodo-bnpl'\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.BNPL_FEE' | translate\"></sp-decimal-input>\n            <sp-decimal-input formControlName=\"minimunMonthlyTrans\" [id]=\"'input-qomodo-min-monthly-trans'\"\n              [label]=\"'UI_LIB.GATEWAYS.QOMODO.MINIMUM_MONTHlY_TRANS'\"></sp-decimal-input>\n          </div>\n          <div class=\"formcard\">\n            <h3>{{ 'UI_LIB.GATEWAYS.QOMODO.PRODOTTI' | translate }}</h3>\n            <div class=\"sp-top-spacing-l\">\n              <sp-radio-button formControlName=\"sectorType\" [id]=\"'input-qomodo-products'\" [name]=\"'Prodotto'\"\n                [optionList]=\"qomodoOptions\"></sp-radio-button>\n            </div>\n          </div>\n        </div>\n      </form>\n    </ng-container>\n\n    <!-- ScalaPay Gateway -->\n    <ng-container *ngIf=\"selectedGateway === 'SCALAPAY'\">\n      <form [formGroup]=\"scalapayForm\">\n        <div class=\"formcard sp-top-spacing-l\">\n          <h3>{{ 'UI_LIB.GATEWAYS.SCALAPAY.TITLE' | translate }}</h3>\n          <div class=\"sp-top-spacing-l\">\n            <sp-radio-button formControlName=\"scalapayProduct\" [id]=\"'input-scalapay-products'\" [name]=\"'Prodotto'\"\n              [optionList]=\"scalapayOptions\"></sp-radio-button>\n          </div>\n        </div>\n      </form>\n    </ng-container>\n  </div>\n</div>\n\n<div class=\"sp-grid-cell-span-12\" *ngIf=\"selectedGateway\">\n  <sp-button class=\"aligned-to-center sp-top-spacing-l\" [flagDisabled]=\"isAddGatewayButtonDisabled(selectedGateway)\"\n    [id]=\"'gateway-associate'\" [label]=\"'UI_LIB.GATEWAYS.ADD_GATEWAY' | translate\" (buttonClick)=\"addGateway()\">\n  </sp-button>\n</div>",
        styles: [":host h2{margin-bottom:32px}:host .sp-grid{margin-top:24px}:host .select-channel{background:#fff;margin-bottom:24px}:host .disabled{pointer-events:none;opacity:.8}:host .container-flex{display:flex;width:100%}:host .container-flex>*{flex:0 0 50%}"]
    })
], SpGatewayFormComponent);

let SpGatewayComponent = class SpGatewayComponent {
    constructor(appState$) {
        this.appState$ = appState$;
        this.gatewayAdded = new EventEmitter();
        this.tableFiltered = new EventEmitter();
        this.gatewayDeleted = new EventEmitter();
        this.gatewayDetail = new EventEmitter();
        this.gatewayRefresh = new EventEmitter();
        this.stripeGateways = ['STRIPE_ALMA', 'STRIPE_SCALAPAY'];
        this.gatewaysColumns = [
            {
                columnData: 'id',
                columnLabel: 'UI_LIB.GATEWAYS.ID',
                columnFilter: 'none'
            },
            {
                columnData: 'alias',
                columnLabel: 'UI_LIB.GATEWAYS.ALIAS',
                columnFilter: 'none'
            },
            {
                columnData: 'mac',
                columnLabel: 'UI_LIB.GATEWAYS.MAC',
                columnFilter: 'none'
            },
            {
                columnData: 'channel',
                columnLabel: 'UI_LIB.GATEWAYS.CHANNEL',
                columnFilter: 'select',
                columnOptions: [...channelTypes]
            },
            {
                columnData: 'state',
                columnLabel: 'UI_LIB.GATEWAYS.STATE',
                columnFilter: 'select',
                columnOptions: [...gatewayStates]
            }
        ];
        this.gatewayActions = [
            {
                iconName: 'delete',
                tooltip: 'SHARED.TOOLTIP.DELETE',
                isVisible: () => true,
                callback: (gateway) => {
                    this.appState$.dispatch(openDialog({
                        dialogData: {
                            title: 'SHARED.DIALOG.ALERT_TITLE',
                            message: ['SHARED.DIALOG.DELETE_CHECK'],
                            buttons: [
                                {
                                    label: 'SHARED.BUTTON.ROLLBACK',
                                    icon: '',
                                    callback: () => this.appState$.dispatch(closeDialog())
                                },
                                {
                                    label: 'SHARED.BUTTON.CONFIRM',
                                    icon: '',
                                    callback: () => {
                                        this.gatewayDeleted.emit({
                                            gateway: gateway,
                                            tableFilterData: this.currentTableFilterData
                                        });
                                        this.appState$.dispatch(closeDialog());
                                    }
                                }
                            ]
                        }
                    }));
                }
            },
            {
                iconName: 'info',
                tooltip: 'SHARED.TOOLTIP.INFO',
                isVisible: () => this.flagShowGatewayDetails,
                callback: gateway => this.gatewayDetail.emit({
                    gateway: gateway,
                    tableFilterData: this.currentTableFilterData
                })
            },
            {
                iconName: 'refresh',
                tooltip: 'SHARED.TOOLTIP.REFRESH_DATA',
                isVisible: gateway => !!gateway.channel && this.stripeGateways.includes(gateway.channel) && gateway.state === 'IN ATTIVAZIONE',
                callback: gateway => this.gatewayRefresh.emit({
                    gateway,
                    tableFilterData: this.currentTableFilterData
                })
            }
        ];
    }
    addGateway() {
        this.gatewayAdded.emit();
    }
    filterTable(tableFilterData) {
        this.currentTableFilterData = tableFilterData;
        this.tableFiltered.emit(tableFilterData);
    }
};
SpGatewayComponent.ctorParameters = () => [
    { type: Store }
];
__decorate([
    Input()
], SpGatewayComponent.prototype, "gateways", void 0);
__decorate([
    Input()
], SpGatewayComponent.prototype, "flagShowGatewayDetails", void 0);
__decorate([
    Output()
], SpGatewayComponent.prototype, "gatewayAdded", void 0);
__decorate([
    Output()
], SpGatewayComponent.prototype, "tableFiltered", void 0);
__decorate([
    Output()
], SpGatewayComponent.prototype, "gatewayDeleted", void 0);
__decorate([
    Output()
], SpGatewayComponent.prototype, "gatewayDetail", void 0);
__decorate([
    Output()
], SpGatewayComponent.prototype, "gatewayRefresh", void 0);
SpGatewayComponent = __decorate([
    Component({
        selector: 'sp-gateway',
        template: "<div class=\"sp-grid\">\n  <div class=\"sp-grid-cell-span-12 aligned-to-end\">\n    <sp-button class=\"button-inline sp-top-spacing-l\"\n               [id]=\"'manage-gaetawys'\"\n               [buttonColor]=\"'accent'\"\n               [label]=\"'UI_LIB.GATEWAYS.ADD_GATEWAY' | translate\"\n               (buttonClick)=\"addGateway()\">\n    </sp-button>\n  </div>\n\n  <div class=\"sp-grid-cell-span-12 sp-top-spacing-l\">\n    <sp-table [dataSource]=\"gateways\"\n              [tableActions]=\"gatewayActions\"\n              [tableColumnData]=\"gatewaysColumns\"\n              (filtered)=\"filterTable($event)\">\n    </sp-table>\n  </div>\n</div>\n"
    })
], SpGatewayComponent);

let SpNotificationsComponent = class SpNotificationsComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.showApplication = false;
        this.tableFiltered = new EventEmitter();
        this.baseColumns = [
            {
                columnData: 'dateCreation',
                columnLabel: 'NOTIFICATIONS.DATE_CREATION',
                dataDisplay: 'date',
                columnFilter: 'dateRange',
            },
            {
                columnData: 'notificationType',
                columnLabel: 'NOTIFICATIONS.NOTIFICATION_TYPE',
                columnFilter: 'select',
                columnOptions: [...notificationStates]
            },
            {
                columnData: 'text',
                columnLabel: 'NOTIFICATIONS.TEXT',
                columnFilter: 'none',
                unsortable: true
            }
        ];
        this.columns = this.baseColumns;
    }
    ngAfterViewInit() {
        // work around for translateService.instant
        setTimeout(() => {
            this.filterTable({ pageIndex: 0, pageSize: 12, fieldFilters: undefined });
        }, 200);
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.notifications && changes.notifications.previousValue !== changes.notifications.currentValue) {
            this.notifications = this.notifications.pipe(filter(notifications => !!notifications), map(notifications => (Object.assign(Object.assign({}, notifications), { content: notifications.content.map(notification => (Object.assign(Object.assign({}, notification), { text: this.translateTemplate(notification) }))) }))));
        }
        if (((_a = changes) === null || _a === void 0 ? void 0 : _a.showApplication) && changes.showApplication.previousValue !== changes.showApplication.currentValue) {
            if (this.showApplication) {
                this.columns = [
                    {
                        columnData: 'applicationId',
                        columnLabel: 'NOTIFICATIONS.APPLICATION_ID',
                        columnFilter: 'select',
                        columnOptions: [...this.applications],
                        unsortable: true
                    },
                    ...this.baseColumns
                ];
            }
            else {
                this.columns = this.baseColumns;
            }
        }
    }
    filterTable(tableFilterData) {
        var _a, _b, _c, _d;
        this.tableFiltered.emit({
            page: tableFilterData.pageIndex,
            size: tableFilterData.pageSize,
            sortBy: tableFilterData.sortBy,
            sortingMethod: tableFilterData.sortingMethod,
            applicationId: (_a = tableFilterData.fieldFilters) === null || _a === void 0 ? void 0 : _a.applicationId,
            notificationType: (_b = tableFilterData.fieldFilters) === null || _b === void 0 ? void 0 : _b.notificationType,
            dateCreationStart: ((_c = tableFilterData.fieldFilters) === null || _c === void 0 ? void 0 : _c.dateCreation) && !!tableFilterData.fieldFilters.dateCreation.start
                ? dateToYMD(tableFilterData.fieldFilters.dateCreation.start)
                : undefined,
            dateCreationEnd: !!((_d = tableFilterData.fieldFilters) === null || _d === void 0 ? void 0 : _d.dateCreation) && !!tableFilterData.fieldFilters.dateCreation.end
                ? dateToYMD(tableFilterData.fieldFilters.dateCreation.end)
                : undefined
        });
    }
    translateTemplate(notification) {
        return notification.template
            ? this.translateService.instant(notification.template, Object.assign({}, notification.parameters))
            : '';
    }
};
SpNotificationsComponent.ctorParameters = () => [
    { type: TranslateService }
];
__decorate([
    Input()
], SpNotificationsComponent.prototype, "notifications", void 0);
__decorate([
    Input()
], SpNotificationsComponent.prototype, "showApplication", void 0);
__decorate([
    Input()
], SpNotificationsComponent.prototype, "applications", void 0);
__decorate([
    Output()
], SpNotificationsComponent.prototype, "tableFiltered", void 0);
SpNotificationsComponent = __decorate([
    Component({
        selector: 'sp-notifications',
        template: "<div class=\"sp-grid-cell-span-12\">\n    <sp-table *ngIf=\"notifications\"\n              [dataSource]=\"notifications | async\"\n              [tableColumnData]=\"columns\"\n              (filtered)=\"filterTable($event)\">\n    </sp-table>\n</div>\n"
    })
], SpNotificationsComponent);

let SpStatisticsComponent = class SpStatisticsComponent {
    constructor() {
        this.searchEmitted = new EventEmitter();
    }
    setSelectedRequiredReport(param) {
        this.excelOptionSelected = param;
    }
    searchStatistics(payload) {
        this.searchEmitted.emit({ data: payload, context: this.excelOptionSelected });
    }
    localUnitChanged() {
        // do nothing
    }
    getTranslationPath() {
        return './assets/translate/feature-modules/statistics/';
    }
};
__decorate([
    Input()
], SpStatisticsComponent.prototype, "env", void 0);
__decorate([
    Input()
], SpStatisticsComponent.prototype, "options", void 0);
__decorate([
    Input()
], SpStatisticsComponent.prototype, "localUnits", void 0);
__decorate([
    Output()
], SpStatisticsComponent.prototype, "searchEmitted", void 0);
SpStatisticsComponent = __decorate([
    Component({
        selector: 'sp-statistics',
        template: "<div class=\"sp-grid\">\n  <h2 class=\"sp-grid-cell-span-12 aligned-to-start\">\n    {{ \"STATISTICS.DATA_ANALYSIS\" | translate }}\n  </h2>\n\n  <mat-accordion class=\"sp-grid-cell-span-12\"\n                 [ngClass]=\"{\n                    'mat-accordion--market': env === 'market', \n                    'mat-accordion--support': env === 'support'\n                  }\">\n    <mat-expansion-panel *ngFor=\"let item of options\"\n                         (opened)=\"setSelectedRequiredReport(item.id)\">\n      <mat-expansion-panel-header>\n        <mat-panel-title>\n          {{ item.label }}\n        </mat-panel-title>\n      </mat-expansion-panel-header>\n      <ng-template *ngTemplateOutlet=\"reportFilterForm; context: {item: item, env:env} \"></ng-template>\n    </mat-expansion-panel>\n  </mat-accordion>\n</div>\n\n<ng-template #reportFilterForm\n             let-item=\"item\"\n             let-env=\"env\">\n  <sp-report-filter-form [env]=\"env\"\n                         [options]=\"item.options\"\n                         [localUnits]=\"localUnits\"\n                         (filterValues)=\"searchStatistics($event)\"></sp-report-filter-form>\n\n</ng-template>\n",
        styles: [":host .mat-accordion--market mat-expansion-panel-header{background:#fc5a11}:host .mat-accordion--market mat-expansion-panel-header:hover{background:#fc5a11}:host .mat-accordion--support mat-expansion-panel-header{background:#128cab}:host .mat-accordion--support mat-expansion-panel-header:hover{background:#128cab}:host .mat-accordion mat-expansion-panel{margin-bottom:24px}:host .mat-accordion mat-expansion-panel mat-expansion-panel-header mat-panel-title{color:#fff}::ng-deep mat-accordion mat-expansion-panel{background:rgba(255,255,255,.6)!important}::ng-deep mat-accordion mat-expansion-panel mat-expansion-panel-header .mat-content{overflow:visible}::ng-deep mat-accordion mat-expansion-panel .mat-expansion-indicator:after{color:#fff}::ng-deep mat-accordion mat-expansion-panel .mat-expansion-panel-body{padding:24px!important}"]
    })
], SpStatisticsComponent);

let SpUserInfoComponent = class SpUserInfoComponent {
    constructor() {
        this.savePassword = new EventEmitter();
        this.flagChangingPassword = false;
        this.newPassword = new FormGroup({
            password: new FormControl('', [Validators.required,
                Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?&].{7,}')]),
            confirmPassword: new FormControl('', [Validators.required,
                Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?&].{7,}')]),
        });
    }
    changePassword() {
        this.flagChangingPassword = false;
        this.savePassword.emit(this.newPassword.get('password').value);
    }
    get newPasswordsMatch() {
        const pw = this.newPassword.get('password').value;
        const confirmPw = this.newPassword.get('confirmPassword').value;
        return pw && confirmPw
            ? pw !== confirmPw
            : true;
    }
    isErrorVisible(name) {
        return this.newPassword.get(`${name}`).invalid && !this.newPassword.get(`${name}`).pristine;
    }
};
__decorate([
    Input()
], SpUserInfoComponent.prototype, "user", void 0);
__decorate([
    Output()
], SpUserInfoComponent.prototype, "savePassword", void 0);
SpUserInfoComponent = __decorate([
    Component({
        selector: 'sp-user-info',
        template: "<ng-container *ngIf=\"!!user\">\n  <div class=\"sp-top-spacing-l\">\n    <div class=\"sp-grid\">\n      <div class=\"sp-top-spacing-xl sp-grid-cell-span-8\">\n        <h3>{{ 'USER_MANAGER.TITLE' | translate | uppercase }}</h3>\n        <sp-label-value [label]=\"'USER_MANAGER.NAME'\"\n                        [value]=\"user.name\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n        <sp-label-value [label]=\"'USER_MANAGER.SURNAME'\"\n                        [value]=\"user.surname\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n        <sp-label-value [label]=\"'USER_MANAGER.EMAIL'\"\n                        [value]=\"user.email\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n        <sp-label-value [label]=\"'USER_MANAGER.TELEPHONE'\"\n                        [value]=\"user.telephone\"\n                        [valueAlignment]=\"'center'\"></sp-label-value>\n      </div>\n\n      <div class=\"sp-grid-cell-span-4\"></div>\n\n      <sp-button *ngIf=\"!flagChangingPassword\"\n                 class=\"sp-grid-cell-span-12 button-inline aligned-to-start\"\n                 [id]=\"'edit-password'\"\n                 [label]=\"'USER_MANAGER.CHANGE_PW' | translate\"\n                 (click)=\"flagChangingPassword = true\">\n      </sp-button>\n\n      <ng-container *ngIf=\"flagChangingPassword\"\n                    [formGroup]=\"newPassword\">\n        <div class=\"sp-grid-cell-span-4 sp-top-spacing-l\">\n          <sp-input formControlName=\"password\"\n                    [id]=\"'input-new-password'\"\n                    [label]=\"('USER_MANAGER.INSERT_PASSWORD' | translate) + ' *'\"\n                    [flagPassword]=\"true\"\n                    [flagShowErrorMessage]=\"isErrorVisible('password')\"\n                    [errorMessage]=\"'SHARED.ERRORS.PWD_ERROR' | translate\"></sp-input>\n        </div>\n        <div class=\"sp-grid-cell-span-4 sp-top-spacing-l\">\n          <sp-input formControlName=\"confirmPassword\"\n                    [id]=\"'input-confirm-new-password'\"\n                    [label]=\"'USER_MANAGER.CONFIRM_PASSWORD' | translate\"\n                    [flagPassword]=\"true\"\n                    [flagShowErrorMessage]=\"isErrorVisible('confirmPassword')\"\n                    [errorMessage]=\"('SHARED.ERRORS.PWD_ERROR' | translate) + ' *'\">\n          </sp-input>\n        </div>\n\n        <div class=\"sp-grid-cell-span-12 aligned-to-start\">\n          <sp-button *ngIf=\"flagChangingPassword\"\n                     class=\"button-inline\"\n                     [id]=\"'edit-password-confirm'\"\n                     [label]=\"'USER_MANAGER.CONFIRM_CHANGE' | translate\"\n                     [flagDisabled]=\"newPasswordsMatch\"\n                     (buttonClick)=\"changePassword()\">\n          </sp-button>\n        </div>\n      </ng-container>\n\n    </div>\n  </div>\n</ng-container>\n",
        styles: [""]
    })
], SpUserInfoComponent);

let SpSharedModule = class SpSharedModule {
};
SpSharedModule = __decorate([
    NgModule({
        declarations: [
            SpNotificationsComponent,
            SpReportFilterFormComponent,
            SpStatisticsComponent,
            SpUserInfoComponent,
            SpPosLoaderComponent,
            SpGatewayFormComponent,
            SpGatewayComponent,
        ],
        imports: [
            CommonModule,
            TranslateModule,
            FormsModule,
            ReactiveFormsModule,
            SpButtonModule,
            SpDatePickerModule,
            SpInputModule,
            SpLabelValueModule,
            SpMonthYearPickerModule,
            SpNumericInputModule,
            SpDecimalInputModule,
            SpMultiSelectModule,
            MatExpansionModule,
            SpSelectModule,
            SpTableModule,
            SpCountdownModule,
            SpLoaderModule,
            SpCheckBoxModule,
            SpRadioButtonModule
        ],
        exports: [
            SpNotificationsComponent,
            SpReportFilterFormComponent,
            SpStatisticsComponent,
            SpUserInfoComponent,
            SpPosLoaderComponent,
            SpGatewayComponent,
            SpGatewayFormComponent
        ]
    })
], SpSharedModule);

let SpSnackBarTemplateModule = class SpSnackBarTemplateModule {
};
SpSnackBarTemplateModule = __decorate([
    NgModule({
        declarations: [SpSnackBarTemplateComponent],
        imports: [
            SpIconModule,
            TranslateModule,
            CommonModule
        ],
        exports: [SpSnackBarTemplateComponent]
    })
], SpSnackBarTemplateModule);

let SpStateDotComponent = class SpStateDotComponent {
};
SpStateDotComponent = __decorate([
    Component({
        selector: 'sp-state-dot',
        template: "<p>sp-state-dot works!</p>\n",
        styles: [""]
    })
], SpStateDotComponent);

let SpStateDotModule = class SpStateDotModule {
};
SpStateDotModule = __decorate([
    NgModule({
        declarations: [SpStateDotComponent],
        imports: [
            CommonModule
        ],
        exports: [SpStateDotComponent]
    })
], SpStateDotModule);

let SpStatusLabelComponent = class SpStatusLabelComponent {
    retrieveIconName(status) {
        let iconName;
        switch (status) {
            case 'PAGATO':
                iconName = 'check';
                break;
            case 'DA PAGARE':
                iconName = 'access_time';
                break;
            case 'INSOLUTO':
                iconName = 'priority_high';
                break;
            case 'IN ELABORAZIONE':
                iconName = 'calendar_today';
                break;
        }
        return iconName;
    }
    retrieveIconColor(status) {
        let iconColor;
        switch (status) {
            case 'PAGATO':
                iconColor = 'green';
                break;
            case 'DA PAGARE':
                iconColor = 'yellow';
                break;
            case 'INSOLUTO':
                iconColor = 'red';
                break;
            case 'IN ELABORAZIONE':
                iconColor = 'yellow';
                break;
        }
        return iconColor;
    }
};
__decorate([
    Input()
], SpStatusLabelComponent.prototype, "status", void 0);
SpStatusLabelComponent = __decorate([
    Component({
        selector: 'sp-status-label',
        template: "<p class=\" sp-grid-cell-span-12\">\n  <sp-icon class=\"sp-rounded-icon\"\n           [id]=\"'current-payment-status'\"\n           [fontIcon]=\"retrieveIconName(status)\"\n           [ngClass]=\"retrieveIconColor(status)\"></sp-icon>\n  <span>{{ status | titlecase }}</span>\n</p>\n",
        styles: [":host .sp-rounded-icon{height:30px;width:30px;margin-right:8px}:host .sp-rounded-icon.red{color:#d9001b;vertical-align:middle}:host .sp-rounded-icon.cyan{color:#02a7f0;vertical-align:middle}:host .sp-rounded-icon.green{color:#1c9252;vertical-align:middle}:host .sp-rounded-icon.yellow{color:#daa520;vertical-align:middle}"]
    })
], SpStatusLabelComponent);

let SpStatusLabelModule = class SpStatusLabelModule {
};
SpStatusLabelModule = __decorate([
    NgModule({
        declarations: [SpStatusLabelComponent],
        imports: [
            CommonModule,
            SpIconModule
        ],
        exports: [SpStatusLabelComponent]
    })
], SpStatusLabelModule);

class AbstractStepperClass {
    get componentForm() {
        return this.form;
    }
}

let StepDirective = class StepDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
};
StepDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
StepDirective = __decorate([
    Directive({
        selector: '[stepRenderContainer]',
    })
], StepDirective);
let SpStepperComponent = class SpStepperComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.componentRefs = [];
    }
    ngAfterViewInit() {
        this.renderSteps();
    }
    /**
     * Return the formControl of the n-th step from component.
     * @param index The step index.
     */
    retrieveFormControl(index) {
        return this.componentRefs[index] && this.componentRefs[index].instance.componentForm;
    }
    /**
     * Return the title of the n-th step from component.
     * @param index The step index.
     */
    retrieveStepTitle(index) {
        return this.steps[index].title;
    }
    previous() {
        if (this.matStepper) {
            this.matStepper.previous();
        }
    }
    next() {
        if (this.matStepper) {
            this.matStepper.next();
        }
    }
    /**
     * Dynamically render step into stepRenderContainer.
     */
    renderSteps() {
        this.steps.forEach((step, index) => {
            // clear the stepRenderContainer
            const viewContainerRef = this.stepRenderContainers.toArray()[index].viewContainerRef;
            viewContainerRef.clear();
            // create componentFactory
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(step.component);
            // create component and save reference
            this.componentRefs[index] = viewContainerRef.createComponent(componentFactory);
        });
    }
};
SpStepperComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
__decorate([
    Input()
], SpStepperComponent.prototype, "steps", void 0);
__decorate([
    ViewChild('stepper')
], SpStepperComponent.prototype, "matStepper", void 0);
__decorate([
    ViewChildren(StepDirective)
], SpStepperComponent.prototype, "stepRenderContainers", void 0);
SpStepperComponent = __decorate([
    Component({
        selector: 'sp-stepper',
        template: "<mat-horizontal-stepper #stepper\n                        labelPosition=\"bottom\"\n                        linear>\n\n  <div *ngFor=\"let step of steps; let i = index\">\n    <mat-step [stepControl]=\"retrieveFormControl(i)\"\n              [completed]=\"false\">\n\n      <!-- Title-->\n      <ng-template matStepLabel>{{ retrieveStepTitle(i) | translate }}</ng-template>\n\n      <!-- Render container -->\n      <ng-template stepRenderContainer></ng-template>\n\n      <!-- Actions -->\n      <div class=\"stepper-actions\">\n        <sp-button *ngIf=\"i !== 0\"\n                   [id]=\"'stepper-btn-prev-' + i\"\n                   [label]=\"'UI_LIB.BUTTON.PREV' | translate\"\n                   (click)=\"previous()\">\n        </sp-button>\n        <sp-button *ngIf=\"i !== steps.length - 1\"\n                   class=\"stepper-actions--next\"\n                   [id]=\"'stepper-btn-next-' + i\"\n                   [label]=\"'UI_LIB.BUTTON.NEXT' | translate\"\n                   [flagDisabled]=\"retrieveFormControl(i) && retrieveFormControl(i).invalid\"\n                   (click)=\"next()\">\n        </sp-button>\n      </div>\n    </mat-step>\n  </div>\n</mat-horizontal-stepper>\n",
        styles: [":host .stepper-actions{display:flex;justify-content:space-between;margin-top:24px}:host .stepper-actions sp-button{flex:1}:host .stepper-actions--next{display:flex;justify-content:flex-end}"]
    })
], SpStepperComponent);

let Stepper = class Stepper {
};
Stepper = __decorate([
    Directive({
        selector: '[stepper]',
    })
], Stepper);

let SpStepperModule = class SpStepperModule {
};
SpStepperModule = __decorate([
    NgModule({
        declarations: [
            SpStepperComponent,
            Stepper,
            StepDirective
        ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatInputModule,
            SpButtonModule,
            TranslateModule,
            SpInputModule,
            MatFormFieldModule,
            MatStepperModule,
            SpButtonModule
        ],
        exports: [
            SpStepperComponent,
            Stepper
        ],
    })
], SpStepperModule);

let SpTabComponent = class SpTabComponent {
};
__decorate([
    Input()
], SpTabComponent.prototype, "id", void 0);
__decorate([
    Input()
], SpTabComponent.prototype, "label", void 0);
__decorate([
    Input()
], SpTabComponent.prototype, "flagDisabled", void 0);
__decorate([
    ViewChild(MatTab)
], SpTabComponent.prototype, "matTab", void 0);
SpTabComponent = __decorate([
    Component({
        selector: 'sp-tab',
        template: "<mat-tab [id]=\"id\"\n         [label]=\"label | translate\"\n         [disabled]=\"flagDisabled\">\n  <ng-content></ng-content>\n</mat-tab>\n"
    })
], SpTabComponent);

let SpTabGroupComponent = class SpTabGroupComponent {
    constructor() {
        /**
         * @description Event emitted when selectedIndex changes.
         */
        this.selectedIndexChange = new EventEmitter();
        /**
         * @description Event emitted when active tab changes.
         */
        this.selectedTabChange = new EventEmitter();
        this.selectedIndex = 0;
    }
    ngAfterViewInit() {
        const matTabsFromQueryList = this.tabs.map(tab => tab.matTab);
        const list = new QueryList();
        list.reset([matTabsFromQueryList]);
        this.tabGroup._allTabs = list;
        this.tabGroup.ngAfterContentInit();
        this.tabs.changes.subscribe(value => {
            const matTabsFromUpdatedQL = value.map(tab => tab.matTab);
            const updatedList = new QueryList();
            updatedList.reset([matTabsFromUpdatedQL]);
            this.tabGroup._allTabs = updatedList;
            this.tabGroup.ngAfterContentInit();
        });
        // FIXME: ExpressionChangedAfterItHasBeenCheckedError
        this.internalSelectedIndex = this.selectedIndex;
    }
    /**
     * @hidden
     * Emits the sqSelectedIndexChange event.
     */
    onSelectedIndexChange(event) {
        this.selectedIndexChange.emit(event);
    }
    /**
     * @hidden
     *  Emits the sqSelectedTabChange event.
     */
    onSelectedTabChange(event) {
        this.selectedTabChange.emit(event);
    }
};
__decorate([
    Input()
], SpTabGroupComponent.prototype, "id", void 0);
__decorate([
    Output()
], SpTabGroupComponent.prototype, "selectedIndexChange", void 0);
__decorate([
    Output()
], SpTabGroupComponent.prototype, "selectedTabChange", void 0);
__decorate([
    ViewChild(MatTabGroup)
], SpTabGroupComponent.prototype, "tabGroup", void 0);
__decorate([
    ContentChildren(SpTabComponent)
], SpTabGroupComponent.prototype, "tabs", void 0);
__decorate([
    Input()
], SpTabGroupComponent.prototype, "selectedIndex", void 0);
SpTabGroupComponent = __decorate([
    Component({
        selector: 'sp-tab-group',
        template: "<mat-tab-group #tabGroup\n               class=\"sp-tab-group\"\n               color=\"accent\"\n               [(selectedIndex)]=\"internalSelectedIndex\"\n               (selectedIndexChange)=\"onSelectedIndexChange($event)\"\n               (selectedTabChange)=\"onSelectedTabChange($event)\">\n  <ng-content #outlet></ng-content>\n</mat-tab-group>\n"
    })
], SpTabGroupComponent);

let SpTabGroupModule = class SpTabGroupModule {
};
SpTabGroupModule = __decorate([
    NgModule({
        declarations: [SpTabGroupComponent, SpTabComponent],
        imports: [CommonModule, TranslateModule, MatTabsModule],
        exports: [SpTabGroupComponent, SpTabComponent]
    })
], SpTabGroupModule);

let SpTooltipComponent = class SpTooltipComponent {
};
SpTooltipComponent = __decorate([
    Component({
        selector: 'sp-tooltip',
        template: "<p>sp-tooltip works!</p>\n"
    })
], SpTooltipComponent);

let SpTooltipModule = class SpTooltipModule {
};
SpTooltipModule = __decorate([
    NgModule({
        declarations: [SpTooltipComponent],
        imports: [],
        exports: [SpTooltipComponent]
    })
], SpTooltipModule);

// tslint:disable: incoherent-file-name-suffix

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractStepperClass, AttributeDirectivesModule, CustomDateAdapter, DialogEffects, EmptyPlaceholderPipe, NumericDirective, SnackbarEffects, SpBreadcrumbComponent, SpBreadcrumbModule, SpButtonComponent, SpButtonModule, SpCardComponent, SpCardExpirationPickerComponent, SpCardExpirationPickerModule, SpCardModule, SpCheckBoxComponent, SpCheckBoxModule, SpConcludeSellingPreviewComponent, SpConcludeSellingPreviewModule, SpContainerComponent, SpContainerModule, SpCountDownComponent, SpCountdownModule, SpCurrencyInputComponent, SpCurrencyInputModule, SpDatePickerComponent, SpDatePickerModule, SpDateRangePickerComponent, SpDateRangePickerModule, SpDecimalInputComponent, SpDecimalInputModule, SpDialogComponent, SpDialogModule, SpDividerComponent, SpDividerModule, SpEmptyPlaceholderModule, SpFileUploaderComponent, SpFileUploaderModule, SpForgotPasswordComponent, SpGatewayComponent, SpGatewayFormComponent, SpHelpChatComponent, SpHelpChatModule, SpIconComponent, SpIconModule, SpImageComponent, SpImageModule, SpInputComponent, SpInputModule, SpLabelValueComponent, SpLabelValueModule, SpLoaderComponent, SpLoaderModule, SpLoginComponent, SpLoginModule, SpMenuComponent, SpMenuModule, SpMerchantRegisteredComponent, SpMerchantRegisteredModule, SpMonthYearPickerComponent, SpMonthYearPickerModule, SpMultiSelectComponent, SpMultiSelectModule, SpNotificationListModule, SpNumberCounterComponent, SpNumberCounterModule, SpNumericInputComponent, SpNumericInputModule, SpOperationInProgressComponent, SpOperationInProgressModule, SpPaymentCongratsComponent, SpPaymentCongratsModule, SpPaymentKoComponent, SpPaymentKoModule, SpPosLoaderComponent, SpRadioButtonComponent, SpRadioButtonModule, SpRedirectMessageComponent, SpRedirectMessageModule, SpReportFilterFormComponent, SpSelectAllOptionsComponent, SpSelectComponent, SpSelectModule, SpSellPreviewComponent, SpSellPreviewModule, SpSharedModule, SpSnackBarTemplateComponent, SpSnackBarTemplateModule, SpStateDotComponent, SpStateDotModule, SpStatusLabelComponent, SpStatusLabelModule, SpStepperComponent, SpStepperModule, SpTabComponent, SpTabGroupComponent, SpTabGroupModule, SpTableComponent, SpTableModule, SpTextAreaComponent, SpTextAreaModule, SpToolbarComponent, SpToolbarModule, SpTooltipComponent, SpTooltipModule, StepDirective, addMonthsToDate, calculateLastRateValue, calculateRateValue, channelTypes, closeDialog, convertNumberForFilter, creditCardExpiresInMonths, creditCardTypes, dateMonthDifference, dateToDMY, dateToMDY, dateToYMD, downloadDocument, extendedDateMonth, firstDayOfMonth, formatAmount, gatewayStates, generateLocalUnits, lastDayOfMonth, maxDateValidator, minDateValidator, notificationStates, objectToQueryParams, openDialog, openDialogForSendEmail, openSnackbar, paymentInvoiceState, rateLabelById, retrieveCardData, retrieveNotificationTranslation, retrieveRouteId, retrieveRouteParam, retrieveRouteQueryParam, returnFirstDayNextMonth, returnNextMonthDate, returnServiceTypeNumber, returnServiceTypeString, returnTicketTypeById, returnTicketTypeByString, roundNumber, serviceTypes, ticketAreas, ticketStates, ɵ0, ɵ1, ɵ2, PayerInfoFormComponent as ɵa, InstallmentsNumberFormComponent as ɵb, MONTH_YEAR_PICKER_FORMATS as ɵc, SpPaginatorIntl as ɵd, SpAnimatedIconModule as ɵe, SpAnimatedIconComponent as ɵf, SpLocalUnitsSidenavModule as ɵg, LocalUnitsSidenavComponent as ɵh, CardExpirationDateAdapter as ɵi, CARD_EXPIRATION_PICKER_FORMATS as ɵj, ExpiredLinkComponent as ɵk, NewPasswordComponent as ɵl, PasswordChangedComponent as ɵm, SpNotificationsListComponent as ɵn, SpNotificationsComponent as ɵo, SpStatisticsComponent as ɵp, SpUserInfoComponent as ɵq, Stepper as ɵr };
//# sourceMappingURL=sp-ui-lib.js.map
